var _defs, _g, _path, _path2, _path3, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _path17, _path18, _path19, _path20, _path21, _path22, _g27, _path23, _path24, _g28, _path25, _path26, _path27, _g29, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g30, _path44, _path45, _path46, _path47, _path48, _g31, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _g32, _g33, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _image, _image2, _path89, _path90, _g34, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _g35, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _g36, _path172, _path173, _path174, _path175, _path176, _g37, _path177, _path178, _path179, _g38, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _g39, _path190, _g40, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _g50, _g51, _path213, _g52, _path214, _path215, _g53, _path216, _g54, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _g55, _g56, _path258, _path259, _path260, _g57, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _g58, _g59, _g60, _g61, _path482, _path483, _path484, _g62, _path485, _path486, _path487, _g63, _path488, _path489, _g64, _g65, _g66, _path490, _path491, _g67, _g68, _g69, _path492, _g70, _g71, _g72, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _g73, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _g74, _g75, _g76, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _g77, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _g78, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Group_432",
    "data-name": "Group 432",
    width: 634,
    height: 469.097,
    viewBox: "0 0 634 469.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 634,
    height: 469.097,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 633.999,
    height: 469.096,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 377.909,
    height: 210.816,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M1958.992,1385.358c0,6.47,4.542,14.338,10.146,17.578s10.15.612,10.15-5.859-4.548-14.342-10.15-17.575a9.216,9.216,0,0,0-4.532-1.385c-3.329,0-5.614,2.651-5.614,7.242",
    transform: "translate(-1958.992 -1378.116)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -18.348,
    y1: 3.725,
    x2: -18.338,
    y2: 3.725,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#438be3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M1958.992,1385.358c0,6.47,4.542,14.338,10.146,17.578s10.15.612,10.15-5.859a14.2,14.2,0,0,0-.083-1.445c-.051,5.423-3.894,7.611-8.625,4.877-4.769-2.757-8.632-9.449-8.632-14.951s3.863-7.737,8.632-4.986c.255.145.5.312.757.479a16.118,16.118,0,0,0-2.2-1.55,9.212,9.212,0,0,0-4.532-1.385c-3.328,0-5.614,2.651-5.614,7.242",
    transform: "translate(-1958.992 -1378.116)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -17.957,
    y1: 3.676,
    x2: -17.948,
    y2: 3.676,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M1958.992,1385.395c0,6.47,4.542,14.338,10.146,17.578,4.08,2.351,7.589,1.595,9.2-1.485-1.681,2.209-4.7,2.595-8.161.594-5.287-3.05-9.575-10.473-9.575-16.571,0-5.42,3.38-7.962,7.832-6.337a8.678,8.678,0,0,0-3.832-1.008c-3.323,0-5.607,2.645-5.607,7.229",
    transform: "translate(-1958.992 -1378.165)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -19.318,
    y1: 3.82,
    x2: -19.308,
    y2: 3.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M1975.776,1408.131a11.944,11.944,0,0,0,5.41,9.364c2.978,1.722,5.4.32,5.4-3.125a11.96,11.96,0,0,0-5.4-9.36,4.922,4.922,0,0,0-2.419-.738c-1.776,0-2.991,1.413-2.991,3.859",
    transform: "translate(-1975.776 -1404.272)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -46.489,
    y1: 7.488,
    x2: -46.465,
    y2: 7.488,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M1986.968,1424.255a4,4,0,0,0,1.8,3.13c1,.576,1.8.113,1.8-1.042a3.983,3.983,0,0,0-1.8-3.126,1.629,1.629,0,0,0-.805-.247c-.592,0-1,.472-1,1.285",
    transform: "translate(-1986.968 -1422.97)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -140.036,
    y1: 21.467,
    x2: -139.966,
    y2: 21.467,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M1202.069,950.3c0,6.468,4.544,14.338,10.147,17.575s10.145.612,10.145-5.859-4.536-14.34-10.145-17.574a9.2,9.2,0,0,0-4.53-1.385c-3.33,0-5.616,2.654-5.616,7.243",
    transform: "translate(-1202.069 -943.053)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -11.213,
    y1: 7.141,
    x2: -11.204,
    y2: 7.141,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M1202.069,950.3c0,6.468,4.544,14.338,10.147,17.575s10.145.612,10.145-5.859a13.717,13.717,0,0,0-.08-1.445c-.048,5.424-3.887,7.607-8.623,4.877-4.769-2.755-8.631-9.45-8.631-14.951s3.863-7.737,8.631-4.985c.254.147.5.311.759.478a16.075,16.075,0,0,0-2.2-1.548,9.2,9.2,0,0,0-4.53-1.385c-3.329,0-5.616,2.654-5.616,7.243",
    transform: "translate(-1202.069 -943.053)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -10.971,
    y1: 7.034,
    x2: -10.961,
    y2: 7.034,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M1202.069,950.325c0,6.468,4.544,14.338,10.147,17.575,4.078,2.356,7.589,1.594,9.2-1.483-1.682,2.2-4.7,2.59-8.169.592-5.285-3.049-9.569-10.466-9.564-16.573,0-5.412,3.374-7.96,7.823-6.335a8.671,8.671,0,0,0-3.831-1.009c-3.324,0-5.609,2.646-5.609,7.233",
    transform: "translate(-1202.069 -943.092)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -11.803,
    y1: 7.309,
    x2: -11.793,
    y2: 7.309,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M1218.859,973.062a11.955,11.955,0,0,0,5.405,9.364c2.987,1.722,5.409.326,5.409-3.124a11.95,11.95,0,0,0-5.409-9.362,4.9,4.9,0,0,0-2.413-.738c-1.774,0-2.992,1.413-2.992,3.859",
    transform: "translate(-1218.859 -969.203)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -28.668,
    y1: 14.892,
    x2: -28.645,
    y2: 14.892,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M1230.083,989.2a3.974,3.974,0,0,0,1.8,3.124c.995.578,1.8.113,1.8-1.038a3.976,3.976,0,0,0-1.8-3.124,1.631,1.631,0,0,0-.81-.251c-.589,0-.991.473-.991,1.289",
    transform: "translate(-1230.083 -987.908)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -86.889,
    y1: 43.644,
    x2: -86.818,
    y2: 43.644,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 292.435,
    height: 276.486,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 97.149,
    height: 84.964,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 357.638,
    height: 154.951,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 232.545,
    height: 133.341,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 232.543,
    height: 133.349,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 182.245,
    height: 144.464,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 182.787,
    height: 144.463,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 194.355,
    height: 120.407,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 231.881,
    height: 132.085,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 43.072,
    height: 45.528,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 55.192,
    height: 71.874,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 139.229,
    height: 80.214,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 44.026,
    height: 44.855,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M1877.083,796.1l19.17,27.84s2.2,2.615-.459,4.447-12.448,7.25-12.448,7.25-4.017,1.19-5.824-1.562-20.16-27.928-20.16-27.928l19.874,31.87s2.874,4.591,8.839,2.3a69.874,69.874,0,0,0,12.654-7.063s5.594-2.576.553-9.31-22.2-27.84-22.2-27.84",
    transform: "translate(-1857.362 -796.097)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -7.406,
    y1: 4.392,
    x2: -7.402,
    y2: 4.392,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 44.026,
    height: 44.852,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M2042.623,696.507l19.167,27.835s2.2,2.615-.451,4.449c-2.667,1.838-12.452,7.247-12.452,7.247s-4.019,1.2-5.827-1.557-20.16-27.924-20.16-27.924l19.878,31.869s2.866,4.583,8.834,2.294a69.421,69.421,0,0,0,12.653-7.066s5.6-2.572.554-9.311-22.2-27.835-22.2-27.835",
    transform: "translate(-2022.899 -696.507)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -8.077,
    y1: 4.798,
    x2: -8.073,
    y2: 4.798,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 30.845,
    height: 37.828,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 63.369,
    height: 53.849,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 61.68,
    height: 53.638,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M2198.023,1410.223l-9.552,5.835.941,2.771c3.536-.359,11.408-1.928,12.618-2.8s.505-2.84-.041-4.176c-.423-1.044-.771-1.833-2.327-1.833a8.194,8.194,0,0,0-1.64.2",
    transform: "translate(-2188.471 -1410.021)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -40.035,
    y1: 6.722,
    x2: -40.017,
    y2: 6.722,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003f97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#1959b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1959b1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 24.682,
    height: 20.335,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 42.413,
    height: 26.975,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 7.152,
    height: 90.136,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 235.344,
    height: 139.067,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 16.008,
    height: 17.425,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M409.856,943.052l-10.376,5.989v2.318l16.345,9.555V958.6l10.376-5.99a6.068,6.068,0,0,1,3.158-.819l11.369,1.249a2.118,2.118,0,0,1,.631.179l-15.985-9.363a2.332,2.332,0,0,0-.991-.372l-11.372-1.248a2.611,2.611,0,0,0-.276-.014,6.416,6.416,0,0,0-2.878.834",
    transform: "translate(-399.48 -942.218)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -2.752,
    y1: 5.336,
    x2: -2.746,
    y2: 5.336,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eca600"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 69.719,
    height: 53.543,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M567.065,662.468l.684.393-.688-.4,0,.005m-29.34-137.092c-6.795,8.632-19.152,49.642-21.189,59.666s-8.9,36.234-4.138,44.972a4.768,4.768,0,0,0,1.437,1.631l53.225,30.818a8.473,8.473,0,0,1-.933-1.348c-4.757-8.737,2.1-34.949,4.138-44.973s14.392-51.033,21.188-59.663c2.125-2.7,6.755-6.394,12.138-9.888l-53.73-31.1c-5.387,3.495-10.013,7.193-12.136,9.888",
    transform: "translate(-510.751 -515.488)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -0.495,
    y1: 2.172,
    x2: -0.493,
    y2: 2.172,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6dcf7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 46.307,
    height: 61.232,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 7.786,
    height: 8.274,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M767.2,922.642c-.182,0-.277-.152-.293-.447l-.1-1.812a2.667,2.667,0,0,1,1.106-2.066l5.829-3.782a.9.9,0,0,1,.454-.167c.177,0,.275.152.292.449l.1,1.809a2.687,2.687,0,0,1-1.106,2.069l-5.832,3.781a.912.912,0,0,1-.452.166",
    transform: "translate(-766.807 -914.368)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -18.063,
    y1: 21.811,
    x2: -18.039,
    y2: 21.811,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M663.581,964.056c-.2,1.323-1.01,4.363.2,4.991l4.3,2.636.005,0c-1-.791-.258-3.625-.068-4.893.229-1.514,12.189-8.773,12.189-8.773l-4.443-2.731s-11.959,7.26-12.186,8.773",
    transform: "translate(-663.13 -955.283)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -7.44,
    y1: 10.024,
    x2: -7.429,
    y2: 10.024,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3273cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00267e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M473.453,859.881c-.2,1.326-1.009,4.366.2,4.993l4.3,2.638.009-.008c-1-.786-.263-3.625-.068-4.894.227-1.513,12.188-8.773,12.188-8.773l-4.443-2.728s-11.962,7.259-12.187,8.772",
    transform: "translate(-473.003 -851.109)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -5.269,
    y1: 11.182,
    x2: -5.258,
    y2: 11.182,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b686c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#313a3d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M474.838,425.586a2.4,2.4,0,0,0-1.09,1.886.756.756,0,0,0,.323.706L514.6,452.616a.755.755,0,0,0,.767-.075,2.412,2.412,0,0,0,1.09-1.889.763.763,0,0,0-.323-.706L475.6,425.5a.564.564,0,0,0-.279-.069.976.976,0,0,0-.489.152",
    transform: "translate(-473.748 -425.434)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -2.653,
    y1: 7.357,
    x2: -2.647,
    y2: 7.357,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00267e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#00267e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3273cb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M369,1120.824a1.166,1.166,0,0,1-.576,1l-32.835,20.39-18.763,11.236c-.512.388-.449.618,0,.878l4.22,2.5a1.608,1.608,0,0,0,1.6.03l19.162-11.046,33.958-19.614a1.154,1.154,0,0,0,.578-1l0-26.9L369,1093.922Z",
    transform: "translate(-316.468 -1093.922)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -0.808,
    y1: 2.398,
    x2: -0.805,
    y2: 2.398,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#485255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b686c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M261.994,1058.595a1.151,1.151,0,0,1-.576,1l-32.835,20.392-18.759,11.237c-.512.385-.449.615,0,.877l4.215,2.5a1.626,1.626,0,0,0,1.6.029L234.8,1083.59l33.959-19.617a1.151,1.151,0,0,0,.573-.995v-26.9l-7.341-4.381Z",
    transform: "translate(-209.463 -1031.695)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -0.486,
    y1: 2.588,
    x2: -0.483,
    y2: 2.588,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 41.362,
    height: 27.886,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 37.963,
    height: 20.994,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 39.805,
    height: 32.585,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 13.994,
    height: 19.206,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 16.005,
    height: 17.429,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M628.384,1072.227l-10.378,5.991v2.316l16.349,9.556v-2.318l10.374-5.988a6.016,6.016,0,0,1,3.156-.821l11.37,1.248a2.083,2.083,0,0,1,.629.179L652.9,1078.3c-.363.034-.725.055-1.078.06a7.412,7.412,0,0,1-4.1-.985l-8.934-5.169-7.25-.795a2.559,2.559,0,0,0-.286-.015,6.415,6.415,0,0,0-2.87.834",
    transform: "translate(-618.006 -1071.393)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -4.305,
    y1: 4.603,
    x2: -4.298,
    y2: 4.603,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 16.349,
    height: 11.871,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 156.266,
    height: 90.201,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M1006.007,105.543l0,267.3,134.005,77.368,0-267.3a17.068,17.068,0,0,0-.129-1.986L1006.131,103.7a14.381,14.381,0,0,0-.125,1.842",
    transform: "translate(-1006.005 -103.701)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -1.033,
    y1: 1.232,
    x2: -1.032,
    y2: 1.232,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2693d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#238ac9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#1b74b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#0e5095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002770"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M1006.3,376.462l133.934,77.321,0-272.755L1006.3,103.7Z",
    transform: "translate(-1006.301 -103.701)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 111.411,
    height: 274.811,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 28.851,
    height: 51.669,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 28.851,
    height: 51.67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 202.169,
    height: 107.661,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 49.53,
    height: 122.796,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 48.706,
    height: 121.97,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 48.085,
    height: 121.352,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 39.964,
    height: 23.77,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 39.138,
    height: 22.946,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 38.519,
    height: 22.324,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 39.964,
    height: 23.771,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 39.14,
    height: 22.942,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-84"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 38.519,
    height: 22.326,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 19.793,
    height: 14.651,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 48.706,
    height: 121.969,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 48.086,
    height: 121.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 42.708,
    height: 22.79,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 42.711,
    height: 22.788,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(256.091 186.515)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M1008.967,779.26c-2.751,1.3-2.842,3.614-.2,5.132l271.322,155.835a27.936,27.936,0,0,0,10.34,3.088l13.112.775a30.774,30.774,0,0,0,10.718-1.632l19.35-7.327a77.846,77.846,0,0,0,9.96-4.787l24.745-14.615a45.889,45.889,0,0,0,8.545-6.879l4.938-5.325a12.739,12.739,0,0,0,2.842-9.532l-.872-5.115a13.036,13.036,0,0,0-5.776-8.146L1113.717,734.506a12.171,12.171,0,0,0-9.858-.306Z",
    transform: "translate(-1006.843 -733.303)",
    fill: "#438be3"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M1941.559,1333.327l6.865-3.835c2,1.094,4.086,2.264,6.174,3.277,8.155,3.965,13.2,11.416,15.688,16.151,1.9,3.617,5.464,14.2,7.049,19.005-.057.035-.114.08-.167.114l-12.674,7.024c-2.961,1.258-6.818.82-11.049-1.617-9.311-5.374-16.853-18.441-16.853-29.195,0-5.394,1.9-9.175,4.966-10.923",
    transform: "translate(-1444.019 -991.335)",
    fill: "#003f97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M1936.593,1352.242c0,10.754,7.542,23.822,16.853,29.195s16.859,1.019,16.859-9.73-7.547-23.819-16.859-29.2-16.853-1.018-16.853,9.731",
    transform: "translate(-1444.019 -999.326)",
    fill: "#1959b1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M1940.112,1362.348c0,9.758,6.848,21.625,15.3,26.5s15.3.925,15.3-8.839-6.859-21.622-15.3-26.5-15.3-.928-15.3,8.835",
    transform: "translate(-1446.643 -1007.688)",
    fill: "#003f97"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(498.271 350.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 26.975,
    height: 32.416,
    transform: "translate(-7.136 1.95) rotate(-15.287)",
    fill: "url(#linear-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(498.271 350.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 27.546,
    height: 32.967,
    transform: "matrix(0.958, -0.286, 0.286, 0.958, -7.758, 2.016)",
    fill: "url(#linear-gradient-2)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(498.271 350.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 25.631,
    height: 31.706,
    transform: "translate(-6.677 1.094) rotate(-14.369)",
    fill: "url(#linear-gradient-3)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(502.54 357.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 10.81,
    height: 14.945,
    transform: "translate(0)",
    fill: "url(#linear-gradient-4)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(505.387 361.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 3.609,
    height: 4.991,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M1999.823,1421.689a1.7,1.7,0,0,0,.764,1.324c.419.242.764.042.764-.443a1.7,1.7,0,0,0-.764-1.322c-.42-.242-.764-.042-.764.441",
    transform: "translate(-1491.167 -1059.676)",
    fill: "#001971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M1984.5,1412.567a1.682,1.682,0,0,0,.759,1.317c.425.245.765.046.765-.439a1.681,1.681,0,0,0-.765-1.321c-.417-.24-.759-.045-.759.443",
    transform: "translate(-1479.741 -1052.874)",
    fill: "#001971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M1979.393,1426.98a1.668,1.668,0,0,0,.762,1.318c.42.246.764.045.764-.44a1.691,1.691,0,0,0-.764-1.319c-.424-.245-.762-.047-.762.44",
    transform: "translate(-1475.933 -1063.621)",
    fill: "#001971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M1991.616,1444.51a1.673,1.673,0,0,0,.764,1.32c.419.245.765.046.765-.443a1.688,1.688,0,0,0-.765-1.316c-.425-.246-.764-.045-.764.44",
    transform: "translate(-1485.047 -1076.692)",
    fill: "#001971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M2003.846,1441.033a1.682,1.682,0,0,0,.761,1.318c.421.245.766.047.766-.435a1.7,1.7,0,0,0-.766-1.326c-.42-.241-.761-.045-.761.444",
    transform: "translate(-1494.166 -1074.098)",
    fill: "#001971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M1995.3,1392.867a1.174,1.174,0,1,0,1.624-.8,1.291,1.291,0,0,0-1.624.8",
    transform: "translate(-1487.682 -1037.933)",
    fill: "#001971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M1979.516,1391.093c-.062.769.245,1.421.69,1.457s.855-.562.916-1.33-.247-1.417-.693-1.452-.857.557-.913,1.324",
    transform: "translate(-1476.018 -1036.279)",
    fill: "#001971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M2012.226,1408.158a1.3,1.3,0,1,0,1.87.357,1.344,1.344,0,0,0-1.87-.357",
    transform: "translate(-1499.907 -1049.823)",
    fill: "#001971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M2022.75,1431.716a1.192,1.192,0,1,0,1.485,1.057,1.3,1.3,0,0,0-1.485-1.057",
    transform: "translate(-1507.294 -1067.554)",
    fill: "#001971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M2022.7,1452.208a1.249,1.249,0,0,0-1.616.571c-.152.534.319,1.133,1.061,1.349s1.465-.042,1.615-.571-.315-1.134-1.06-1.349",
    transform: "translate(-1506.998 -1082.782)",
    fill: "#001971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M2010.153,1462.755c-.474-.406-.985-.587-1.145-.4s.1.661.57,1.069.991.584,1.147.4-.1-.663-.572-1.066",
    transform: "translate(-1497.981 -1090.35)",
    fill: "#001971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M1922.764,1315.9c2.2-3.583,7.271-1.015,13.085,2.159l-6.865,3.835c-3.068,1.749-4.966,5.529-4.966,10.923,0,.151.008.3.008.443l-4.131,1.413c-.5-10.244.043-14.153,2.87-18.774",
    transform: "translate(-1431.443 -979.904)",
    fill: "#001971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M1184.651,900.844l5.283-2.95a22.613,22.613,0,0,1,6.046,2.778c10.806,6.811,18.76,13.7,19.448,36.076l.06.037,1.249.716-9.156,5.08c-2.956,1.26-6.818.823-11.048-1.617-9.306-5.375-16.853-18.444-16.851-29.195,0-5.391,1.9-9.172,4.968-10.926",
    transform: "translate(-879.63 -669.515)",
    fill: "#003f97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M1179.683,917.172c0,10.751,7.544,23.82,16.851,29.195s16.855,1.019,16.855-9.73-7.543-23.819-16.855-29.2-16.851-1.018-16.851,9.731",
    transform: "translate(-879.63 -674.917)",
    fill: "#1959b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M1183.2,927.278c0,9.758,6.851,21.622,15.3,26.506s15.3.924,15.3-8.838-6.852-21.624-15.3-26.5-15.3-.927-15.3,8.831",
    transform: "translate(-882.249 -683.28)",
    fill: "#003f97"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(305.747 239.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 26.969,
    height: 32.406,
    transform: "matrix(0.965, -0.264, 0.264, 0.965, -7.133, 1.95)",
    fill: "url(#linear-gradient-6)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(305.747 239.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 27.54,
    height: 32.958,
    transform: "translate(-7.756 2.014) rotate(-16.589)",
    fill: "url(#linear-gradient-7)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(305.747 239.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 25.638,
    height: 31.713,
    transform: "matrix(0.969, -0.248, 0.248, 0.969, -6.678, 1.095)",
    fill: "url(#linear-gradient-8)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(310.018 246.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 10.814,
    height: 14.945,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-9)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(312.873 251.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 3.601,
    height: 4.991,
    fill: "url(#linear-gradient-10)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    clipPath: "url(#clip-path-2)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M1242.918,986.623a1.679,1.679,0,0,0,.763,1.321c.422.244.762.049.762-.44a1.68,1.68,0,0,0-.762-1.32c-.419-.243-.763-.05-.763.439",
    transform: "translate(-926.781 -735.27)",
    fill: "#001971"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M1227.593,977.5a1.686,1.686,0,0,0,.761,1.323c.42.241.763.042.763-.443a1.693,1.693,0,0,0-.763-1.319c-.422-.246-.761-.045-.761.439",
    transform: "translate(-915.354 -728.465)",
    fill: "#001971"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M1222.45,991.922a1.676,1.676,0,0,0,.767,1.316c.423.246.766.047.766-.439a1.684,1.684,0,0,0-.766-1.319c-.422-.245-.767-.044-.767.441",
    transform: "translate(-911.519 -739.219)",
    fill: "#001971"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M1234.686,1009.444a1.682,1.682,0,0,0,.766,1.318c.42.242.76.045.76-.443a1.685,1.685,0,0,0-.76-1.316c-.421-.244-.766-.048-.766.441",
    transform: "translate(-920.643 -752.284)",
    fill: "#001971"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M1246.945,1005.972a1.692,1.692,0,0,0,.759,1.322c.423.243.763.047.763-.437a1.672,1.672,0,0,0-.763-1.322c-.42-.247-.759-.048-.759.437",
    transform: "translate(-929.783 -749.698)",
    fill: "#001971"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M1238.382,957.8a1.174,1.174,0,1,0,1.631-.8,1.291,1.291,0,0,0-1.631.8",
    transform: "translate(-923.289 -713.521)",
    fill: "#001971"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M1222.6,956.027c-.058.769.25,1.418.693,1.456s.853-.561.914-1.33-.245-1.417-.693-1.451-.853.556-.914,1.324",
    transform: "translate(-911.624 -711.873)",
    fill: "#001971"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M1255.316,973.093a1.3,1.3,0,1,0,1.873.359,1.346,1.346,0,0,0-1.873-.359",
    transform: "translate(-935.52 -725.419)",
    fill: "#001971"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M1265.844,996.644a1.192,1.192,0,1,0,1.483,1.063,1.3,1.3,0,0,0-1.483-1.063",
    transform: "translate(-942.909 -743.143)",
    fill: "#001971"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M1265.78,1017.135a1.243,1.243,0,0,0-1.616.575c-.156.53.324,1.13,1.065,1.346a1.253,1.253,0,0,0,1.618-.57c.151-.532-.327-1.132-1.067-1.35",
    transform: "translate(-942.601 -758.37)",
    fill: "#001971"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M1253.237,1027.686c-.472-.4-.989-.582-1.146-.4s.1.663.574,1.067.983.584,1.141.4-.1-.667-.57-1.07",
    transform: "translate(-933.587 -765.943)",
    fill: "#001971"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M1171.808,901.517c.928-3.082,4.906-7.024,11.9-5.106l-5.287,2.95c-2.817,1.6-4.641,4.931-4.926,9.629l-1.844.279s-.015-.028-.036-.061a19.729,19.729,0,0,1,.191-7.691",
    transform: "translate(-873.402 -668.032)",
    fill: "#001971"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M1007.61,358.058l.217-30.318s4.607-36.75,5.865-47.637,3.872-11.187,7.063-13.1c17.44-10.415,68.525-40.927,68.525-40.927l2.482-1.381c2.491-1.393,6.245-.117,6.245-.117l180.485,104.27c10.6,6.178,13.79,8.774,16.872,13.146,6.573,9.31,24.326,34.522,24.326,34.522s34.762,54.635,37.859,59.934,13.121,23.3,13.121,23.3c2.04,2.118,6.114,9.537,7.007,17.6s1.549,18.825-1.873,27.381-12.14,14.829-26.888,23.712-32.43,17.7-44.675,18.583-20.489-3.131-20.489-3.131l-.315-.159c-1.57-4.759-5.17-15.453-7.083-19.1-2.486-4.735-7.533-12.186-15.688-16.151s-16.31-10.252-19.259-5.436c-2.838,4.622-3.375,8.537-2.866,18.816l-.047-.021-152.548-87.522-.06-.037c-.688-22.375-8.642-29.264-19.448-36.076-10.773-6.8-16.781-1.555-17.945,2.328a20.224,20.224,0,0,0-.142,8.02c-7.481-4.422-35.111-20.865-38.04-24.069-3.39-3.712-4.136-16.692-4.343-20.881s1.64-5.559,1.64-5.559",
    transform: "translate(-750.088 -167.063)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(255.864 103.551)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M1010.313,521c-3.39-3.712-4.136-16.692-4.343-20.881s1.64-5.559,1.64-5.559l.217-30.318s4.607-36.75,5.865-47.637c.493-4.282,1.2-6.92,2.066-8.671,0,0,1.278-2.6,7.919,1.469s179.7,104.008,179.7,104.008,10.115,6.56,18.569,20.376,17.391,31.054,17.391,31.054l27.549,48.266s10.775,15.571,13.644,19.65,14.259,6.815,14.259,6.815,4.348,27.766,3.489,44.029a40.737,40.737,0,0,1-14.522-3.194l-.315-.159c-1.57-4.759-5.17-15.453-7.083-19.1-2.486-4.735-7.533-12.186-15.688-16.151s-16.31-10.252-19.259-5.436c-2.838,4.623-3.375,8.537-2.866,18.816l-.047-.021-152.548-87.522-.06-.037c-.688-22.375-8.642-29.264-19.448-36.076-10.773-6.8-16.781-1.555-17.945,2.328a20.224,20.224,0,0,0-.142,8.02c-7.481-4.422-35.111-20.865-38.04-24.069",
    transform: "translate(-1005.952 -407.119)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(531.158 277.618)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M2101.833,1149.87a58.925,58.925,0,0,1-6.7-2.12l-.725-2.52a22.575,22.575,0,0,1-4.083.2,12.013,12.013,0,0,1-2.028-1.546c.728-1.563,4.992-4.609,17.138-10.377a329.448,329.448,0,0,0,57.544-34.793,22.438,22.438,0,0,0,6.306-7.236c3.91,6.944,8.435,15.076,8.435,15.076,2.04,2.118,6.114,9.537,7.007,17.6a95.513,95.513,0,0,1,.686,13.43,342.055,342.055,0,0,1-39.928,28.321c-24.183,14.636-35.752,11.074-40.907,6.734-1.065-12.035-2.741-22.775-2.741-22.775",
    transform: "translate(-2088.292 -1091.481)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 44.257,
    height: 21.62,
    transform: "translate(481.74 322.081)",
    opacity: 0.5,
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 0.254,
    height: 0.763,
    transform: "translate(481.74 343.447)",
    opacity: 0.5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAADCAYAAABS3WWCAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAAaADAAQAAAABAAAAAwAAAACgKuykAAAAEklEQVQIHWP4//+/ABMDEIAJACe2AxJOxIpIAAAAAElFTkSuQmCC",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(264.115 187.479)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M1038.39,737.09l208.483,119.666s48.162,25.59,52.886,27.871,12.633,6.031,23.306,4.319,27.138-10.022,39.526-17.516,24.15-16.067,28.841-21.2a19.644,19.644,0,0,0,4.063-7.165c.17.222.344.466.534.734a20.392,20.392,0,0,1-4.6,9.093c-4.691,5.134-16.455,13.695-28.841,21.192s-28.849,15.811-39.526,17.523-18.578-2.041-23.306-4.318-52.886-27.872-52.886-27.872L1041.358,740.769Z",
    transform: "translate(-1038.39 -737.09)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(285.074 68.137)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M1353.817,267.887a.757.757,0,0,0,.222.176l168.711,97.772a1.952,1.952,0,0,0,1.635.064l2.282-1.072a.654.654,0,0,0,.253-.185c.19.235.1.5-.253.676l-2.282,1.079a2,2,0,0,1-1.635-.07l-168.711-97.767c-.33-.194-.4-.459-.222-.671",
    transform: "translate(-1294.473 -267.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M1328.557,282.835a.825.825,0,0,0,.224.185l168.71,97.769a1.988,1.988,0,0,0,1.634.063l2.281-1.074a.883.883,0,0,0,.255-.185c.189.23.1.505-.255.673l-2.281,1.083a2.015,2.015,0,0,1-1.634-.07l-168.71-97.769c-.341-.2-.407-.461-.224-.674",
    transform: "translate(-1275.638 -279.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M1303.742,298.248a.6.6,0,0,0,.22.185L1472.673,396.2a2,2,0,0,0,1.64.069l2.276-1.077a.768.768,0,0,0,.255-.189c.188.235.1.507-.255.679l-2.276,1.077a2,2,0,0,1-1.64-.069l-168.711-97.764c-.33-.2-.407-.461-.22-.68",
    transform: "translate(-1257.133 -290.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M1277.907,313.148a.769.769,0,0,0,.22.184L1446.839,411.1a1.975,1.975,0,0,0,1.632.073l2.283-1.075a.781.781,0,0,0,.255-.19c.187.231.1.5-.255.676l-2.283,1.077a1.963,1.963,0,0,1-1.632-.073l-168.712-97.763c-.336-.191-.408-.462-.22-.676",
    transform: "translate(-1237.868 -301.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M1252.268,328.047a.691.691,0,0,0,.222.183L1421.2,426a1.993,1.993,0,0,0,1.633.072l2.278-1.078a.75.75,0,0,0,.255-.186c.191.233.106.505-.255.678l-2.278,1.077a1.974,1.974,0,0,1-1.633-.076L1252.49,328.724c-.334-.191-.4-.461-.222-.677",
    transform: "translate(-1218.753 -312.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M1225.826,343.756a.925.925,0,0,0,.222.187l168.716,97.765a1.974,1.974,0,0,0,1.632.066l2.279-1.075a.808.808,0,0,0,.257-.18c.19.229.1.5-.257.671l-2.279,1.079a1.983,1.983,0,0,1-1.632-.068l-168.716-97.769c-.333-.193-.4-.462-.222-.676",
    transform: "translate(-1199.037 -324.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M1200.785,358.688a.677.677,0,0,0,.224.176l168.711,97.768a1.983,1.983,0,0,0,1.639.072l2.276-1.076a.815.815,0,0,0,.255-.187c.189.234.1.507-.255.677l-2.276,1.076a1.976,1.976,0,0,1-1.639-.07l-168.711-97.764c-.335-.193-.4-.461-.224-.671",
    transform: "translate(-1180.367 -335.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M1173.9,374.619a.745.745,0,0,0,.222.191l168.711,97.764a1.969,1.969,0,0,0,1.631.065l2.281-1.076a.85.85,0,0,0,.256-.182c.191.229.1.5-.256.675l-2.281,1.074a1.942,1.942,0,0,1-1.631-.069L1174.12,375.295c-.334-.193-.406-.46-.222-.676",
    transform: "translate(-1160.316 -347.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M1147.314,389.6a.761.761,0,0,0,.214.182l168.715,97.769a1.964,1.964,0,0,0,1.636.063l2.276-1.074a.782.782,0,0,0,.259-.184c.188.232.1.5-.259.675l-2.276,1.078a1.989,1.989,0,0,1-1.636-.071l-168.715-97.769c-.332-.189-.4-.459-.214-.669",
    transform: "translate(-1140.492 -358.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M1120.89,404.274a.84.84,0,0,0,.218.18l168.716,97.768a1.982,1.982,0,0,0,1.635.07l2.275-1.076a.865.865,0,0,0,.258-.186c.185.234.107.507-.258.676l-2.275,1.077a1.991,1.991,0,0,1-1.635-.069l-168.716-97.767c-.33-.191-.4-.465-.218-.673",
    transform: "translate(-1120.791 -369.585)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(285.076 66.235)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M1526.93,359.069a.769.769,0,0,0-.219-.181L1358,261.121a1.965,1.965,0,0,0-1.631-.071l-2.28,1.079a.839.839,0,0,0-.26.186c-.183-.233-.1-.509.26-.68l2.28-1.074a1.965,1.965,0,0,1,1.631.064L1526.711,358.4c.334.192.4.459.219.671",
    transform: "translate(-1294.485 -260.413)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M1501.668,374.028a.757.757,0,0,0-.222-.183L1332.74,276.075a1.987,1.987,0,0,0-1.639-.065l-2.282,1.074a.789.789,0,0,0-.255.186c-.188-.235-.1-.506.255-.679l2.282-1.076a1.984,1.984,0,0,1,1.639.074l168.706,97.765c.336.194.406.457.222.675",
    transform: "translate(-1275.647 -271.566)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M1476.853,389.448a.881.881,0,0,0-.218-.181L1307.925,291.5a1.972,1.972,0,0,0-1.636-.071l-2.283,1.078a.828.828,0,0,0-.254.183c-.187-.231-.1-.506.254-.673l2.283-1.076a1.968,1.968,0,0,1,1.636.069l168.71,97.769c.329.19.4.46.218.669",
    transform: "translate(-1257.145 -283.067)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M1451.022,404.352a.788.788,0,0,0-.223-.184L1282.087,306.4a1.983,1.983,0,0,0-1.633-.063l-2.278,1.071a.826.826,0,0,0-.256.186c-.19-.232-.1-.508.256-.672l2.278-1.08a1.987,1.987,0,0,1,1.633.069L1450.8,403.678c.336.2.4.462.223.674",
    transform: "translate(-1237.884 -294.179)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M1425.372,419.26a.845.845,0,0,0-.219-.186L1256.44,321.31a1.978,1.978,0,0,0-1.633-.07l-2.281,1.076a.9.9,0,0,0-.255.185c-.189-.228-.1-.5.255-.672l2.281-1.075a1.968,1.968,0,0,1,1.633.069l168.714,97.768c.334.19.4.46.219.671",
    transform: "translate(-1218.758 -305.297)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M1398.94,434.966a.724.724,0,0,0-.217-.185L1230,337.016a1.952,1.952,0,0,0-1.632-.072l-2.279,1.078a.831.831,0,0,0-.258.181c-.186-.229-.1-.5.258-.677l2.279-1.075a2,2,0,0,1,1.632.065l168.719,97.769c.33.193.4.462.217.68",
    transform: "translate(-1199.049 -317.004)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M1373.89,449.865a.707.707,0,0,0-.218-.18l-168.715-97.768a1.942,1.942,0,0,0-1.634-.07l-2.282,1.079a.691.691,0,0,0-.255.186c-.186-.235-.1-.507.255-.679l2.282-1.081a1.976,1.976,0,0,1,1.634.075l168.715,97.759c.333.2.4.465.218.679",
    transform: "translate(-1180.37 -328.115)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M1347,465.831a.958.958,0,0,0-.219-.185l-168.716-97.769a2.018,2.018,0,0,0-1.634-.069l-2.278,1.081a.912.912,0,0,0-.255.18c-.189-.228-.108-.5.255-.669l2.278-1.082a1.988,1.988,0,0,1,1.634.07l168.716,97.767c.329.194.406.463.219.677",
    transform: "translate(-1160.319 -340.019)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M1320.423,480.788a.724.724,0,0,0-.22-.183l-168.718-97.768a1.947,1.947,0,0,0-1.629-.073l-2.282,1.078a.67.67,0,0,0-.252.189c-.191-.233-.106-.508.252-.675l2.282-1.078a1.981,1.981,0,0,1,1.629.064L1320.2,480.117c.334.186.4.457.22.672",
    transform: "translate(-1140.502 -351.173)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M1294,495.462a.814.814,0,0,0-.219-.184l-168.711-97.769a1.992,1.992,0,0,0-1.636-.066l-2.285,1.074a.776.776,0,0,0-.25.19c-.188-.238-.105-.509.25-.674l2.285-1.085a2,2,0,0,1,1.636.074l168.711,97.769c.333.189.4.457.219.671",
    transform: "translate(-1120.797 -362.114)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(267.572 133.475)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M1231.718,668.646l1.607-37.614a3.349,3.349,0,0,0-1.527-2.761L1052.682,525.534a1.468,1.468,0,0,0-.7-.2,1.063,1.063,0,0,1,1.6-.35L1232.7,627.716a3.332,3.332,0,0,1,1.524,2.763l-1.6,37.61c-.034.752-.463,1.177-1.042,1.141a1.549,1.549,0,0,0,.137-.585",
    transform: "translate(-1051.983 -524.768)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(265.354 133.477)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M1045.322,525.914c.063-.779.55-1.2,1.179-1.12a1.828,1.828,0,0,0-.089.412l-2.05,37.15a3.145,3.145,0,0,0,1.448,2.752l179.713,103.211a1.68,1.68,0,0,0,.523.193c-.208.707-.865.955-1.614.523L1044.716,565.821a3.151,3.151,0,0,1-1.449-2.757Z",
    transform: "translate(-1043.259 -524.783)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(272.283 113.971)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M1070.5,448.938l49.663,28.752,49.733,28.618,49.745,28.616,24.87,14.31,6.216,3.577a28.333,28.333,0,0,1,5.478,4.383,55.507,55.507,0,0,1,8.65,11.3,43.222,43.222,0,0,0-7.986-11.953,30.705,30.705,0,0,0-2.641-2.495,18.208,18.208,0,0,0-2.978-2.144l-6.216-3.583-24.848-14.345-49.71-28.67-49.706-28.678-49.786-28.54Z",
    transform: "translate(-1070.497 -448.089)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(264.115 191.157)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M1246.873,870.2s11.239,5.973,23.4,12.4l0,.008-5.331,1.027L1038.39,753.35l2.968-1.8Z",
    transform: "translate(-1038.39 -751.552)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(298.979 219.475)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 43.24,
    height: 45.783,
    transform: "translate(-0.117 -0.152)",
    xlinkHref: "data:image/png;base64,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"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(457.318 247.332)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M1798.893,972.419c.012-.028.074-.005.156.056a7.418,7.418,0,0,0-.145,2.02c.214,4.856.842,24.888,3.947,31.453,4.76,10.081,18.479,20.441,37.38,28.792l9.286,4.714a3.426,3.426,0,0,0,.91.124c.989,0,2.371-.468,1.93-3.184.633,2.275,1.422,6.093.093,7.429-1.945,1.959-9.179-2.772-15.788-6.538s-30.728-14.716-35.622-28.147-2.544-36.093-2.148-36.719",
    transform: "translate(-1797.983 -972.407)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(341.883 267.329)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M1344.465,1051.028l138.9,79.649-.324.565-138.906-79.65Z",
    transform: "translate(-1344.14 -1051.028)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 44.257,
    height: 45.274,
    transform: "translate(472.329 202.282)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(472.421 202.488)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 62.727,
    height: 62.521,
    transform: "matrix(0.896, -0.444, 0.444, 0.896, -18.5, 9.165)",
    fill: "url(#linear-gradient-11)"
  }))))))), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 44.257,
    height: 45.02,
    transform: "translate(514.297 177.101)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(514.526 177.157)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 62.728,
    height: 62.518,
    transform: "matrix(0.896, -0.444, 0.444, 0.896, -18.498, 9.164)",
    fill: "url(#linear-gradient-12)"
  }))))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M1803.46,966.035a2.15,2.15,0,0,1,.805.16s11.145,5.975,16.39,9.315,9.349,9.354,9.349,9.354,22.647,39.109,24.608,45.125c1.366,4.2-.353,4.838-1.519,4.838a3.425,3.425,0,0,1-.91-.124l-9.286-4.714c-18.9-8.351-32.62-18.711-37.38-28.793-3.1-6.565-3.733-26.6-3.947-31.453-.142-3.154,1.046-3.709,1.89-3.709",
    transform: "translate(-1343.331 -720.324)",
    fill: "#003f97"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M1893.706,1026.181a41.315,41.315,0,0,1,3.631,4.407c3.392,5.856,8.161,14.193,12.593,22.126v19.575a127.357,127.357,0,0,1-14.936-8.063Z",
    transform: "translate(-1412.04 -765.172)",
    fill: "#2971c9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M1808.237,972.454a.69.69,0,0,1,.137.018c1.133.609,11.308,6.1,16.178,9.2a23.894,23.894,0,0,1,3.187,2.469l1.318,38.713c-8.535-5.719-14.557-11.769-17.295-17.564-2.764-5.85-3.5-23.82-3.746-29.722l-.047-1.11a3.5,3.5,0,0,1,.269-2",
    transform: "translate(-1348.103 -725.11)",
    fill: "#2971c9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M1937.27,877.9c3.806-1.852,32.682-17.966,42.884-24.7s29.1-18.55,29.1-18.55a3.193,3.193,0,0,1,1.882-.65c.989,0,2.236.522,3.409,2.516,2.479,4.213,28.374,45.292,28.374,45.292s-1.869,7.118-10.262,13.96-29.37,21.182-47.129,29.308c-9.148,4.178-15.307,5.1-18.956,5.1a11.65,11.65,0,0,1-4.159-.561l-27.6-47.075s-1.367-2.8,2.449-4.643",
    transform: "translate(-1442.52 -621.877)",
    fill: "#003f97"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M1942.715,884.141c4.035-1.958,32.9-18.1,43.072-24.8,10.071-6.64,28.882-18.413,29.071-18.536l.127-.076.057-.051a1.587,1.587,0,0,1,.836-.276c.822,0,1.543.932,2.005,1.716,2.318,3.946,22.986,37.122,26.424,42.567-.668,1.817-4.052,6.271-10.477,11.511-8.677,7.063-28.879,20.308-46.12,28.193-8.948,4.1-14.708,5.829-18.1,5.829a12.724,12.724,0,0,1-3.58-.812l-25.008-42.823c-.167-.451-.267-1.495,1.7-2.446",
    transform: "translate(-1447.258 -626.649)",
    fill: "#2971c9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M2067.127,1065.238c17.759-8.126,38.724-22.461,47.129-29.308s10.262-13.96,10.262-13.96,3.67,7.646,0,13.012-22.031,17.51-29.364,22.13-30.48,16.2-36.017,17.007-14.128-2.639-15.126-4.344c0,0,6.822,2.91,23.115-4.536",
    transform: "translate(-1524.116 -762.031)",
    fill: "#1959b1"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(552.872 213.758)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M2227.537,841.455c.632-.4,1-.627,1.023-.645l.127-.076.057-.051a1.589,1.589,0,0,1,.836-.276c.822,0,1.542.932,2.005,1.716,1.13,1.925,6.628,10.8,12.365,20.026l.725,15.881s.384,1.732-10.042-4.837Z",
    transform: "translate(-2213.834 -840.408)",
    fill: "#c5d0d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M2185.4,849.394l6.415,28.8c-.1-.061-.19-.12-.283-.185-9.952-6.5-15.558-16.363-17.866-21.205,4.626-2.939,8.983-5.685,11.734-7.411",
    transform: "translate(-2173.663 -847.109)",
    fill: "#c5d0d3"
  }))))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M2088.109,997.863c-8.676,7.063-28.878,20.308-46.12,28.193-8.948,4.1-14.708,5.829-18.1,5.829a12.73,12.73,0,0,1-3.58-.812l-6.574-11.26c6.862-5.735,21.259-17.183,36.141-25.468a388.952,388.952,0,0,1,35.281-17.6l13.432,9.6c-.668,1.817-4.052,6.271-10.477,11.511",
    transform: "translate(-1501.538 -728.312)",
    fill: "#367ed6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M2173.664,990.65c1.249-3.867,9.788-12.311,14.075-14.456,5.153-2.581,9.287.128,11.472,1.936s8.768,11.74,8.768,11.74c2.76,4.053-12.053,10.494-16.5,9.552-1.824-.383-7.3.3-9.769-1.312Z",
    transform: "translate(-1620.791 -727.108)",
    fill: "#367ed6"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(533.679 213.758)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M2103.046,859.345c10.071-6.64,28.882-18.413,29.071-18.536l.127-.076.057-.051a1.587,1.587,0,0,1,.836-.276c.822,0,1.542.932,2.006,1.716,2.318,3.946,22.986,37.122,26.424,42.567-.589,1.59-3.249,5.195-8.2,9.568-9.743-10.362-27.347-24.543-55.174-31.853,1.873-1.144,3.525-2.186,4.851-3.059",
    transform: "translate(-2098.197 -840.407)",
    fill: "#fff"
  }))))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M2046.794,1200.353c4.774,2.3,12.493,5.733,22.805,4.082,10.677-1.712,27.138-10.022,39.525-17.523s24.15-16.058,28.842-21.192a20.439,20.439,0,0,0,4.6-9.093,38.384,38.384,0,0,1,5.835,16.109c.9,8.067,1.55,18.824-1.873,27.381s-12.14,14.829-26.888,23.712-32.43,17.7-44.675,18.583-20.489-3.13-20.489-3.13l-.315-.159c-1.57-4.759-5.17-15.453-7.083-19.1a42.353,42.353,0,0,0-7.5-10.247l3.545-6.253.552-.971Z",
    transform: "translate(-1520.81 -862.439)",
    fill: "#003f97"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M2054.17,1202.553l3.12-2.2c4.774,2.3,12.493,5.733,22.805,4.082,10.677-1.712,27.138-10.022,39.525-17.523s24.15-16.058,28.841-21.192a20.434,20.434,0,0,0,4.6-9.093,35.622,35.622,0,0,1,3.66,7.291c-.618,11.623-11.114,16.965-11.114,16.965s-9.062,6.131-18.694,11.964c-8.333,5.046-17.094,9.748-20.768,11.559-7.918,3.9-11.818,5.851-25.044,6.936-11.26.925-23.928-5.85-27.447-7.887Z",
    transform: "translate(-1531.306 -862.439)",
    fill: "#1959b1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M2228.225,1222.619c10.15-6.144,19.884-13,25.644-18.1,1.588,1.473,4.985,4.854,5.809,7.457,1.091,3.423,1.307,17.278,1.307,17.278-3.953,3.395-9.683,7.232-21.017,14.329a201.484,201.484,0,0,1-27.478,14.574L2206.228,1244l-6.923-6.877c9.354-3.489,20.154-9.2,28.92-14.508",
    transform: "translate(-1639.91 -898.146)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(559.394 306.369)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M2228.225,1222.619c10.15-6.144,19.884-13,25.644-18.1,1.588,1.473,4.985,4.854,5.809,7.457,1.091,3.423,1.307,17.278,1.307,17.278-3.953,3.395-9.683,7.232-21.017,14.329a201.484,201.484,0,0,1-27.478,14.574L2206.228,1244l-6.923-6.877c9.354-3.489,20.154-9.2,28.92-14.508",
    transform: "translate(-2199.303 -1204.515)",
    fill: "#438be3"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M2255.385,1279.993c3.675-1.8,12.436-6.51,20.773-11.557,9.629-5.833,18.692-11.967,18.692-11.967,2.64-1.571,2.621,2.427,2.621,2.427l.249,10.394c-3.859,2.855-9.33,6.307-18.02,11.965a214.947,214.947,0,0,1-22.238,12.13l-3.376-8.685s-1.741-3.212,1.3-4.708",
    transform: "translate(-1680.388 -936.613)",
    fill: "#1959b1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M2256.935,1292.491l-2.848-7.329s-1.741-3.212,1.3-4.708c3.675-1.8,12.436-6.51,20.773-11.557,9.629-5.833,18.692-11.967,18.692-11.967a2.848,2.848,0,0,1,.423-.209,5.341,5.341,0,0,1,.375,1.9l.25,10.393c-3.865,2.851-9.332,6.307-18.026,11.964a206.9,206.9,0,0,1-20.937,11.507",
    transform: "translate(-1680.388 -937.075)",
    fill: "#00004c"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M2408.657,1273.356c-.3.21-.612.43-.933.652l-.919-12.284c.349-.23.663-.437.938-.62Z",
    transform: "translate(-1794.632 -940.342)",
    fill: "#000d65"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M2390.065,1285.716l-.926.6-1.157-12.2c.316-.206.625-.405.923-.6Z",
    transform: "translate(-1780.598 -949.601)",
    fill: "#000d65"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M2366.418,1300.969c-.294.193-.6.391-.908.594l-1.593-12c.306-.19.608-.377.912-.572Z",
    transform: "translate(-1762.653 -961.136)",
    fill: "#000d65"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M2340.345,1317.3c-.061.039-.115.08-.184.123-.226.145-.459.3-.695.443l-2.339-11.738c.3-.177.591-.358.886-.537Z",
    transform: "translate(-1742.677 -973.512)",
    fill: "#000d65"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M2267.951,1357.906c-.3.148-.594.3-.884.445l-3.716-10.972c.274-.141.57-.287.882-.448Z",
    transform: "translate(-1687.666 -1004.338)",
    fill: "#000d65"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M2289.553,1346.526c-.292.154-.585.31-.879.459l-3.462-11.165c.287-.154.575-.312.881-.474Z",
    transform: "translate(-1703.967 -995.7)",
    fill: "#000d65"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M2314.523,1332.6c-.292.173-.584.343-.877.513l-2.934-11.512c.3-.165.593-.335.889-.5Z",
    transform: "translate(-1722.98 -985.073)",
    fill: "#000d65"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M1483.421,1083.838l-.466,5.821a1.56,1.56,0,0,1-2.154,1.5l-129.091-74.207-2.42-10.367Z",
    transform: "translate(-1006.096 -750.56)",
    fill: "#1959b1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M1049.987,779.3l3.8,8.964a8.135,8.135,0,0,0-5.3,5.146,20.224,20.224,0,0,0-.142,8.02c-7.481-4.422-35.111-20.865-38.04-24.069-3.39-3.712-4.136-16.692-4.343-20.881s1.64-5.559,1.64-5.559l1.769,5.283Z",
    transform: "translate(-750.088 -559.921)",
    fill: "#1959b1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M2253.869,1204.515c1.587,1.473,4.984,4.854,5.808,7.458.024.082.048.17.071.264a22.877,22.877,0,0,1-5.539,4.354s-9.062,6.131-18.693,11.964c-8.334,5.046-17.094,9.748-20.768,11.559a85.492,85.492,0,0,1-8.552,3.863l-6.892-6.85c9.355-3.489,20.155-9.2,28.92-14.508,10.149-6.143,19.883-13,25.645-18.1",
    transform: "translate(-1639.909 -898.146)",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M2263.517,1318.936a213.888,213.888,0,0,0,21.375-11.794c1.824-1.186,3.514-2.282,5.086-3.3,5.979-3.876,10.082-6.535,13.255-8.824l.024,1.181c-3.105,2.217-7.091,4.8-12.751,8.461-1.565,1.023-3.253,2.113-5.07,3.3a215.3,215.3,0,0,1-21.564,11.894Z",
    transform: "translate(-1687.79 -965.631)",
    fill: "#003f97"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M2300.715,1286c-3.141,2.245-7.163,4.849-12.922,8.58-1.567,1.021-3.251,2.114-5.079,3.3a218.26,218.26,0,0,1-22.173,12.2l-.358-.919a214.712,214.712,0,0,0,22-12.1c1.823-1.182,3.505-2.276,5.08-3.293,6.088-3.943,10.231-6.627,13.426-8.943Z",
    transform: "translate(-1685.304 -958.026)",
    fill: "#003f97"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M2298.02,1275.306c-3.147,2.248-7.173,4.859-12.951,8.6q-2.349,1.521-5.079,3.294a221.817,221.817,0,0,1-22.975,12.582l-.362-.913a219.637,219.637,0,0,0,22.809-12.486c1.816-1.188,3.505-2.279,5.077-3.3,6.106-3.956,10.25-6.647,13.453-8.97Z",
    transform: "translate(-1682.671 -950.048)",
    fill: "#003f97"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M2282.487,1272.349c-1.564,1.017-3.256,2.109-5.079,3.3a237.24,237.24,0,0,1-23.627,12.937,4.459,4.459,0,0,1-.176-1,234.94,234.94,0,0,0,23.27-12.754c1.828-1.183,3.513-2.281,5.081-3.3,6.25-4.051,10.441-6.764,13.68-9.128.024.273.024.46.024.46l.012.718c-3.174,2.286-7.257,4.935-13.184,8.769",
    transform: "translate(-1680.399 -941.31)",
    fill: "#003f97"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(556.639 358.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 13.914,
    height: 17.046,
    transform: "matrix(0.394, -0.919, 0.919, 0.394, -3.189, 7.441)",
    fill: "url(#linear-gradient-13)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    clipPath: "url(#clip-path-2)"
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M2130.64,1430.5a84.432,84.432,0,0,1-15.084-1.034c-3.892-.73-5.014-3.053-5.014-3.053s.293,2.425,4.1,3.3a60.447,60.447,0,0,0,16.664,1.336c3.536-.358,11.407-1.927,12.617-2.8a94.529,94.529,0,0,1-13.282,2.249",
    transform: "translate(-1573.724 -1063.606)",
    fill: "#1959b1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M2153.526,1452.362l-11.367-.32s-2.2.134-1.38,1.689,1.605,2.89,2.794,3.35,5.961.825,11.554.276,18.434-6.093,22.146-7.975l-.091-1.655s-13.8,6.375-20.539,7.476c0,0-.643-2.937-3.116-2.842",
    transform: "translate(-1596.133 -1079.498)",
    fill: "#1959b1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M2169.5,1454.892a25.9,25.9,0,0,1-4.674-2.722l6.767.193c2.473-.1,3.117,2.842,3.117,2.842,6.741-1.1,20.539-7.476,20.539-7.476l.091,1.655c-3.466,1.753-14.883,6.705-20.94,7.8-1.167-.6-3.152-1.573-4.9-2.292",
    transform: "translate(-1614.204 -1079.498)",
    fill: "#000d65"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M2141.5,1465.189a2.4,2.4,0,0,1,1.334-.5l4.58.127a3.117,3.117,0,0,1-2.97,3.151,3.083,3.083,0,0,1-2.943-2.779",
    transform: "translate(-1596.807 -1092.146)",
    fill: "#f0eff0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M2185.112,1412.645a79.511,79.511,0,0,0,10.406-1.882l.084-.017c.161.8.383,2.277-.115,2.628-.685.487-9.457,3.286-9.457,3.286Z",
    transform: "translate(-1629.327 -1051.922)",
    fill: "#000d65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(586.408 343.645)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M2306.426,1364.7l22.345-13.466a1.06,1.06,0,0,1,.535-.163.793.793,0,0,1,.772.883l.116,4.347a2.078,2.078,0,0,1-.931,1.685l-22.236,13.262a1.017,1.017,0,0,1-.525.159.828.828,0,0,1-.8-.875l-.184-4.132a2.048,2.048,0,0,1,.911-1.7",
    transform: "translate(-2305.513 -1351.071)",
    fill: "#438be3"
  }))))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M2308.678,1367.173l22.349-13.471a.408.408,0,0,1,.2-.063c.1,0,.121.172.127.247l.1,4.345a1.405,1.405,0,0,1-.612,1.109L2308.61,1372.6a.392.392,0,0,1-.19.066c-.123,0-.141-.158-.147-.252l-.185-4.136a1.4,1.4,0,0,1,.59-1.107",
    transform: "translate(-1721.024 -1009.341)",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M2310.538,1314.259v-1.785c-3.813,2.836-9.145,6.312-17.592,11.6a221.8,221.8,0,0,1-22.59,12.391v1.844c.084,1.678,1.781.8,1.781.8a223.419,223.419,0,0,0,20.809-11.533c7.535-4.727,12.6-8,16.306-10.669a3.254,3.254,0,0,0,1.286-2.651",
    transform: "translate(-1692.889 -978.646)",
    fill: "#1959b1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M2308.771,1317.5v.026a3.24,3.24,0,0,1-1.279,2.649c-3.709,2.665-8.764,5.942-16.309,10.665a224.521,224.521,0,0,1-20.785,11.53,1.518,1.518,0,0,1-.042-.309v-1.845a221.7,221.7,0,0,0,22.59-12.391c7.225-4.526,12.162-7.722,15.825-10.326",
    transform: "translate(-1692.889 -982.394)",
    fill: "#00004c"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M2394.68,1335.52c-.317.214-.642.423-.971.644v-1.87c.329-.213.655-.426.971-.629Z",
    transform: "translate(-1784.867 -994.447)",
    fill: "#003f97"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M2412.17,1323.755c-.317.218-.636.445-.97.679v-1.8c.329-.225.654-.444.97-.66Z",
    transform: "translate(-1797.909 -985.726)",
    fill: "#003f97"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M2373.227,1349.341c-.321.2-.64.406-.97.61v-1.9c.33-.208.652-.415.97-.613Z",
    transform: "translate(-1768.871 -1004.719)",
    fill: "#003f97"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M2349.347,1364.336c-.324.208-.648.4-.97.6V1363l.97-.589Z",
    transform: "translate(-1751.065 -1015.882)",
    fill: "#003f97"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M2326.145,1378.138c-.324.193-.655.379-.971.565v-2.01c.316-.179.647-.368.971-.554Z",
    transform: "translate(-1733.764 -1026.118)",
    fill: "#003f97"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M2301.908,1391.592c-.324.171-.646.35-.966.523v-2.086c.321-.164.642-.337.966-.511Z",
    transform: "translate(-1715.696 -1036.094)",
    fill: "#003f97"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M2282.181,1401.8c-.328.172-.653.339-.969.5v-2.144c.315-.152.636-.315.969-.478Z",
    transform: "translate(-1700.984 -1043.67)",
    fill: "#003f97"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M2144.611,1464.787a2.809,2.809,0,0,1,.542-.1l3.874.106a2.208,2.208,0,0,1-4.417-.009",
    transform: "translate(-1599.128 -1092.146)",
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M2336.369,1321.4c.591,1.807,2.271,2.526,3.746,1.6a4.453,4.453,0,0,0,1.6-4.95c-.594-1.81-2.272-2.526-3.744-1.6a4.45,4.45,0,0,0-1.6,4.954",
    transform: "translate(-1741.956 -981.308)",
    fill: "#1959b1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M2338.041,1322.666a2.131,2.131,0,0,0,3.238,1.379,3.835,3.835,0,0,0,1.375-4.277,2.126,2.126,0,0,0-3.232-1.381,3.837,3.837,0,0,0-1.381,4.28",
    transform: "translate(-1743.224 -982.793)",
    fill: "#d2d5d7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M2449.681,1259.342l-.282-5.032a2.326,2.326,0,0,1,.8-1.409c.641-.606,2.962-4.781,4.33-8.683a73.152,73.152,0,0,1,.012,9.653l-3.831,5.847s-1.074,1.41-1.028-.377",
    transform: "translate(-1826.392 -927.751)",
    fill: "#000d65"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M1899.457,1173.521s.484-5.714-.891-7.83-3.151-2.794-5.963-2.383-8.43,2.08-8.77,5.045-.345,12.222-.345,12.222a4.1,4.1,0,0,0,2.742,3.433c2.669,1.093,9.8,1.093,9.8,1.093s3.525-.228,3.514-3.505-.086-8.074-.086-8.074",
    transform: "translate(-1404.421 -867.335)",
    fill: "#003f97"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M1894.686,1163.308c2.813-.411,4.59.272,5.963,2.383a5.08,5.08,0,0,1,.605,1.566c-2.782.937-6.662,2.2-8.215,2.495a7.673,7.673,0,0,1-6.758-2.458c1.355-2.308,5.955-3.629,8.4-3.985",
    transform: "translate(-1406.504 -867.335)",
    fill: "#1959b1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M1928.067,1160.133s-3.361,6.22-5.691,7.427-8.979,2.168-8.979,2.168v11.448h5.479a6.875,6.875,0,0,0,5.693-2.521c.894-1.315,3.5-5.5,3.5-5.5l.36-3.223s-3.513,6.58-5.634,8.02-8.026,1.3-8.026,1.3v-7.742s5.485-.8,7.54-1.417,5.71-6.362,5.71-6.362Z",
    transform: "translate(-1426.723 -865.053)",
    fill: "#000d65"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M1943.908,1161.372v0a42.329,42.329,0,0,0,3.766-4.74l3.144.892s-3.361,6.22-5.691,7.427a5.363,5.363,0,0,1-.563.253,11.917,11.917,0,0,0-.656-3.828",
    transform: "translate(-1449.473 -862.44)",
    fill: "#1959b1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M1883.694,1192.083a10.724,10.724,0,0,0,4.226,3.016l-.115,7.144a19.279,19.279,0,0,1-4.3-1.62c.01-2.069.053-5.85.186-8.54",
    transform: "translate(-1404.436 -888.876)",
    fill: "#c5ccd0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M1946.352,1204.288c-.026-3.187-.081-7.176-.081-7.176s.033-.385.055-.99l.032-.024c.166-.041.322-.086.462-.128a4.753,4.753,0,0,0,1.638-1.137l4.482.976s-3.513,6.58-5.634,8.02a4.547,4.547,0,0,1-.948.464Z",
    transform: "translate(-1451.235 -890.927)",
    fill: "#1959b1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M2344.757,921.067v-17.3s.386-4.035,1.1-5.132,2.13-1.365,4.366,0,4.149,3.117,4.205,8.141a77.013,77.013,0,0,1-.549,9.611s-1.633,4.588-2.62,5.351-5.624.72-5.624.72Z",
    transform: "translate(-1748.366 -669.378)",
    fill: "#003f97"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M2345.636,937.483l-.879-1.391v-17.3s.038-.374.109-.931c1.72.214,4.481,1.244,4.727,3.444.3,2.661.617,11.788.452,15.878a28.725,28.725,0,0,1-4.408.3",
    transform: "translate(-1748.366 -684.403)",
    fill: "#000d65"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M2349.911,906.28c-.245-2.2-3.008-3.231-4.727-3.445v.007a14.233,14.233,0,0,1,.993-4.207c.7-1.095,2.129-1.365,4.366,0a7.757,7.757,0,0,1,3.381,3.578,25.229,25.229,0,0,1-3.956,4.6c-.018-.2-.034-.378-.056-.535",
    transform: "translate(-1748.685 -669.378)",
    fill: "#1959b1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M2332.156,940.123c-.6.609-3.276,1.1-4.97,1.353-.51-.81-1.033-1.64-1.568-2.484,1.621-.143,4.833-.584,6.152-1.822l-.208-7.159-10.206,2.238c-.393-.617-.778-1.232-1.172-1.854l11.585-2.716,3.513-4.2a35.038,35.038,0,0,1,0,11.453,39.234,39.234,0,0,1-3.127,5.187",
    transform: "translate(-1730.044 -688.595)",
    fill: "#003f97"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M2323.126,936.868l5.012.861-11.263,2.647-1.128-1.774Z",
    transform: "translate(-1726.735 -698.576)",
    fill: "#1959b1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M2340.545,976.748l5.335.139s-.958,1.239-6.152,1.822l-.62-.98Z",
    transform: "translate(-1744.155 -728.312)",
    fill: "#1959b1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M1794.008,1136.8s2.287,1.147,2.412-1.184.384-4.708.384-5.808-.042-3.138-1.143-3.854-3.268-2.037-3.268-2.037-1.354-1.062-1.695,1.695a40.07,40.07,0,0,0,.295,8.35c.172,1.016,1.442,1.912,3.015,2.838",
    transform: "translate(-1335.143 -837.897)",
    fill: "#1959b1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M1794.291,1139.507s2,1.112,2.374,1.272,1.006-.181,1.119-2.246.434-5.449,0-6.206a8.861,8.861,0,0,0-3.094-2.175c-.69-.276-1.51-.622-1.531,1.259s.158,5.267.158,6.046a2.388,2.388,0,0,0,.974,2.051",
    transform: "translate(-1337.066 -842.534)",
    fill: "#1959b1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M1793.159,1131.41c.022-1.88.841-1.535,1.531-1.259a8.86,8.86,0,0,1,3.094,2.175,1.074,1.074,0,0,1,.09.236,11.966,11.966,0,0,0-2.461-1.505c-.688-.276-1.508-.617-1.535,1.26s.159,5.266.159,6.045a3.094,3.094,0,0,0,.222,1.122,2.4,2.4,0,0,1-.942-2.029c0-.779-.184-4.168-.158-6.046",
    transform: "translate(-1337.066 -842.534)",
    fill: "#003f97"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M1801.6,1142.173s.02-4.6.1-6.64a5.174,5.174,0,0,1,.65-2.774l.414.5a9.669,9.669,0,0,0-.579,2.3v6.355Z",
    transform: "translate(-1343.364 -844.642)",
    fill: "#003f97"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M1798.55,1140.552s.02-4.6.1-6.64a5.173,5.173,0,0,1,.65-2.774l-1-.553a14.957,14.957,0,0,0-.79,2.653l.027,6.755Z",
    transform: "translate(-1340.31 -843.021)",
    fill: "#1959b1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(553.445 285.654)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M2246.073,1177.376l3.332,3.466-.24.219-3.323-3.46Z",
    transform: "translate(-2228.054 -1163.564)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M2265.642,1166.181l3.323,3.461-.234.222-3.322-3.458Z",
    transform: "translate(-2242.645 -1155.217)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M2270.591,1163.239l3.319,3.457-.233.23-3.322-3.462Z",
    transform: "translate(-2246.334 -1153.023)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M2275.065,1160.53l3.323,3.464-.241.222-3.314-3.465Z",
    transform: "translate(-2249.671 -1151.003)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M2279.646,1157.7l3.321,3.461-.232.226-3.323-3.459Z",
    transform: "translate(-2253.086 -1148.891)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M2283.649,1154.648l3.323,3.459-.238.227-3.318-3.461Z",
    transform: "translate(-2256.072 -1146.617)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M2288.1,1151.4l3.319,3.459-.237.23-3.323-3.466Z",
    transform: "translate(-2259.388 -1144.194)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M2292.708,1148.538l3.317,3.459-.231.228-3.317-3.466Z",
    transform: "translate(-2262.827 -1142.061)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M2297.729,1145.4l3.319,3.461-.232.226-3.321-3.463Z",
    transform: "translate(-2266.57 -1139.719)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M2302.094,1142.6l3.316,3.461-.232.221-3.318-3.459Z",
    transform: "translate(-2269.824 -1137.634)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M2306.391,1139.345l3.322,3.462-.234.227-3.323-3.459Z",
    transform: "translate(-2273.029 -1135.207)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 0.325,
    height: 4.799,
    transform: "translate(34.413 3.575) rotate(-43.831)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M2315.872,1133.5l3.322,3.462-.236.227-3.321-3.459Z",
    transform: "translate(-2280.097 -1130.847)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M2319.454,1129.863l3.322,3.463-.237.222-3.319-3.459Z",
    transform: "translate(-2282.769 -1128.136)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M2324.5,1126.705l3.321,3.461-.239.224-3.318-3.461Z",
    transform: "translate(-2286.534 -1125.781)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M2328.929,1123.073l3.316,3.454-.229.228-3.323-3.458Z",
    transform: "translate(-2289.833 -1123.073)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M2241.3,1180.475l3.327,3.468-.24.22-3.322-3.464Z",
    transform: "translate(-2224.493 -1165.875)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 0.323,
    height: 4.797,
    transform: "translate(15.446 15.491) rotate(-43.803)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M2231.408,1185.82l3.322,3.462-.235.222-3.321-3.459Z",
    transform: "translate(-2217.117 -1169.86)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M2227.05,1188.252l3.323,3.455-.235.232-3.32-3.466Z",
    transform: "translate(-2213.869 -1171.673)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M2221.805,1191l3.325,3.458-.239.228-3.318-3.466Z",
    transform: "translate(-2209.959 -1173.725)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M2216.73,1194.108l3.324,3.46-.236.224-3.323-3.464Z",
    transform: "translate(-2206.172 -1176.04)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M2211.525,1196.709l3.324,3.458-.238.227-3.317-3.462Z",
    transform: "translate(-2202.294 -1177.979)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M2206.205,1199.433l3.32,3.463-.229.221-3.317-3.463Z",
    transform: "translate(-2198.33 -1180.011)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M2201.282,1201.836l3.318,3.467-.229.222-3.324-3.457Z",
    transform: "translate(-2194.653 -1181.802)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M2196.239,1204.062l3.321,3.462-.235.225-3.318-3.461Z",
    transform: "translate(-2190.896 -1183.463)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M2191.554,1207.067l3.321,3.458-.24.226-3.318-3.461Z",
    transform: "translate(-2187.398 -1185.703)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M2186.034,1209.749l3.323,3.459-.24.225-3.318-3.463Z",
    transform: "translate(-2183.283 -1187.703)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M2180.976,1212.155l3.321,3.467-.24.221-3.32-3.458Z",
    transform: "translate(-2179.509 -1189.497)",
    fill: "#438be3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M2176.142,1214.638l3.322,3.46-.237.225-3.32-3.461Z",
    transform: "translate(-2175.908 -1191.349)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(451.976 241.442)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M1783.52,1039.387l.612-.218c-2.1-5.982-6.152-27.723-6.465-45.291-.324-18.026,1.8-44.308,1.826-44.573l-.655-.054c-.018.271-2.149,26.582-1.823,44.636.328,18.394,4.467,39.708,6.505,45.5",
    transform: "translate(-1776.981 -949.251)",
    fill: "#438be3"
  }))))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M2381.769,1074.455a6.8,6.8,0,0,0,3.257-4.646c.414-2.388-.352-5.7-.857-7.89l-.5-2.157,1.1,1.921c3.567,6.235,10.262,18.254,11.573,20.6l.057.1-.026.11a16.2,16.2,0,0,1-6.44,10.01l-.415.268-.088-.488c-1.042-5.879-7.732-17.264-7.8-17.377l-.178-.3Z",
    transform: "translate(-1775.731 -790.211)",
    fill: "#003f97"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M2388.324,1078.457a17.361,17.361,0,0,0-.4-6.043c.108.2.092-.464.071-1.2,3.371,5.931,8.811,15.675,10.616,18.918a2.194,2.194,0,0,0-.245.906,15.8,15.8,0,0,1-5.739,9.168c-1.218-5.617-6.571-15.018-7.611-16.806a7.409,7.409,0,0,0,3.306-4.944",
    transform: "translate(-1778.387 -798.751)",
    fill: "#e3e3e4"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M2055.008,1229.306l.276-.25.212.3a20.652,20.652,0,0,0,8.289,6.429,16.7,16.7,0,0,0,6.156.946,45.305,45.305,0,0,0,8.67-.961l.209-.046.124.169c.065.088,6.828,8.924,10.381,15.95l.16.325-.337.13c-.087.031-8.687,3.314-15.835,3.314a19.756,19.756,0,0,1-3.021-.222c-5.77-.945-8.905-5.291-10.592-7.623-.3-.415-.558-.776-.77-1.021-3.006-3.558-6.587-8.423-6.563-11.439a8.94,8.94,0,0,1,2.641-6",
    transform: "translate(-1530.346 -916.445)",
    fill: "#003f97"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M2057.112,1232.955a21.122,21.122,0,0,0,8.338,6.345,17.476,17.476,0,0,0,6.4.989,46.417,46.417,0,0,0,8.61-.931,125.828,125.828,0,0,1,10.02,15.362c-1.65.6-9.028,3.148-15.258,3.148a18.083,18.083,0,0,1-2.918-.213c-5.5-.9-8.544-5.1-10.173-7.363-.307-.426-.571-.792-.79-1.055-4.157-4.908-6.429-8.821-6.414-11.011a8.278,8.278,0,0,1,2.179-5.27",
    transform: "translate(-1532.259 -919.353)",
    fill: "#e3e3e4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M2065.477,1256.073c0,1.262.881,1.772,1.97,1.143a4.384,4.384,0,0,0,1.976-3.42c0-1.257-.89-1.765-1.976-1.137a4.361,4.361,0,0,0-1.97,3.413",
    transform: "translate(-1540.121 -933.845)",
    fill: "#b61678"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M2085.464,1273.088c0,2.466,1.727,3.462,3.858,2.232a8.539,8.539,0,0,0,3.867-6.689c0-2.465-1.728-3.466-3.867-2.234a8.539,8.539,0,0,0-3.858,6.691",
    transform: "translate(-1555.025 -943.896)",
    fill: "#fff"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M2121.007,1280.594c0,3.332,2.341,4.678,5.219,3.015a11.544,11.544,0,0,0,5.22-9.041c0-3.328-2.34-4.679-5.22-3.015a11.554,11.554,0,0,0-5.219,9.041",
    transform: "translate(-1581.527 -947.602)",
    fill: "#fff"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M2397.534,1128.233a10.069,10.069,0,0,1,2.471-4.074c1.837-1.612,3.332-.3,3.336,2.909a14.009,14.009,0,0,1-2.671,8.026c-.886-2.286-2.043-4.724-3.136-6.861",
    transform: "translate(-1787.719 -837.714)",
    fill: "#fff"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M2394.246,1103.671a6.933,6.933,0,0,1,1.628-2.416c1.462-1.276,2.645-.243,2.645,2.312a10.557,10.557,0,0,1-.282,2.326c-1.13-.625-2.688-1.49-3.991-2.221",
    transform: "translate(-1785.268 -820.742)",
    fill: "#fff"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 13.735,
    height: 29.25,
    transform: "translate(606.627 272.228)",
    xlinkHref: "data:image/png;base64,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"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 35.863,
    height: 25.181,
    transform: "translate(522.437 313.433)",
    xlinkHref: "data:image/png;base64,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"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M1014.239,674.237l-1.769-5.282.2-27.959,3.142,9.091V675.13Z",
    transform: "translate(-754.947 -477.959)",
    fill: "#b61678"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M1012.659,685.289l1.552,1.727v13.691l-1.642-2.212Z",
    transform: "translate(-755.022 -510.986)",
    fill: "#e3e3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(50.643 217.084)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M432.388,900.964,352.219,854.68a11.123,11.123,0,0,0-10.03,0L239.911,913.735c-2.757,1.591-2.757,4.2,0,5.788l15.73,9.084-.6.345,5.819,3.361-2.445,1.411,1.495.863L257.63,935.9l-38.091,22L199.485,970.1c-.645.391-.354.782.059,1.02l2.817,1.626a1.635,1.635,0,0,0,1.676,0l21.153-11.587,38.1-21.993,2.274-1.315,28.256,16.316-2.274,1.313-38.1,21.995L233.4,989.679c-.649.392-.356.781.056,1.02l2.817,1.623a1.634,1.634,0,0,0,1.677,0L259.1,980.737l38.093-21.99,2.275-1.317.918.528,2.443-1.412,5.817,3.36.6-.348,10.825,6.25a11.134,11.134,0,0,0,10.03,0l102.282-59.055c2.752-1.591,2.752-4.2,0-5.79",
    transform: "translate(-199.107 -853.486)",
    fill: "#438be3"
  }))))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M987.8,960.537l-9.989-5.824c-2.035-1.154-4.835-.978-7.932.809-6.215,3.588-11.254,12.314-11.254,19.493,0,3.611,1.275,6.142,3.334,7.31l9.99,5.819c2.038,1.153,4.835.972,7.924-.81,6.213-3.591,11.255-12.317,11.255-19.5,0-3.6-1.272-6.134-3.328-7.3",
    transform: "translate(-714.797 -711.338)",
    fill: "#003f97"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M1020.414,984.9c0,7.179-5.042,15.905-11.255,19.5-3.089,1.782-5.885,1.963-7.924.81-2.058-1.166-3.333-3.7-3.333-7.307,0-7.18,5.039-15.905,11.257-19.5,3.092-1.784,5.892-1.96,7.927-.8,2.057,1.167,3.328,3.7,3.328,7.3",
    transform: "translate(-744.085 -728.4)",
    fill: "#b8bfc3"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M1020.352,984.749c0,7.2-5.052,15.952-11.285,19.551s-11.288.682-11.288-6.517,5.055-15.949,11.288-19.548,11.285-.684,11.285,6.514",
    transform: "translate(-743.992 -728.271)",
    fill: "#1959b1"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M1025.368,996.081c0,5.542-3.89,12.28-8.688,15.052s-8.692.524-8.692-5.02,3.891-12.28,8.692-15.05,8.688-.525,8.688,5.018",
    transform: "translate(-751.605 -738.101)",
    fill: "#003f97"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M1027.807,1001.583a16.421,16.421,0,0,1-7.428,12.867c-4.1,2.369-7.43.445-7.43-4.289a16.418,16.418,0,0,1,7.43-12.866c4.1-2.371,7.428-.449,7.428,4.287",
    transform: "translate(-755.304 -742.876)",
    fill: "#003f97"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M1028.242,1005.327a14.138,14.138,0,0,1-6.392,11.075c-3.53,2.037-6.39.385-6.39-3.693a14.127,14.127,0,0,1,6.39-11.071c3.53-2.038,6.392-.385,6.392,3.689",
    transform: "translate(-757.177 -746.221)",
    fill: "#d9e8f9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M1028.242,1005.327a14.138,14.138,0,0,1-6.392,11.075c-3.53,2.037-6.39.385-6.39-3.693a14.127,14.127,0,0,1,6.39-11.071c3.53-2.038,6.392-.385,6.392,3.689",
    transform: "translate(-757.177 -746.221)",
    fill: "#d9e8f9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M1033.176,1019.863a6.046,6.046,0,0,1-2.732,4.741c-1.515.873-2.742.166-2.742-1.58a6.04,6.04,0,0,1,2.742-4.739c1.512-.875,2.732-.167,2.732,1.579",
    transform: "translate(-766.304 -759.003)",
    fill: "#aeb5b9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M1035.773,1022.371a5.5,5.5,0,0,1-2.485,4.308c-1.375.792-2.489.148-2.489-1.437a5.491,5.491,0,0,1,2.489-4.3c1.376-.793,2.485-.151,2.485,1.434",
    transform: "translate(-768.614 -761.008)",
    fill: "#d4dbdf"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M1054.546,1021.781a1.582,1.582,0,0,1-.719,1.241c-.394.229-.71.043-.71-.414a1.577,1.577,0,0,1,.71-1.24c.4-.229.719-.046.719.413",
    transform: "translate(-785.256 -761.509)",
    fill: "#00267e"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M1020.711,1039.97a1.6,1.6,0,0,1-.719,1.241c-.4.229-.717.043-.717-.415a1.588,1.588,0,0,1,.717-1.24c.392-.227.719-.041.719.414",
    transform: "translate(-760.022 -775.073)",
    fill: "#00267e"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M1029.426,1050.918a1.577,1.577,0,0,1-.717,1.241c-.4.227-.716.043-.716-.414a1.583,1.583,0,0,1,.714-1.24c.4-.229.719-.045.719.413",
    transform: "translate(-766.522 -783.235)",
    fill: "#00267e"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M1043.592,1044.438a1.585,1.585,0,0,1-.715,1.239c-.394.228-.717.045-.717-.411a1.584,1.584,0,0,1,.717-1.241c.394-.229.715-.044.715.414",
    transform: "translate(-777.085 -778.404)",
    fill: "#00267e"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M1047.837,1008.189a1.571,1.571,0,0,1-.715,1.241c-.394.229-.717.042-.717-.413a1.592,1.592,0,0,1,.717-1.241c.4-.229.715-.042.715.412",
    transform: "translate(-780.251 -751.375)",
    fill: "#00267e"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M1030.205,1015.463a1.572,1.572,0,0,1-.715,1.24c-.4.228-.722.045-.722-.414a1.588,1.588,0,0,1,.722-1.241c.4-.227.715-.042.715.416",
    transform: "translate(-767.1 -756.798)",
    fill: "#00267e"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M1029.537,1002.142a5.147,5.147,0,0,1,1.134,3.54,14.14,14.14,0,0,1-6.394,11.074,4.581,4.581,0,0,1-4.363.517c1.156,1.262,3.078,1.415,5.258.156a14.138,14.138,0,0,0,6.392-11.075c0-2.124-.785-3.584-2.027-4.212",
    transform: "translate(-760.498 -747.247)",
    fill: "#fff"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M1041.385,981.871l-.256,3.144-.29.171-.255-2.848c.127-.082.265-.165.4-.241s.272-.151.4-.225",
    transform: "translate(-775.911 -732.132)",
    fill: "#003f97"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M1041.385,1075.955c-.132.08-.27.164-.4.242s-.27.15-.4.219l.252-3.135.293-.17Z",
    transform: "translate(-775.911 -800.165)",
    fill: "#003f97"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M1000.379,1053.056v.337l-2.587,1.79c-.007-.153-.013-.306-.013-.461s.007-.306.013-.464Z",
    transform: "translate(-743.993 -785.211)",
    fill: "#003f97"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M1078.916,1007.042c0,.157,0,.315-.01.47l-2.587,1.2v-.338l2.587-1.789c.008.146.01.3.01.454",
    transform: "translate(-802.557 -750.562)",
    fill: "#003f97"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M1020.381,1002.873l-.253.322-1.515-1.576c.228-.295.455-.579.7-.859Z",
    transform: "translate(-759.527 -746.216)",
    fill: "#003f97"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M1060.5,1059.249c-.223.294-.454.579-.689.864l-1.078-2.119.252-.315Z",
    transform: "translate(-789.445 -788.658)",
    fill: "#003f97"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M1005.477,1070.6l-2.108,2.972a5.331,5.331,0,0,1-.4-.565l2.371-2.613Z",
    transform: "translate(-747.862 -798.136)",
    fill: "#003f97"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M1073.97,985.664l-2.378,2.614-.142-.2,2.121-2.977a6.471,6.471,0,0,1,.4.567",
    transform: "translate(-798.926 -734.537)",
    fill: "#003f97"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M1005.489,1029.07l-.151.375-2.371.127c.123-.341.258-.691.4-1.033Z",
    transform: "translate(-747.862 -766.929)",
    fill: "#003f97"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M1073.97,1035.4c-.124.342-.257.688-.4,1.031l-2.114-.522.142-.382Z",
    transform: "translate(-798.927 -772.048)",
    fill: "#003f97"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M1020.39,1077.99l-1.073,3.358a6.587,6.587,0,0,1-.692-.063l1.512-3.32Z",
    transform: "translate(-759.537 -803.784)",
    fill: "#003f97"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M1060.5,976.782l-1.51,3.32-.258-.018,1.078-3.368a5.264,5.264,0,0,1,.69.066",
    transform: "translate(-789.445 -728.288)",
    fill: "#003f97"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M986.331,1051.663c0-.152.007-.3.013-.459l-3.9-2.253c0,.187-.013.376-.013.561,0,.124,0,.248.012.368l3.906,2.256c-.007-.158-.013-.313-.013-.473",
    transform: "translate(-732.545 -782.15)",
    fill: "#001971"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M1023.494,954.01l3.93,2.268a6.259,6.259,0,0,1,.77.1l-3.987-2.3a6.079,6.079,0,0,0-.712-.06",
    transform: "translate(-763.167 -711.358)",
    fill: "#001971"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M958.629,1035.2c0,.123-.005.251-.005.373,0,.189.005.374.015.557l3.681,2.127c0-.143-.01-.283-.01-.428,0-.167.007-.333.01-.5Z",
    transform: "translate(-714.797 -771.9)",
    fill: "#001971"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M967.829,1008.093l-3.726-2.153c-.142.338-.271.677-.394,1.014l3.728,2.149c.119-.337.255-.675.392-1.01",
    transform: "translate(-718.589 -750.079)",
    fill: "#001971"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M979.315,978.977l3.753,2.168c.222-.29.449-.571.684-.845L980,978.128c-.234.278-.459.561-.681.849",
    transform: "translate(-730.225 -729.341)",
    fill: "#001971"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M967.818,1060.419l-3.549-2.053a5.43,5.43,0,0,0,.452.6l3.486,2.013a6.73,6.73,0,0,1-.389-.556",
    transform: "translate(-719.006 -789.17)",
    fill: "#001971"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M1005.408,961.642c.169-.1.34-.191.51-.278l-3.8-2.194c-.129.07-.258.142-.394.22s-.263.157-.391.237l3.79,2.191c.093-.059.189-.121.285-.175",
    transform: "translate(-746.643 -715.205)",
    fill: "#001971"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M992.01,1022.061l-3.867-2.23c-.137.336-.273.671-.4,1.009l3.872,2.234c.123-.336.255-.676.392-1.013",
    transform: "translate(-736.512 -760.437)",
    fill: "#001971"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M1025.984,973.617c-.079.042-.156.092-.237.141l3.789,2.185c.127-.077.253-.158.386-.232s.27-.151.4-.225l-3.772-2.178c-.189.1-.376.2-.566.31",
    transform: "translate(-764.847 -725.746)",
    fill: "#001971"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M987.355,1071.7a5.815,5.815,0,0,0,.358.541l4.032,2.329a6.119,6.119,0,0,1-.406-.57Z",
    transform: "translate(-736.22 -799.11)",
    fill: "#001971"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M1048.755,968.58l3.582,2.07a5.536,5.536,0,0,1,.705.063l-3.461-2a6.314,6.314,0,0,0-.827-.133",
    transform: "translate(-782.003 -722.222)",
    fill: "#001971"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M1003.52,992.965l3.838,2.217c.224-.29.447-.575.679-.849l-3.832-2.214c-.232.279-.46.56-.686.846",
    transform: "translate(-748.274 -739.774)",
    fill: "#001971"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(133.111 252.097)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M532.055,992.1l-8.72-.954,4.724,10.879,11.284,6.545-6.008-15.427a1.862,1.862,0,0,0-1.28-1.043",
    transform: "translate(-523.335 -991.142)",
    fill: "#d9e8f9"
  }))))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M424.169,966.05l-13.355-7.78c-2.719-1.546-6.466-1.31-10.6,1.077-8.3,4.8-15.04,16.461-15.04,26.056,0,4.827,1.7,8.207,4.456,9.767l13.355,7.779c2.715,1.538,6.456,1.3,10.584-1.081,8.307-4.8,15.043-16.464,15.043-26.056,0-4.82-1.7-8.2-4.442-9.762",
    transform: "translate(-287.204 -713.805)",
    fill: "#003f97"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M467.767,998.618c0,9.592-6.736,21.256-15.043,26.056-4.128,2.384-7.869,2.62-10.584,1.082-2.754-1.558-4.454-4.941-4.454-9.77,0-9.592,6.732-21.256,15.038-26.051,4.135-2.39,7.88-2.625,10.6-1.079,2.741,1.561,4.442,4.941,4.442,9.762",
    transform: "translate(-326.36 -736.612)",
    fill: "#b8bfc3"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M467.668,998.411c0,9.622-6.753,21.319-15.084,26.129s-15.086.909-15.086-8.71,6.755-21.318,15.086-26.128,15.084-.911,15.084,8.709",
    transform: "translate(-326.219 -736.434)",
    fill: "#1959b1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M474.381,1013.557c0,7.408-5.2,16.416-11.614,20.117s-11.613.7-11.613-6.706,5.2-16.415,11.613-20.115,11.614-.7,11.614,6.7",
    transform: "translate(-336.403 -749.576)",
    fill: "#003f97"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M477.646,1020.917c0,6.332-4.448,14.031-9.929,17.2s-9.924.6-9.924-5.731,4.444-14.031,9.924-17.2,9.929-.6,9.929,5.732",
    transform: "translate(-341.353 -755.962)",
    fill: "#003f97"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M478.205,1025.92c0,5.449-3.821,12.072-8.541,14.8s-8.545.516-8.545-4.933,3.825-12.073,8.545-14.8,8.541-.519,8.541,4.934",
    transform: "translate(-343.833 -760.428)",
    fill: "#d9e8f9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M478.205,1025.92c0,5.449-3.821,12.072-8.541,14.8s-8.545.516-8.545-4.933,3.825-12.073,8.545-14.8,8.541-.519,8.541,4.934",
    transform: "translate(-343.833 -760.428)",
    fill: "#d9e8f9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M484.821,1045.347a8.1,8.1,0,0,1-3.658,6.337c-2.023,1.167-3.661.219-3.661-2.115a8.075,8.075,0,0,1,3.661-6.333c2.017-1.167,3.658-.223,3.658,2.111",
    transform: "translate(-356.049 -777.516)",
    fill: "#aeb5b9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M488.29,1048.7a7.361,7.361,0,0,1-3.321,5.758c-1.837,1.056-3.325.2-3.325-1.921a7.337,7.337,0,0,1,3.325-5.754c1.833-1.059,3.321-.2,3.321,1.917",
    transform: "translate(-359.138 -780.192)",
    fill: "#d4dbdf"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M513.368,1047.914a2.117,2.117,0,0,1-.955,1.658c-.525.3-.954.057-.954-.552a2.119,2.119,0,0,1,.954-1.658c.528-.3.955-.059.955.552",
    transform: "translate(-381.369 -780.868)",
    fill: "#00267e"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M468.163,1072.217a2.115,2.115,0,0,1-.959,1.658c-.527.305-.954.056-.954-.551a2.118,2.118,0,0,1,.954-1.66c.53-.3.959-.058.959.554",
    transform: "translate(-347.659 -798.988)",
    fill: "#00267e"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M479.8,1086.856a2.121,2.121,0,0,1-.958,1.659c-.529.3-.958.058-.958-.552a2.114,2.114,0,0,1,.956-1.658c.531-.306.96-.057.96.551",
    transform: "translate(-356.336 -809.905)",
    fill: "#00267e"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M498.728,1078.187a2.125,2.125,0,0,1-.959,1.658c-.527.307-.959.057-.959-.553a2.123,2.123,0,0,1,.959-1.657c.526-.306.959-.059.959.553",
    transform: "translate(-370.446 -803.44)",
    fill: "#00267e"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M504.416,1029.745a2.117,2.117,0,0,1-.954,1.659c-.532.3-.96.054-.96-.553a2.111,2.111,0,0,1,.96-1.658c.528-.306.954-.056.954.552",
    transform: "translate(-374.691 -767.32)",
    fill: "#00267e"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M480.868,1039.468a2.113,2.113,0,0,1-.958,1.657c-.528.3-.955.059-.955-.551a2.113,2.113,0,0,1,.955-1.658c.53-.3.958-.06.958.551",
    transform: "translate(-357.132 -774.57)",
    fill: "#00267e"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M479.942,1021.663a6.861,6.861,0,0,1,1.519,4.733c0,5.444-3.828,12.07-8.545,14.8-2.255,1.3-4.3,1.465-5.833.7,1.543,1.683,4.114,1.885,7.029.2,4.719-2.725,8.541-9.348,8.541-14.8,0-2.844-1.044-4.791-2.711-5.632",
    transform: "translate(-348.281 -761.803)",
    fill: "#fff"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M495.785,994.577l-.34,4.2-.387.233-.342-3.807c.171-.111.351-.215.53-.321s.36-.2.539-.3",
    transform: "translate(-368.885 -741.606)",
    fill: "#003f97"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M495.785,1120.311c-.179.109-.356.222-.539.323s-.359.2-.53.3l.337-4.191.393-.226Z",
    transform: "translate(-368.885 -832.528)",
    fill: "#003f97"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M440.973,1089.7v.452l-3.46,2.39c-.007-.2-.016-.4-.016-.613s.01-.412.016-.619Z",
    transform: "translate(-326.219 -812.538)",
    fill: "#003f97"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M545.934,1028.21c0,.211,0,.418-.011.626l-3.462,1.609v-.452l3.462-2.389c.007.2.011.4.011.606",
    transform: "translate(-404.486 -766.233)",
    fill: "#003f97"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M467.712,1022.643l-.346.428-2.028-2.107c.3-.4.61-.777.931-1.147Z",
    transform: "translate(-346.98 -760.426)",
    fill: "#003f97"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M521.323,1097.983c-.3.395-.6.777-.916,1.154l-1.442-2.828.338-.422Z",
    transform: "translate(-386.965 -817.149)",
    fill: "#003f97"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M447.789,1113.149l-2.821,3.972a8.133,8.133,0,0,1-.54-.759l3.171-3.491Z",
    transform: "translate(-331.387 -829.812)",
    fill: "#003f97"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M539.326,999.639l-3.174,3.493-.2-.277,2.839-3.976a8.633,8.633,0,0,1,.532.759",
    transform: "translate(-399.634 -744.815)",
    fill: "#003f97"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M447.795,1057.65l-.2.5-3.171.167c.169-.457.348-.921.533-1.378Z",
    transform: "translate(-331.387 -788.109)",
    fill: "#003f97"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M539.322,1066.116c-.164.458-.342.919-.535,1.378l-2.831-.7.2-.511Z",
    transform: "translate(-399.635 -794.949)",
    fill: "#003f97"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M467.74,1123.031l-1.443,4.488a7.116,7.116,0,0,1-.921-.087l2.018-4.435Z",
    transform: "translate(-347.007 -837.363)",
    fill: "#003f97"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M521.328,987.766l-2.02,4.442-.344-.03,1.442-4.5a7.96,7.96,0,0,1,.921.084",
    transform: "translate(-386.966 -736.465)",
    fill: "#003f97"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M422.216,1087.847c0-.2.009-.406.016-.614l-5.214-3.008q-.015.377-.014.75c0,.166,0,.326.007.492l5.221,3.012c-.007-.21-.016-.417-.016-.632",
    transform: "translate(-310.939 -808.452)",
    fill: "#001971"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M471.875,957.327l5.249,3.031a8.382,8.382,0,0,1,1.031.129l-5.33-3.075a8.419,8.419,0,0,0-.951-.085",
    transform: "translate(-351.853 -713.831)",
    fill: "#001971"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M385.184,1065.846c-.006.165-.012.335-.012.5,0,.253.006.5.019.744l4.922,2.842c-.011-.19-.017-.38-.017-.576,0-.22.006-.443.017-.664Z",
    transform: "translate(-287.203 -794.748)",
    fill: "#001971"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M397.485,1029.611l-4.981-2.879c-.186.449-.361.9-.526,1.358l4.977,2.871c.163-.451.342-.9.53-1.35",
    transform: "translate(-292.278 -765.583)",
    fill: "#001971"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M412.835,990.706l5.012,2.9q.448-.579.916-1.129l-5.022-2.9c-.312.371-.611.751-.906,1.136",
    transform: "translate(-307.83 -737.873)",
    fill: "#001971"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M397.451,1099.544,392.7,1096.8a8.486,8.486,0,0,0,.609.8l4.66,2.689a8.786,8.786,0,0,1-.518-.744",
    transform: "translate(-292.816 -817.829)",
    fill: "#001971"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M447.689,967.538c.231-.133.457-.256.681-.373l-5.079-2.93c-.173.094-.347.187-.527.289s-.351.212-.525.321l5.065,2.925c.129-.076.259-.159.385-.233",
    transform: "translate(-329.755 -718.982)",
    fill: "#001971"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M429.8,1048.29l-5.164-2.981c-.188.446-.371.9-.534,1.347l5.171,2.988c.167-.454.342-.907.528-1.354",
    transform: "translate(-316.228 -779.435)",
    fill: "#001971"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M475.211,983.535c-.108.062-.209.128-.314.192l5.06,2.923c.171-.108.34-.214.513-.315s.361-.2.543-.295l-5.05-2.914c-.25.129-.5.264-.753.41",
    transform: "translate(-354.107 -733.067)",
    fill: "#001971"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M423.564,1114.616a8.187,8.187,0,0,0,.481.724l5.389,3.11a8.288,8.288,0,0,1-.545-.759Z",
    transform: "translate(-315.83 -831.113)",
    fill: "#001971"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M505.62,976.813l4.792,2.765a9.074,9.074,0,0,1,.944.081l-4.629-2.673a7.777,7.777,0,0,0-1.107-.174",
    transform: "translate(-377.015 -728.361)",
    fill: "#001971"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M445.166,1009.4l5.131,2.963c.3-.388.6-.765.908-1.134l-5.12-2.957c-.312.369-.616.744-.919,1.128",
    transform: "translate(-331.938 -751.818)",
    fill: "#001971"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M494.907,1000.1l1.879-1.885-6-15.425a2.842,2.842,0,0,0-2.142-1.74L477.276,979.8a6.067,6.067,0,0,0-3.158.819l-10.376,5.99v2.318l10.376-5.99a4.429,4.429,0,0,1,2.131-.555l11.371,1.247a1.862,1.862,0,0,1,1.28,1.043Z",
    transform: "translate(-345.789 -730.575)",
    fill: "#d9e8f9"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(101.608 239.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 37.68,
    height: 45.508,
    transform: "translate(-8.282 13.683) rotate(-58.814)",
    fill: "url(#linear-gradient-14)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    clipPath: "url(#clip-path-2)"
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M415.826,978.6l-16.345-9.555v2.318l16.345,9.555Z",
    transform: "translate(-297.873 -722.567)",
    fill: "#d58a00"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M417.122,1068.118l.27-11.174,54.882,33.918-7.173,6.572Z",
    transform: "translate(-311.027 -788.11)",
    fill: "#003f97"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M682.041,699.2a97.362,97.362,0,0,1,1.976,19.883,89.69,89.69,0,0,1-.763,9.047,11.152,11.152,0,0,0-2.237.392C658.4,735.653,651.3,762.363,651.3,762.363l-3.583,7.077-36.045,20.809-56.026-36.2-12.16-16.673,18.121-10.466,43.983-56.06-.025-6.338,13.834-7.986L675.325,689.6c1.891.934,6.491,8.391,6.716,9.6",
    transform: "translate(-405.251 -489.537)",
    fill: "#d9e8f9"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M837.278,699.149c-.326-1.34-4.839-8.629-6.706-9.55l-55.924-33.076-13.834,7.986.025,6.338-2.25,2.863-6.7,71.095-.2,24.2,8.263,4.565,18.118-10.461s.546-13.368,1.916-15.427c13.014-19.526,33.1-32.5,42.082-38.844,6.884-4.863,12.81-8.338,15.208-9.694",
    transform: "translate(-560.498 -489.537)",
    fill: "#f3ffff"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M974.681,755.131l17.114-9.95a2.379,2.379,0,0,0-.424-.282l-24.029-14.213Z",
    transform: "translate(-721.298 -544.837)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(122.778 249.209)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M498.169,979.788,482.71,999.413l54.882,33.918,14.837-24.771Z",
    transform: "translate(-482.71 -979.788)",
    fill: "#d9e8f9"
  }))))), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M555.507,1061.635l9.472-15.809-47.418-28.079-10.824,13.745Z",
    transform: "translate(-377.848 -758.883)",
    fill: "#00267e"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M631.116,483.924c1.23,7.879,5.754,36.949,6.606,46.458.989,11.038.8,21.918.8,21.918-27.98,19.508-41.107,38.595-42.065,40.635-.785,1.681-1.914,14.217-1.914,14.217s-19.765,12.539-26.793,8.02l-53.913-31.216a4.769,4.769,0,0,1-1.437-1.631c-4.758-8.738,2.1-34.952,4.138-44.972s14.393-51.034,21.188-59.667c2.123-2.7,6.75-6.393,12.136-9.888,5.3-3.436,20.2-12.829,25.443-15.871a4.407,4.407,0,0,1,3.654,0l50.17,29.044a4.219,4.219,0,0,1,1.987,2.952",
    transform: "translate(-380.841 -336.684)",
    fill: "#fff"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M795.233,620.234c-.851-9.508-5.375-38.579-6.605-46.458a4.089,4.089,0,0,0-.706-1.745c-2.813,1.73-20.57,12.665-26.819,16.721-5.384,3.494-10.013,7.192-12.138,9.888-6.8,8.63-19.151,49.641-21.187,59.663s-8.9,36.237-4.138,44.974a8.475,8.475,0,0,0,.937,1.353l.684.393c7.028,4.52,26.793-8.02,26.793-8.02s1.129-12.535,1.914-14.217c.959-2.04,14.085-21.126,42.066-40.635,0,0,.189-10.88-.8-21.918m-10.684-31.8-1.116-5.56,4.64-2.68a.915.915,0,0,1,1.123-.007,1.274,1.274,0,0,0-.659.185l-4.64,2.68,1.118,5.561Zm7.417,37.347-4.039,2.333-.185,7.35-.49-.366.214-7.165,4.034-2.33a.914.914,0,0,1,1.123-.006,1.237,1.237,0,0,0-.656.184",
    transform: "translate(-538.353 -426.535)",
    fill: "#d9e8f9"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(129.91 131.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 175.738,
    height: 158.099,
    transform: "matrix(0.514, -0.857, 0.857, 0.514, -68.127, 108.365)",
    fill: "url(#linear-gradient-15)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    clipPath: "url(#clip-path-2)"
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M795.233,620.234c-.659-7.381-3.534-26.554-5.363-38.443a3.5,3.5,0,0,1-.429.969l-3.014,3.983c1.429,10.045,3.121,23.309,3.275,30.708.066,3.04-.017,6.21-.177,9.287l1.974-1.14a.913.913,0,0,1,1.123-.006c.454.011.765.373.765,1a3.005,3.005,0,0,1-.522,1.572l-3.813,5.256c-.613,7.055-1.431,12.41-1.431,12.41v.008c-23.062,17.756-34.185,33.949-35.366,36.463-.28.6-.96,2.086-1.994,12.171a2.416,2.416,0,0,1-.939,1.688c-9.843,5.652-21.12,9.789-23.761,4.94-3.747-6.885.762-27.318,3.184-38.3.431-1.953.8-3.643,1.09-5.061,2.32-11.406,14.465-50.313,20.227-57.631,1.35-1.715,4.989-4.974,11.171-8.983,4.815-3.126,16.667-10.588,23-14.37.475-.281.69-.186.755.239.19,1.263.427,2.814.689,4.57l2.394-1.384a.915.915,0,0,1,1.123-.007.687.687,0,0,1,.452.174c-.427-2.779-.786-5.069-1.02-6.581a4.091,4.091,0,0,0-.706-1.745c-2.813,1.73-20.57,12.665-26.819,16.721-5.384,3.494-10.013,7.192-12.138,9.888-6.8,8.63-19.151,49.641-21.187,59.663s-8.9,36.237-4.138,44.973a8.462,8.462,0,0,0,.937,1.353l.684.393c7.028,4.52,26.793-8.02,26.793-8.02s1.129-12.535,1.914-14.217c.959-2.04,14.085-21.126,42.066-40.635,0,0,.189-10.88-.8-21.918",
    transform: "translate(-538.353 -426.535)",
    fill: "#003f97"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M765.773,703.283,818.889,669.2a113.25,113.25,0,0,0,0-12.486c-.414-5.171-4-29.591-4-29.591s-24.98,15.373-27.111,16.845-4.7,3.394-8.338,12.847c-3.946,10.271-11.752,33.917-13.67,46.472",
    transform: "translate(-570.998 -467.612)",
    fill: "#003f97"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M772.42,706.687c2.518-13.114,9.6-34.3,13.126-43.483,3.575-9.3,6.069-11.022,7.889-12.274,1.772-1.223,19.924-12.419,25.465-15.83.841,5.79,3.38,23.416,3.716,27.658a108.663,108.663,0,0,1,.033,11.7Z",
    transform: "translate(-575.954 -473.563)",
    fill: "#2971c9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M783.394,878.164c-1.018-4.207-4.335-4.731-13.911,2.548s-18.462,15.989-21.426,21.438c-1.335,2.449-1.9,6.407-2.55,10.578-.8,5.105-1.262,10.119,1.3,10.659,5.852,1.231,16.256-4.775,16.256-4.775s1.343-11.909,6.049-18.441c6.967-9.671,15.69-16.179,14.277-22.006",
    transform: "translate(-555.416 -652.516)",
    fill: "#003f97"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M752.189,925.932a7.164,7.164,0,0,1-1.482-.14c-.793-.165-1.5-1.911-.348-9.265l.111-.7c.588-3.785,1.148-7.358,2.3-9.484,2.779-5.115,11.257-13.572,21.088-21.045,4.681-3.557,8.038-5.362,9.975-5.362.72,0,1.525.166,2,2.127.811,3.34-2.7,7.38-7.154,12.494-2.186,2.508-4.658,5.353-6.925,8.5-4.259,5.913-5.839,15.77-6.195,18.383-1.918,1.038-8.636,4.487-13.373,4.487",
    transform: "translate(-559.053 -656.126)",
    fill: "#2971c9"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M562.581,585.654c-6.894,14.349-16.1,45.345-17.842,53.88-.32,1.567-.762,3.535-1.251,5.773l45.775,26.428c.527-2.373.992-4.465,1.331-6.11,1.717-8.473,10.818-39.1,17.7-53.581Z",
    transform: "translate(-405.251 -436.693)",
    fill: "#003f97"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M548.979,649.773c.418-1.9.78-3.541,1.06-4.913,1.7-8.378,10.394-37.658,17.176-52.39l43.576,25.157c-6.846,14.92-15.609,44.473-17.313,52.833-.25,1.249-.581,2.739-.955,4.449Z",
    transform: "translate(-409.346 -441.776)",
    fill: "#2971c9"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M552.025,644.86c-.114.558-.243,1.172-.383,1.818l52.777-33.871v0L569.2,592.471c-6.782,14.732-15.473,44.011-17.176,52.389",
    transform: "translate(-411.331 -441.776)",
    fill: "#a0d1f9"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M578.038,771.576l-.02.005c-.008-.009,0-.011.02-.005l7.046-1.4,5.377-1.847,1.366-10.195,6.193-3.825c-1.513-2.6-5.13-2.084-13.307,4.134A127.618,127.618,0,0,0,569.139,772.3L582.9,780.25a21.177,21.177,0,0,1,1.442-2.351c.556-.77,1.126-1.519,1.694-2.249-3.527-1.836-7.669-3.974-8-4.074",
    transform: "translate(-424.378 -561.346)",
    fill: "#a0d1f9"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M593.479,813.579c.316-1.547.874-3.824,1.618-6.6l-39.974-22.573-6.143,8.483,43.543,25.137c.374-1.711.706-3.2.956-4.45",
    transform: "translate(-409.346 -584.894)",
    fill: "#2971c9"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(139.633 150.694)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M567.215,592.47c-6.782,14.732-15.473,44.011-17.176,52.389-.28,1.372-.642,3.014-1.06,4.913l6.809,3.93c7.335-10.765,22.624-31.586,39.5-45.028Z",
    transform: "translate(-548.979 -592.47)",
    fill: "#fff"
  }))))), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M764.968,920.781c.05.871.724,1.17,1.5.666l5.832-3.781a3.146,3.146,0,0,0,1.33-2.506l-.1-1.812c-.05-.874-.729-1.175-1.505-.669l-5.832,3.782a3.133,3.133,0,0,0-1.33,2.506Z",
    transform: "translate(-570.32 -680.356)",
    fill: "#1959b1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(195.038 232.57)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 10.716,
    height: 10.905,
    transform: "matrix(0.896, -0.445, 0.445, 0.896, -3.333, 1.638)",
    fill: "url(#linear-gradient-16)"
  }))))))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M995.259,788.757c0,.339.22.488.485.331a1.122,1.122,0,0,0,.49-.9c0-.34-.215-.486-.49-.33a1.136,1.136,0,0,0-.485.9",
    transform: "translate(-742.114 -587.423)",
    fill: "#003f97"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M983.039,608.193c0,.34.215.484.489.33a1.13,1.13,0,0,0,.494-.9c0-.34-.22-.486-.494-.328a1.124,1.124,0,0,0-.489.9",
    transform: "translate(-733.002 -452.784)",
    fill: "#003f97"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M994.595,818.975l3.185-1.836v-8.991l-3.185,1.841Z",
    transform: "translate(-741.619 -602.596)",
    fill: "#1959b1"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M996.2,812.9l2.4-1.383v-.535l-2.4,1.383Z",
    transform: "translate(-742.813 -604.712)",
    fill: "#00267e"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M996.2,816.361l2.4-1.384v-.533l-2.4,1.381Z",
    transform: "translate(-742.813 -607.29)",
    fill: "#00267e"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M996.2,819.814l2.4-1.383V817.9l-2.4,1.383Z",
    transform: "translate(-742.813 -609.865)",
    fill: "#00267e"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M996.2,823.265l2.4-1.383v-.535l-2.4,1.384Z",
    transform: "translate(-742.813 -612.438)",
    fill: "#00267e"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M996.2,826.721l2.4-1.383V824.8l-2.4,1.384Z",
    transform: "translate(-742.813 -615.014)",
    fill: "#00267e"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M996.2,830.176l2.4-1.381v-.536l-2.4,1.384Z",
    transform: "translate(-742.813 -617.591)",
    fill: "#00267e"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M996.2,833.626l2.4-1.382v-.538l-2.4,1.385Z",
    transform: "translate(-742.813 -620.161)",
    fill: "#00267e"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M996.2,837.079l2.4-1.382v-.538l-2.4,1.385Z",
    transform: "translate(-742.813 -622.737)",
    fill: "#00267e"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M996.2,840.551l2.4-1.383v-.532l-2.4,1.38Z",
    transform: "translate(-742.813 -625.329)",
    fill: "#00267e"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M692.965,967.4a70.9,70.9,0,0,0-2.22,12.377c-1.288.169-7.526.013-8.851.115-2.106.164-1.081-3.589-.854-5.1s12.189-8.773,12.189-8.773a11.474,11.474,0,0,0-.263,1.383",
    transform: "translate(-507.481 -720.312)",
    fill: "#003f97"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(168.668 242.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 22.283,
    height: 22.888,
    transform: "translate(-6.8 13.52) rotate(-65.224)",
    fill: "url(#linear-gradient-17)"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M643.612,1017.194l4.438,2.73v-6.583l-4.438-2.729Z",
    transform: "translate(-479.909 -753.563)",
    fill: "#00267e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M648.05,1004.93l4.968-2.865-4.443-2.733-4.963,2.869Z",
    transform: "translate(-479.909 -745.152)",
    fill: "#3273cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M661.06,1019.526l4.968-2.865v-6.582l-4.968,2.865Z",
    transform: "translate(-492.919 -753.165)",
    fill: "#003f97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M648.557,1022.375c0,1.244-.876,1.749-1.957,1.128a4.333,4.333,0,0,1-1.954-3.389c0-1.248.876-1.751,1.954-1.131a4.33,4.33,0,0,1,1.957,3.391",
    transform: "translate(-480.68 -759.608)",
    fill: "#d4dbdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M502.84,863.221a70.6,70.6,0,0,0-2.221,12.378c-1.288.169-7.526.012-8.85.114-2.107.166-1.081-3.588-.853-5.1s12.188-8.773,12.188-8.773h0a11.289,11.289,0,0,0-.261,1.385",
    transform: "translate(-365.715 -642.628)",
    fill: "#003f97"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(120.309 216.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 22.285,
    height: 22.889,
    transform: "translate(-6.8 13.522) rotate(-65.224)",
    fill: "url(#linear-gradient-18)"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M453.462,913.018l4.444,2.732v-6.58l-4.444-2.735Z",
    transform: "translate(-338.124 -675.884)",
    fill: "#151f22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M457.906,900.77l4.967-2.871-4.444-2.73-4.967,2.865Z",
    transform: "translate(-338.124 -667.483)",
    fill: "#5b686c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M470.934,915.352l4.967-2.867V905.9l-4.967,2.871Z",
    transform: "translate(-351.152 -675.485)",
    fill: "#003f97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M458.428,918.2c0,1.247-.875,1.752-1.953,1.129a4.309,4.309,0,0,1-1.957-3.386c0-1.249.874-1.752,1.957-1.129a4.329,4.329,0,0,1,1.953,3.387",
    transform: "translate(-338.911 -681.934)",
    fill: "#d4dbdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M456.491,1004.038l5.017-2.9,3.4-4.228,9.706-5.6v-2.7l-4.823-.649-4.883,2.819-3.4-2.305-5.017,2.9Z",
    transform: "translate(-340.382 -736.674)",
    fill: "#003f97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M458.139,986.005l3.4,2.305,4.883-2.819,4.823.649L470.1,985.3l-4.823-.65-4.887,2.818-3.4-2.3-5.017,2.895v12.668l1.149.839V988.9Z",
    transform: "translate(-337.013 -734.203)",
    fill: "#3273cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M451.973,1008.649v12.666l1.149.84V1009.49Z",
    transform: "translate(-337.013 -752.099)",
    fill: "#00267e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M428.843,427.123c1.946-1.353,8.112-5.619,10.385-6.933,1.363-.786,2.47-.149,2.467,1.427a5.282,5.282,0,0,1-.868,2.668c-3.419,5.551-7.046,12.14-11.431,14.67-1.485.857-2.64.13-2.64-1.537V430.73a6.08,6.08,0,0,1,2.087-3.607",
    transform: "translate(-318.21 -313.064)",
    fill: "#003f97"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(120.498 108.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 44.997,
    height: 50.639,
    transform: "translate(-11.82 20.473) rotate(-60)",
    fill: "url(#linear-gradient-19)"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M423.382,434.953v-6.688a6.08,6.08,0,0,1,2.087-3.606c1.946-1.353,8.112-5.619,10.385-6.933a1.751,1.751,0,0,1,1.726-.183l-1.019-.757a1.665,1.665,0,0,0-1.859.1c-2.271,1.312-8.436,5.581-10.381,6.931a6.063,6.063,0,0,0-2.09,3.607v6.687a1.961,1.961,0,0,0,.657,1.644l1.085.788a2.021,2.021,0,0,1-.591-1.589",
    transform: "translate(-314.836 -310.599)",
    fill: "#00267e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M422.765,431.124l10.971-6.33-5.276-3.045-10.967,6.333Z",
    transform: "translate(-311.303 -314.477)",
    fill: "#3273cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M438.221,615.4l10.971-6.334V433.721l-10.971,6.331Z",
    transform: "translate(-326.759 -323.404)",
    fill: "#003f97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M422.765,625.036V449.69l-5.272-3.043V621.988Z",
    transform: "translate(-311.303 -333.043)",
    fill: "#00267e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M496.486,920.023v3.117l-30.445-17.472v-3.119Z",
    transform: "translate(-347.503 -672.985)",
    fill: "#00267e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M497.349,918.4l-.863.414-30.445-17.474.866-.411Z",
    transform: "translate(-347.503 -671.781)",
    fill: "#3273cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M496.486,759.831v3.116l-30.445-17.472v-3.117Z",
    transform: "translate(-347.503 -553.541)",
    fill: "#00267e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M497.349,758.209l-.863.412-30.445-17.472.866-.413Z",
    transform: "translate(-347.503 -552.329)",
    fill: "#3273cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M512.975,621.233l1.294-.745-5.274-3.044-1.291.745Z",
    transform: "translate(-378.568 -460.398)",
    fill: "#3273cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M512.975,754.485V623.416l-5.272-3.044V751.44Z",
    transform: "translate(-378.568 -462.58)",
    fill: "#00267e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M529.725,629.411l-1.294.745V761.225l1.294-.748Z",
    transform: "translate(-394.024 -469.32)",
    fill: "#003f97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M480.286,1129.128l-6.574,3.388-30.443-17.475,6.575-3.387Z",
    transform: "translate(-330.523 -828.905)",
    fill: "#687579"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M460.463,1142.445v3.118l-30.443-17.474v-3.119Z",
    transform: "translate(-320.644 -838.834)",
    fill: "#00267e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M462.681,1137.418l-2.218,1.28-30.443-17.475,2.217-1.278Z",
    transform: "translate(-320.644 -835.086)",
    fill: "#3273cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M551.927,1191.762l-2.218,1.278v-3.118l2.218-1.28Z",
    transform: "translate(-409.89 -886.311)",
    fill: "#003f97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M480.286,1057.842l-6.574,3.387-30.443-17.473,6.575-3.388Z",
    transform: "translate(-330.523 -775.75)",
    fill: "#687579"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M460.463,1071.161v3.117l-30.443-17.473v-3.118Z",
    transform: "translate(-320.644 -785.682)",
    fill: "#00267e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M462.681,1066.134l-2.218,1.279-30.443-17.473,2.217-1.278Z",
    transform: "translate(-320.644 -781.935)",
    fill: "#3273cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M551.927,1120.474l-2.218,1.279v-3.117l2.218-1.279Z",
    transform: "translate(-409.89 -833.157)",
    fill: "#003f97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M530.35,1094.944l2.058-1.191L525,1089.44,523,1090.58Z",
    transform: "translate(-389.978 -812.341)",
    fill: "#3273cb"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(80.494 278.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 84.349,
    height: 83.064,
    transform: "matrix(0.481, -0.877, 0.877, 0.481, -26.834, 48.637)",
    fill: "url(#linear-gradient-20)"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M378.408,1106.461l-2.062,1.19,0,26.9a1.154,1.154,0,0,1-.578,1l-33.958,19.614-19.162,11.046a1.609,1.609,0,0,1-1.6-.03l-4.22-2.5c-.234-.134-.36-.263-.357-.412h0v.517c0,.151.124.277.36.415l4.22,2.5a1.612,1.612,0,0,0,1.6.029l19.162-9.6,34.841-20.045a3.868,3.868,0,0,0,1.754-3.039Z",
    transform: "translate(-235.978 -825.033)",
    fill: "#003f97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M423.332,1032.725l2.065-1.191-7.415-4.311-1.991,1.138Z",
    transform: "translate(-310.184 -765.949)",
    fill: "#3273cb"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(53.277 262.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 84.347,
    height: 83.059,
    transform: "translate(-26.835 48.637) rotate(-61.25)",
    fill: "url(#linear-gradient-21)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    clipPath: "url(#clip-path-2)"
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M271.389,1044.241l-2.065,1.19v26.9a1.151,1.151,0,0,1-.573.995l-33.959,19.617-19.162,11.043a1.627,1.627,0,0,1-1.6-.029l-4.215-2.5c-.237-.134-.364-.264-.361-.413h0v.516c0,.146.127.276.364.415l4.215,2.5a1.616,1.616,0,0,0,1.6.03l19.162-9.594,34.843-20.049a3.88,3.88,0,0,0,1.753-3.039Z",
    transform: "translate(-156.176 -778.638)",
    fill: "#003f97"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M563.7,511.676l10.97-6.333-5.276-3.044-10.966,6.331Z",
    transform: "translate(-416.392 -374.539)",
    fill: "#3273cb"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M579.155,695.942l10.97-6.331V514.267l-10.97,6.333Z",
    transform: "translate(-431.847 -383.464)",
    fill: "#003f97"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M563.7,705.578V530.236l-5.272-3.046V702.534Z",
    transform: "translate(-416.392 -393.1)",
    fill: "#00267e"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M594.448,1088.339l5.018-2.9,3.4-4.227,9.709-5.6v-2.7l-4.824-.651-4.885,2.821-3.4-2.306-5.018,2.9Z",
    transform: "translate(-443.25 -799.53)",
    fill: "#003f97"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M596.092,1070.311l3.4,2.306,4.885-2.822,4.824.651-1.151-.841-4.822-.651-4.883,2.822-3.4-2.305-5.017,2.9v12.664l1.151.842v-12.666Z",
    transform: "translate(-439.876 -797.066)",
    fill: "#3273cb"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M589.923,1082.379v12.664l1.151.842v-12.666Z",
    transform: "translate(-439.876 -807.076)",
    fill: "#00267e"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M596.741,917.682l-4.113,2.373,0-14.065,4.116-2.374Z",
    transform: "translate(-441.89 -673.782)",
    fill: "#d4dbdf"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M592.436,521.54c1.946-1.354,8.109-5.622,10.383-6.933,1.363-.787,2.467-.15,2.467,1.424a5.313,5.313,0,0,1-.868,2.669c-3.419,5.547-7.044,12.139-11.433,14.672-1.483.856-2.639.128-2.639-1.54v-6.687a6.07,6.07,0,0,1,2.089-3.6",
    transform: "translate(-440.192 -383.465)",
    fill: "#003f97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(204.689 272.827)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M806.485,1100.529l36.045-20.809,3.583-7.077-41.362,23.735Z",
    transform: "translate(-804.751 -1072.643)",
    fill: "#d9e8f9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(217.504 252.902)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M891.064,994.306l-35.929,20.745.144.249,35.785-20.659,1.856,1.075c.06-.079.114-.156.179-.234Z",
    transform: "translate(-855.135 -994.306)",
    fill: "#d9e8f9"
  }))))), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M933.888,868.716c-.379-.544-1.346-.637-2.987-.061a1.2,1.2,0,0,1,.967.447c.383.545.739,9.342-10.505,20.472s-30.095,22.294-30.095,22.294,20.876-11.55,32.122-22.679,10.884-19.927,10.5-20.473",
    transform: "translate(-664.573 -647.421)",
    fill: "#f3ffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(228.856 220.843)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M926.317,876.207c6.813-5.31,11.048-7.546,13.251-7.894-1.724-.393-6.178,1.57-14.292,7.894-9.51,7.417-25.511,24.644-25.511,24.644s17.045-17.227,26.553-24.644",
    transform: "translate(-899.764 -868.265)",
    fill: "#d9e8f9"
  }))))), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M992.838,879.513a63.658,63.658,0,0,1,5.708-3.81c3.482-2.012,4.88-2.04,5.243-1.834.056.973.074,8.093-9.671,17.741a81.11,81.11,0,0,1-6.659,5.82Z",
    transform: "translate(-736.298 -651.538)",
    fill: "#f3ffff"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M994.869,881.2a62.779,62.779,0,0,1,5.708-3.815c3.484-2.01,4.882-2.041,5.243-1.832.058.972.074,8.094-9.67,17.739a81.257,81.257,0,0,1-6.659,5.821Z",
    transform: "translate(-737.812 -652.792)",
    fill: "#d9e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(253.301 223.826)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M1017.536,892.28c.083-.244.159-.477.222-.7l-10.374,5.991-.21.7Z",
    transform: "translate(-1004.298 -888.629)",
    fill: "#d9e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M1013.166,905.863c.149-.28.293-.552.424-.821l-9.971,5.757-.21.695Z",
    transform: "translate(-1001.492 -898.671)",
    fill: "#d9e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M1010.942,886.435l10.111-5.84c.026-.231.041-.431.05-.6l-9.95,5.745Z",
    transform: "translate(-1007.109 -879.993)",
    fill: "#d9e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M1019.4,886.211c.053-.229.1-.451.136-.655l-10.26,5.927-.21.693Z",
    transform: "translate(-1005.706 -884.141)",
    fill: "#d9e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M1015.474,898.811c.114-.261.217-.511.313-.758l-10.286,5.941-.209.691Z",
    transform: "translate(-1002.895 -893.46)",
    fill: "#d9e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M1004.04,931.605c.35-.391.687-.779,1.009-1.159l-7.069,4.082-.209.695Z",
    transform: "translate(-997.288 -917.613)",
    fill: "#d9e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M999.628,942.856q.539-.51,1.04-1c.138-.136.27-.272.4-.407l-4.988,2.878-.212.7Z",
    transform: "translate(-995.871 -925.817)",
    fill: "#d9e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M1007.562,922.026c.266-.344.513-.677.747-1.008L999.85,925.9l-.21.7Z",
    transform: "translate(-998.681 -910.583)",
    fill: "#d9e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M1010.555,913.542c.2-.305.394-.608.571-.9l-9.391,5.419-.207.7Z",
    transform: "translate(-1000.09 -904.336)",
    fill: "#d9e8f9"
  }))))), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M750.6,1121.268l-8.717-.956L746.6,1131.2l11.284,6.545-6.006-15.428a1.872,1.872,0,0,0-1.282-1.044",
    transform: "translate(-553.182 -835.361)",
    fill: "#d9e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(188.698 284.952)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M750.6,1121.268l-8.717-.956L746.6,1131.2l11.284,6.545-6.006-15.428a1.872,1.872,0,0,0-1.282-1.044",
    transform: "translate(-741.88 -1120.312)",
    fill: "#d9e8f9"
  }))))), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M645.141,1097.96l-13.355-7.78c-2.716-1.548-6.463-1.311-10.6,1.076-8.3,4.8-15.042,16.459-15.042,26.054,0,4.828,1.709,8.211,4.461,9.768l13.352,7.779c2.721,1.54,6.455,1.3,10.585-1.082,8.311-4.8,15.047-16.461,15.047-26.055,0-4.816-1.7-8.2-4.448-9.76",
    transform: "translate(-451.971 -812.163)",
    fill: "#003f97"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M688.755,1130.527c0,9.594-6.736,21.258-15.047,26.055-4.13,2.383-7.864,2.622-10.585,1.082-2.75-1.56-4.453-4.941-4.453-9.768,0-9.593,6.731-21.255,15.037-26.052,4.136-2.389,7.882-2.624,10.6-1.077,2.744,1.562,4.448,4.944,4.448,9.76",
    transform: "translate(-491.137 -834.97)",
    fill: "#b8bfc3"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M688.665,1130.324c0,9.621-6.756,21.318-15.089,26.129s-15.082.911-15.082-8.708,6.755-21.318,15.082-26.128,15.089-.91,15.089,8.708",
    transform: "translate(-491.005 -834.797)",
    fill: "#1959b1"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M695.369,1145.469c0,7.408-5.2,16.415-11.618,20.119s-11.611.7-11.611-6.707,5.2-16.412,11.611-20.116,11.618-.7,11.618,6.7",
    transform: "translate(-501.181 -847.937)",
    fill: "#003f97"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M698.629,1152.828c0,6.33-4.443,14.028-9.926,17.2s-9.922.6-9.922-5.734,4.441-14.026,9.922-17.193,9.926-.6,9.926,5.732",
    transform: "translate(-506.132 -854.321)",
    fill: "#003f97"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M699.2,1157.829c0,5.446-3.824,12.073-8.543,14.8s-8.54.516-8.54-4.936,3.824-12.069,8.538-14.795,8.545-.516,8.545,4.934",
    transform: "translate(-508.622 -858.786)",
    fill: "#d9e8f9"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M699.2,1157.829c0,5.446-3.824,12.073-8.543,14.8s-8.54.516-8.54-4.936,3.824-12.069,8.538-14.795,8.545-.516,8.545,4.934",
    transform: "translate(-508.622 -858.786)",
    fill: "#d9e8f9"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M705.8,1177.258a8.08,8.08,0,0,1-3.661,6.335c-2.019,1.168-3.658.222-3.658-2.111a8.088,8.088,0,0,1,3.658-6.336c2.022-1.169,3.661-.221,3.661,2.112",
    transform: "translate(-520.822 -875.874)",
    fill: "#aeb5b9"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M709.284,1180.607a7.348,7.348,0,0,1-3.322,5.756c-1.831,1.058-3.32.2-3.32-1.921a7.349,7.349,0,0,1,3.32-5.753c1.833-1.059,3.322-.2,3.322,1.917",
    transform: "translate(-523.924 -878.552)",
    fill: "#d4dbdf"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M734.338,1179.822a2.1,2.1,0,0,1-.959,1.656c-.527.306-.959.059-.959-.55a2.122,2.122,0,0,1,.959-1.659c.532-.307.959-.057.959.553",
    transform: "translate(-546.128 -879.224)",
    fill: "#00267e"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M689.131,1204.127a2.122,2.122,0,0,1-.955,1.657c-.533.306-.964.058-.964-.55a2.122,2.122,0,0,1,.96-1.661c.528-.3.959-.055.959.554",
    transform: "translate(-512.419 -897.348)",
    fill: "#00267e"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M700.792,1218.765a2.115,2.115,0,0,1-.955,1.658c-.532.3-.957.056-.957-.552a2.106,2.106,0,0,1,.957-1.659c.526-.3.955-.056.955.554",
    transform: "translate(-521.119 -908.262)",
    fill: "#00267e"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M719.725,1210.1a2.116,2.116,0,0,1-.96,1.656c-.527.307-.954.06-.954-.553a2.12,2.12,0,0,1,.954-1.657c.53-.306.96-.059.96.554",
    transform: "translate(-535.235 -901.798)",
    fill: "#00267e"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M725.407,1161.652a2.125,2.125,0,0,1-.956,1.66c-.528.3-.957.057-.957-.552a2.118,2.118,0,0,1,.957-1.659c.527-.3.956-.059.956.551",
    transform: "translate(-539.473 -865.677)",
    fill: "#00267e"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M701.85,1171.374a2.119,2.119,0,0,1-.957,1.659c-.528.307-.959.057-.959-.553a2.114,2.114,0,0,1,.959-1.658c.527-.3.957-.057.957.552",
    transform: "translate(-521.905 -872.926)",
    fill: "#00267e"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M700.943,1153.574a6.861,6.861,0,0,1,1.515,4.732c0,5.445-3.827,12.071-8.545,14.8-2.257,1.3-4.3,1.466-5.829.7,1.538,1.681,4.11,1.883,7.023.2,4.719-2.725,8.543-9.352,8.543-14.8,0-2.842-1.043-4.792-2.708-5.631",
    transform: "translate(-513.07 -860.162)",
    fill: "#fff"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M716.765,1126.481l-.339,4.2-.387.233-.343-3.808c.175-.111.354-.217.533-.318s.359-.2.536-.3",
    transform: "translate(-533.657 -839.961)",
    fill: "#003f97"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M716.765,1252.217c-.177.11-.358.219-.536.324s-.358.2-.533.3l.338-4.19.392-.229Z",
    transform: "translate(-533.657 -930.883)",
    fill: "#003f97"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M661.965,1221.611v.453l-3.459,2.389c-.005-.2-.012-.4-.012-.615s.007-.409.012-.618Z",
    transform: "translate(-491.005 -910.894)",
    fill: "#003f97"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M766.925,1160.116c0,.211-.005.419-.013.627l-3.462,1.609v-.451l3.462-2.391c.008.2.013.405.013.605",
    transform: "translate(-569.265 -864.589)",
    fill: "#003f97"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M688.7,1154.549l-.343.428-2.027-2.108c.3-.392.608-.774.924-1.146Z",
    transform: "translate(-511.764 -858.781)",
    fill: "#003f97"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M742.317,1229.9c-.3.4-.6.774-.919,1.153l-1.439-2.827.338-.421Z",
    transform: "translate(-551.75 -915.51)",
    fill: "#003f97"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M668.784,1245.059l-2.828,3.97a8.112,8.112,0,0,1-.535-.759l3.173-3.491Z",
    transform: "translate(-496.171 -928.169)",
    fill: "#003f97"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M760.3,1131.546l-3.171,3.5-.2-.278,2.84-3.978a8.454,8.454,0,0,1,.53.759",
    transform: "translate(-564.406 -843.171)",
    fill: "#003f97"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M668.79,1189.558l-.2.5-3.173.167c.167-.456.346-.919.53-1.378Z",
    transform: "translate(-496.171 -886.467)",
    fill: "#003f97"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M760.3,1198.03c-.159.458-.341.919-.533,1.378l-2.832-.7.2-.509Z",
    transform: "translate(-564.406 -893.311)",
    fill: "#003f97"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M688.722,1254.949l-1.446,4.484a7.384,7.384,0,0,1-.917-.087l2.02-4.434Z",
    transform: "translate(-511.783 -935.725)",
    fill: "#003f97"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M742.32,1119.676l-2.02,4.441-.341-.03,1.439-4.5a7.609,7.609,0,0,1,.922.087",
    transform: "translate(-551.75 -834.821)",
    fill: "#003f97"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M643.2,1219.759c0-.2.007-.41.012-.614L638,1216.136c-.01.25-.015.5-.015.75,0,.166,0,.327.005.491l5.223,3.015c-.005-.209-.012-.42-.012-.633",
    transform: "translate(-475.714 -906.812)",
    fill: "#001971"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M692.863,1089.245l5.247,3.03a8.3,8.3,0,0,1,1.033.13l-5.329-3.074a7.9,7.9,0,0,0-.952-.085",
    transform: "translate(-516.633 -812.195)",
    fill: "#001971"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M606.161,1197.754c-.007.166-.017.334-.017.5,0,.253.01.5.018.746l4.921,2.842c0-.187-.013-.379-.013-.575,0-.22.012-.445.018-.667Z",
    transform: "translate(-451.971 -893.105)",
    fill: "#001971"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M618.473,1161.522l-4.981-2.877c-.184.45-.363.905-.525,1.356l4.976,2.873c.166-.453.343-.9.53-1.352",
    transform: "translate(-457.058 -863.943)",
    fill: "#001971"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M633.82,1122.617l5.014,2.9c.3-.388.6-.764.912-1.133l-5.022-2.9c-.306.369-.609.748-.9,1.133",
    transform: "translate(-472.607 -836.234)",
    fill: "#001971"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M618.443,1231.45l-4.753-2.742a8.294,8.294,0,0,0,.608.8l4.66,2.689a7.486,7.486,0,0,1-.515-.745",
    transform: "translate(-457.598 -916.186)",
    fill: "#001971"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M668.676,1099.447c.227-.131.452-.252.679-.373l-5.075-2.928c-.179.094-.354.188-.533.289s-.349.212-.525.319l5.069,2.928c.126-.077.253-.158.386-.235",
    transform: "translate(-494.53 -817.341)",
    fill: "#001971"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M650.784,1180.195l-5.168-2.982c-.187.449-.369.9-.533,1.35l5.173,2.985c.164-.454.34-.9.528-1.354",
    transform: "translate(-481.006 -877.789)",
    fill: "#001971"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M696.2,1115.44c-.106.061-.208.126-.313.193l5.059,2.922c.17-.106.343-.214.513-.314s.363-.2.543-.3l-5.049-2.913c-.252.128-.5.267-.753.411",
    transform: "translate(-518.885 -831.421)",
    fill: "#001971"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M644.549,1246.526a7.667,7.667,0,0,0,.482.724l5.39,3.111a8.456,8.456,0,0,1-.546-.759Z",
    transform: "translate(-480.607 -929.472)",
    fill: "#001971"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M726.613,1108.727l4.789,2.764a8.939,8.939,0,0,1,.949.083l-4.63-2.67a8.04,8.04,0,0,0-1.108-.176",
    transform: "translate(-541.798 -826.722)",
    fill: "#001971"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M666.164,1141.316l5.13,2.962c.295-.385.6-.765.908-1.134l-5.12-2.954c-.313.367-.621.742-.917,1.127",
    transform: "translate(-496.725 -850.182)",
    fill: "#001971"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M713.447,1129.274l1.879-1.885-6-15.43a2.848,2.848,0,0,0-2.143-1.739l-11.37-1.248a6.015,6.015,0,0,0-3.156.82l-10.374,5.989v2.317l10.374-5.99a4.386,4.386,0,0,1,2.131-.553l11.37,1.246a1.873,1.873,0,0,1,1.282,1.044Z",
    transform: "translate(-508.745 -826.894)",
    fill: "#d9e8f9"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    transform: "translate(157.19 272.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 37.073,
    height: 45.626,
    transform: "translate(-8.076 14.057) rotate(-60.122)",
    fill: "url(#linear-gradient-22)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(157.19 279.334)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M634.355,1107.78l-16.349-9.554v2.316l16.349,9.556Z",
    transform: "translate(-618.006 -1098.226)",
    fill: "#d9e8f9"
  }))))), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M586.978,529.366v-6.687a6.07,6.07,0,0,1,2.089-3.6c1.946-1.354,8.109-5.622,10.383-6.933a1.762,1.762,0,0,1,1.729-.185l-1.023-.758a1.675,1.675,0,0,0-1.858.1c-2.269,1.314-8.434,5.585-10.379,6.935a6.061,6.061,0,0,0-2.09,3.6v6.69a1.959,1.959,0,0,0,.656,1.642l1.083.79a2.041,2.041,0,0,1-.59-1.591",
    transform: "translate(-436.823 -381)",
    fill: "#00267e"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M634.049,519.176a1.61,1.61,0,0,1,.283.984,4.212,4.212,0,0,1-1.911,3.308,1.336,1.336,0,0,1-1.348.136c.334.442.935.523,1.625.125a4.229,4.229,0,0,0,1.914-3.313,1.343,1.343,0,0,0-.563-1.239",
    transform: "translate(-470.559 -387.124)",
    fill: "#3273cb"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M630.1,522.537a4.212,4.212,0,0,1,1.916-3.311c.7-.407,1.315-.313,1.646.162-.265-.7-.96-.912-1.793-.434a4.226,4.226,0,0,0-1.908,3.312,1.615,1.615,0,0,0,.258.944,1.9,1.9,0,0,1-.119-.673",
    transform: "translate(-469.728 -386.767)",
    fill: "#00267e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(0 294.082)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M0,1194.432l90.093,51.98,66.173-38.2-90.084-52Z",
    transform: "translate(0 -1156.211)",
    fill: "#438be3"
  }))))), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M238.033,1172.9l-66.175,38.192-9.436-5.387,66.177-38.191Z",
    transform: "translate(-121.11 -870.558)",
    fill: "#4c8de5"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M392.684,1262.009,326.51,1300.2l-9.5-5.483,66.176-38.192Z",
    transform: "translate(-236.376 -936.926)",
    fill: "#4c8de5"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M66.379,1073.633l9.5,5.485L9.7,1117.307l-9.5-5.485Z",
    transform: "translate(-0.151 -800.554)",
    fill: "#4c8de5"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M78.735,1275.843v-6.733l29.883,17.253v6.734Zm-41.2-23.785v-6.736l31.7,18.306v6.729Z",
    transform: "translate(-27.987 -928.574)",
    fill: "#00277f"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M111.82,1173.538l90.084,52V1218.8l-90.084-52Z",
    transform: "translate(-83.378 -870.026)",
    fill: "#00277f"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M222.988,1109.353l90.085,52v-6.734l-90.085-52Z",
    transform: "translate(-166.271 -822.169)",
    fill: "#00277f"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M199.456,1233.647l.016-6.764,66.175-38.192,0,6.733Z",
    transform: "translate(-148.725 -886.348)",
    fill: "#1959b1"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M37.495,1140.119l.019-6.763,66.176-38.193v6.733Z",
    transform: "translate(-27.958 -816.608)",
    fill: "#1959b1"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M354.37,1319.323l9.5-5.484v-6.733l18.892-10.906v6.736l9.5-5.487v-6.734l18.776-10.843v6.734l9.5-5.485V1270.6l-9.5,5.485v1.894l-2.006,1.158v-1.893l-6.445,3.721v1.895l-2.09,1.2v-1.893l-6.447,3.722v1.891l-1.789,1.037v-1.9l-9.5,5.485v1.895l-2.024,1.171v-1.9l-6.448,3.72v1.9l-2.089,1.2v-1.895l-6.446,3.72v1.895l-1.885,1.09v-1.9l-9.5,5.484Z",
    transform: "translate(-264.236 -947.424)",
    fill: "#1959b1"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M.177,1216.311v10.524l90.089,52.006v-10.519Zm50.7,37.9v-6.733l29.883,17.253v6.734Zm-41.2-23.785v-6.736L41.378,1242v6.729Z",
    transform: "translate(-0.132 -906.942)",
    fill: "#004098"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M.177,1256.958l90.089,52.006v-.239L.177,1256.709Z",
    transform: "translate(-0.132 -937.065)",
    fill: "#00277f"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M222.988,1087.724l90.085,52v1.894l-90.085-52Z",
    transform: "translate(-166.271 -811.062)",
    fill: "#004098"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M189.762,1106.907l90.085,52v1.894l-90.085-52Z",
    transform: "translate(-141.496 -825.366)",
    fill: "#004098"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M156.221,1126.286l90.08,52v1.891l-90.08-52Z",
    transform: "translate(-116.486 -839.815)",
    fill: "#004098"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M111.82,1151.911l90.084,52v1.894l-90.084-52Z",
    transform: "translate(-83.378 -858.922)",
    fill: "#004098"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M78.517,1171.136l90.083,52v2.155l-90.083-52.26Z",
    transform: "translate(-58.546 -873.257)",
    fill: "#004098"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M44.971,1190.511l90.081,52v1.894l-90.081-52Z",
    transform: "translate(-33.532 -887.704)",
    fill: "#004098"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M9.7,1194.785l90.081,52-9.5,5.487-90.083-52Z",
    transform: "translate(-0.152 -890.891)",
    fill: "#4c8de5"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M232.493,1066.159l90.083,52-9.5,5.484-90.085-52Z",
    transform: "translate(-166.271 -794.981)",
    fill: "#4c8de5"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M196.2,1092.285l90.087,52-6.445,3.721-90.085-52Z",
    transform: "translate(-141.496 -814.462)",
    fill: "#4c8de5"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M162.664,1111.647l90.084,52-6.447,3.722-90.08-52Z",
    transform: "translate(-116.486 -828.899)",
    fill: "#4c8de5"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M121.32,1130.345l90.085,52-9.5,5.485-90.084-52Z",
    transform: "translate(-83.378 -842.841)",
    fill: "#4c8de5"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M84.962,1156.51l90.086,52-6.448,3.72-90.082-52Z",
    transform: "translate(-58.547 -862.352)",
    fill: "#4c8de5"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M51.416,1175.879l90.081,52-6.446,3.72-90.08-52Z",
    transform: "translate(-33.533 -876.794)",
    fill: "#4c8de5"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M363.869,1439.492l-9.5,5.488v.277l9.5-5.484Z",
    transform: "translate(-264.236 -1073.357)",
    fill: "#00277f"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M577.163,1316.615l9.5-5.485v-.284l-9.5,5.492Z",
    transform: "translate(-430.361 -977.432)",
    fill: "#00277f"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M475.493,1375.055l-9.5,5.486v.281l9.5-5.487Z",
    transform: "translate(-347.467 -1025.309)",
    fill: "#00277f"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M145.212,1033.46l27.327,15.761v28.6l-27.327-15.759Z",
    transform: "translate(-108.277 -770.599)",
    fill: "#c6dcf7"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M283.641,1025.075v28.6l-30.989,17.892v-28.6Z",
    transform: "translate(-188.389 -764.347)",
    fill: "#d9e8f9"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M172.813,996.25l-27.234-15.706L176.485,962.7l27.228,15.707Z",
    transform: "translate(-108.551 -717.839)",
    fill: "#fff"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M145.3,1032.848l27.234,15.706v.211L145.211,1033Z",
    transform: "translate(-108.277 -770.143)",
    fill: "#d9e8f9"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M283.55,1024.456l.09.157-30.989,17.894v-.211Z",
    transform: "translate(-188.389 -763.886)",
    fill: "#eaffff"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M199.483,1011.867l30.992-17.891-2.751-1.587-30.993,17.891Z",
    transform: "translate(-146.693 -739.975)",
    fill: "#e6f5ff"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M199.48,1069.481l0-5.158-2.752-1.592v5.163Z",
    transform: "translate(-146.693 -792.426)",
    fill: "#d9e8f9"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M20.1,1104.492l27.322,15.76v28.6L20.1,1133.09Z",
    transform: "translate(-14.99 -823.564)",
    fill: "#c6dcf7"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M158.521,1096.1l0,28.6L127.531,1142.6V1114Z",
    transform: "translate(-95.093 -817.309)",
    fill: "#d9e8f9"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M47.7,1067.273l-27.233-15.7,30.9-17.841L78.6,1049.433Z",
    transform: "translate(-15.259 -770.799)",
    fill: "#fff"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M20.2,1103.87l27.233,15.705v.213l-27.322-15.76Z",
    transform: "translate(-14.996 -823.101)",
    fill: "#d9e8f9"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M158.431,1095.475l.091.16-30.99,17.893v-.213Z",
    transform: "translate(-95.094 -816.841)",
    fill: "#eaffff"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M74.359,1082.885l30.989-17.892L102.6,1063.4,71.607,1081.3Z",
    transform: "translate(-53.393 -792.927)",
    fill: "#e6f5ff"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M74.356,1140.514l0-5.158-2.752-1.586v5.157Z",
    transform: "translate(-53.393 -845.395)",
    fill: "#d9e8f9"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M256.534,1097.946l27.32,15.763v28.6l-27.322-15.757Z",
    transform: "translate(-191.283 -818.683)",
    fill: "#c6dcf7"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M394.942,1089.56v28.6l-30.993,17.888v-28.6Z",
    transform: "translate(-271.378 -812.43)",
    fill: "#d9e8f9"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M284.122,1060.733l-27.23-15.709,30.9-17.84,27.231,15.706Z",
    transform: "translate(-191.552 -765.92)",
    fill: "#fff"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M256.63,1097.324l27.23,15.709v.212l-27.32-15.763Z",
    transform: "translate(-191.289 -818.219)",
    fill: "#d9e8f9"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M394.85,1088.935l.092.159-30.993,17.9v-.212Z",
    transform: "translate(-271.378 -811.964)",
    fill: "#eaffff"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M310.793,1076.356l30.989-17.894-2.752-1.584-30.989,17.891Z",
    transform: "translate(-229.69 -788.061)",
    fill: "#e6f5ff"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M310.789,1133.971l0-5.158-2.752-1.59v5.161Z",
    transform: "translate(-229.69 -840.514)",
    fill: "#d9e8f9"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M131.409,1168.968l27.32,15.762v28.6L131.4,1197.57Z",
    transform: "translate(-97.982 -871.641)",
    fill: "#c6dcf7"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M269.824,1160.582v28.6l-30.993,17.892v-28.6Z",
    transform: "translate(-178.084 -865.388)",
    fill: "#d9e8f9"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M159,1131.762l-27.232-15.707,30.9-17.838,27.233,15.706Z",
    transform: "translate(-98.252 -818.885)",
    fill: "#fff"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M131.509,1168.349l27.232,15.707v.212l-27.32-15.762Z",
    transform: "translate(-97.994 -871.18)",
    fill: "#d9e8f9"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M269.733,1159.964l.091.157-30.993,17.895v-.212Z",
    transform: "translate(-178.084 -864.927)",
    fill: "#eaffff"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M185.672,1147.372l30.989-17.891-2.748-1.591-30.993,17.893Z",
    transform: "translate(-136.394 -841.011)",
    fill: "#e6f5ff"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M185.672,1204.988v-5.159l-2.752-1.59v5.163Z",
    transform: "translate(-136.394 -893.467)",
    fill: "#d9e8f9"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M369.476,1163.6l27.32,15.762v28.6l-27.323-15.759Z",
    transform: "translate(-275.497 -867.641)",
    fill: "#c6dcf7"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M507.888,1155.228l0,28.6L476.9,1201.719v-28.6Z",
    transform: "translate(-355.597 -861.395)",
    fill: "#d9e8f9"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M397.069,1126.391l-27.23-15.706,30.9-17.843,27.23,15.71Z",
    transform: "translate(-275.77 -814.877)",
    fill: "#fff"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M369.576,1162.991l27.23,15.706v.211l-27.32-15.762Z",
    transform: "translate(-275.507 -867.184)",
    fill: "#d9e8f9"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M507.8,1154.606l.093.158L476.9,1172.656v-.211Z",
    transform: "translate(-355.597 -860.932)",
    fill: "#eaffff"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M487.535,1302.551v-.145l.137-.08v.143a.97.97,0,0,1,1.289.123.227.227,0,0,0-.2.031.664.664,0,0,0-.292.422c-.034-.126-.152-.168-.289-.086a.663.663,0,0,0-.291.421c-.034-.129-.151-.166-.29-.087a.682.682,0,0,0-.292.421c-.035-.125-.151-.166-.285-.087a.667.667,0,0,0-.293.423c-.035-.125-.152-.166-.294-.088a.61.61,0,0,0-.191.194,3.5,3.5,0,0,1,1.287-1.607",
    transform: "translate(-362.57 -971.052)",
    fill: "#0540ac"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M491.444,1309.542l-.137.078v-2.833l.137-.074Z",
    transform: "translate(-366.342 -974.35)",
    fill: "#0540ac"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M491.765,1317.235a.713.713,0,0,0,.322-.561l.137-.075a1.025,1.025,0,0,1-.458.794c-.251.144-.458.024-.458-.266l.137-.08c0,.207.145.29.321.189",
    transform: "translate(-366.343 -981.721)",
    fill: "#0540ac"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M507.68,1290.016v1.565a2.145,2.145,0,0,1-.968,1.674c-.533.306-.965.056-.965-.56v-1.562Z",
    transform: "translate(-377.11 -961.9)",
    fill: "#0540ac"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M506.591,1304.827v-1.4l.225-.127v1.391l.215-.123.649-.2v.133l-1.933,1.114v-.131l.645-.548Z",
    transform: "translate(-377.11 -971.808)",
    fill: "#0540ac"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M524.3,1295.283v.413l-2.875,1.659v-.416Z",
    transform: "translate(-388.801 -965.828)",
    fill: "#0540ac"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M523.391,1287.521l-.374.22v-2.849l-.23.132.416-1.405.428.918-.24.135Z",
    transform: "translate(-389.815 -957.131)",
    fill: "#0540ac"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M528.523,1284.554l-.375.219,0-2.848-.229.132.42-1.4.425.917-.237.139Z",
    transform: "translate(-393.639 -954.917)",
    fill: "#0540ac"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M484.045,1298.176l3.831-2.212v5.517l-3.831,2.208Zm3.728-2.01-3.628,2.095v5.23l3.628-2.1Z",
    transform: "translate(-360.928 -966.335)",
    fill: "#0540ac"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M502.023,1287.806l3.831-2.213v5.514l-3.831,2.213Zm3.727-2.014-3.63,2.1v5.23l3.63-2.1Z",
    transform: "translate(-374.333 -958.602)",
    fill: "#0540ac"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M519.555,1277.675l3.832-2.213v5.516l-3.832,2.214Zm3.73-2.012-3.627,2.095v5.231l3.627-2.095Z",
    transform: "translate(-387.406 -951.048)",
    fill: "#0540ac"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M423.738,1142.009l30.99-17.892-2.75-1.588-30.99,17.893Z",
    transform: "translate(-313.909 -837.013)",
    fill: "#e6f5ff"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M423.738,1199.634v-5.158l-2.751-1.589v5.159Z",
    transform: "translate(-313.909 -889.476)",
    fill: "#d9e8f9"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M244.355,1233.763l27.321,15.762v28.6l-27.323-15.758Z",
    transform: "translate(-182.201 -919.955)",
    fill: "#c6dcf7"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M382.767,1225.377l.005,28.6-31,17.891v-28.6Z",
    transform: "translate(-262.301 -913.702)",
    fill: "#d9e8f9"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M271.956,1196.549l-27.228-15.706,30.9-17.842,27.231,15.709Z",
    transform: "translate(-182.482 -867.191)",
    fill: "#fff"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M244.455,1233.148l27.227,15.706v.212L244.362,1233.3Z",
    transform: "translate(-182.209 -919.496)",
    fill: "#d9e8f9"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M382.677,1224.762l.091.156-30.991,17.895v-.212Z",
    transform: "translate(-262.301 -913.244)",
    fill: "#eaffff"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M362.414,1372.7v-.146l.135-.076v.144a.968.968,0,0,1,1.288.122.221.221,0,0,0-.194.032.661.661,0,0,0-.289.422c-.037-.126-.154-.17-.291-.089a.687.687,0,0,0-.293.426c-.037-.132-.15-.169-.292-.09a.694.694,0,0,0-.288.424c-.035-.126-.153-.168-.29-.088a.683.683,0,0,0-.291.423c-.036-.126-.154-.166-.292-.086a.6.6,0,0,0-.191.193,3.515,3.515,0,0,1,1.288-1.612",
    transform: "translate(-269.273 -1023.362)",
    fill: "#0540ac"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M366.327,1379.694l-.135.077v-2.829l.135-.08Z",
    transform: "translate(-273.051 -1026.657)",
    fill: "#0540ac"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M366.649,1387.382a.728.728,0,0,0,.325-.562l.132-.076a1.014,1.014,0,0,1-.457.792c-.256.149-.458.031-.458-.261l.136-.083c0,.209.145.292.323.19",
    transform: "translate(-273.05 -1034.025)",
    fill: "#0540ac"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M382.552,1360.172v1.564a2.127,2.127,0,0,1-.965,1.672c-.532.309-.967.058-.967-.555v-1.565Z",
    transform: "translate(-283.809 -1014.212)",
    fill: "#0540ac"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M381.464,1374.979v-1.4l.225-.127v1.393l.213-.124.65-.2v.13l-1.932,1.117v-.131l.648-.551Z",
    transform: "translate(-283.809 -1024.118)",
    fill: "#0540ac"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M399.2,1365.439v.412l-2.873,1.658v-.412Z",
    transform: "translate(-295.52 -1018.14)",
    fill: "#0540ac"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M398.277,1357.677l-.376.216v-2.847l-.229.133.417-1.406.425.916-.237.138Z",
    transform: "translate(-296.523 -1009.44)",
    fill: "#0540ac"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M403.4,1354.706l-.383.216v-2.848l-.23.136.422-1.407.421.919-.23.136Z",
    transform: "translate(-300.341 -1007.226)",
    fill: "#0540ac"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M358.924,1368.324l3.83-2.215v5.518l-3.83,2.212Zm3.728-2.009-3.627,2.093v5.229l3.627-2.094Z",
    transform: "translate(-267.631 -1018.639)",
    fill: "#0540ac"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M376.888,1357.948l3.834-2.216v5.52l-3.834,2.211Zm3.731-2.012-3.629,2.094v5.232l3.629-2.1Z",
    transform: "translate(-281.026 -1010.901)",
    fill: "#0540ac"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M394.431,1347.83l3.833-2.21v5.515l-3.833,2.212Zm3.732-2.011-3.626,2.1v5.23l3.626-2.092Z",
    transform: "translate(-294.107 -1003.361)",
    fill: "#0540ac"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M298.618,1212.159l30.989-17.891-2.752-1.59-30.989,17.9Z",
    transform: "translate(-220.613 -889.32)",
    fill: "#e6f5ff"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M298.618,1269.79v-5.156l-2.752-1.591v5.163Z",
    transform: "translate(-220.613 -941.788)",
    fill: "#d9e8f9"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M145.212,915.95l27.327,15.76v28.6L145.212,944.55Z",
    transform: "translate(-108.277 -682.978)",
    fill: "#c6dcf7"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M283.641,907.562v28.6l-30.989,17.895v-28.6Z",
    transform: "translate(-188.389 -676.724)",
    fill: "#d9e8f9"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M172.813,878.736l-27.234-15.709,30.905-17.841,27.228,15.708Z",
    transform: "translate(-108.551 -630.213)",
    fill: "#fff"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M145.3,915.329l27.234,15.709v.208l-27.327-15.759Z",
    transform: "translate(-108.277 -682.515)",
    fill: "#d9e8f9"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M283.55,906.943l.09.157-30.989,17.893v-.209Z",
    transform: "translate(-188.389 -676.262)",
    fill: "#eaffff"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M199.483,894.345l30.992-17.891-2.751-1.588-30.993,17.9Z",
    transform: "translate(-146.693 -652.344)",
    fill: "#e6f5ff"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M199.48,951.978l0-5.158-2.752-1.586v5.158Z",
    transform: "translate(-146.693 -704.813)",
    fill: "#d9e8f9"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M20.1,986.976l27.322,15.759v28.6L20.1,1015.572Z",
    transform: "translate(-14.99 -735.939)",
    fill: "#c6dcf7"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M158.521,978.593l0,28.6-30.993,17.893v-28.6Z",
    transform: "translate(-95.093 -729.688)",
    fill: "#d9e8f9"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M47.7,949.756,20.464,934.05l30.9-17.843L78.6,931.915Z",
    transform: "translate(-15.259 -683.17)",
    fill: "#fff"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M20.2,986.357l27.233,15.706v.21L20.111,986.515Z",
    transform: "translate(-14.996 -735.477)",
    fill: "#d9e8f9"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M158.431,977.962l.091.161-30.99,17.891v-.21Z",
    transform: "translate(-95.094 -729.217)",
    fill: "#eaffff"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M74.359,965.367l30.989-17.893-2.752-1.589-30.989,17.9Z",
    transform: "translate(-53.393 -705.299)",
    fill: "#e6f5ff"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M74.356,1023l0-5.158-2.752-1.586v5.158Z",
    transform: "translate(-53.393 -757.771)",
    fill: "#d9e8f9"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M256.534,980.433l27.32,15.759v28.6l-27.322-15.758Z",
    transform: "translate(-191.283 -731.06)",
    fill: "#c6dcf7"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M394.942,972.051v28.6l-30.993,17.894v-28.6Z",
    transform: "translate(-271.378 -724.81)",
    fill: "#d9e8f9"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M284.122,943.215l-27.23-15.7,30.9-17.842,27.231,15.71Z",
    transform: "translate(-191.552 -678.294)",
    fill: "#fff"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M256.63,979.814l27.23,15.7v.211l-27.32-15.759Z",
    transform: "translate(-191.289 -730.599)",
    fill: "#d9e8f9"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M394.85,971.435l.092.156-30.993,17.891v-.211Z",
    transform: "translate(-271.378 -724.351)",
    fill: "#eaffff"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M310.793,958.838l30.989-17.892-2.752-1.588-30.989,17.895Z",
    transform: "translate(-229.69 -700.433)",
    fill: "#e6f5ff"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M310.789,1016.461l0-5.158-2.752-1.586v5.156Z",
    transform: "translate(-229.69 -752.895)",
    fill: "#d9e8f9"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M131.409,1051.458l27.32,15.76v28.6L131.4,1080.056Z",
    transform: "translate(-97.982 -784.02)",
    fill: "#c6dcf7"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M269.824,1043.079v28.6l-30.993,17.893v-28.6Z",
    transform: "translate(-178.084 -777.772)",
    fill: "#d9e8f9"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M159,1014.241l-27.232-15.7,30.9-17.844L189.9,996.4Z",
    transform: "translate(-98.252 -731.254)",
    fill: "#fff"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M131.509,1050.846l27.232,15.7v.211L131.421,1051Z",
    transform: "translate(-97.994 -783.563)",
    fill: "#d9e8f9"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M269.733,1042.441l.091.162-30.993,17.891v-.211Z",
    transform: "translate(-178.084 -777.296)",
    fill: "#eaffff"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M185.672,1029.858l30.989-17.892-2.748-1.589L182.92,1028.27Z",
    transform: "translate(-136.394 -753.388)",
    fill: "#e6f5ff"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M185.672,1087.484v-5.157l-2.752-1.588v5.158Z",
    transform: "translate(-136.394 -805.853)",
    fill: "#d9e8f9"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M369.476,1046.093l27.32,15.762v28.6l-27.323-15.76Z",
    transform: "translate(-275.497 -780.019)",
    fill: "#c6dcf7"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M507.888,1037.711l0,28.6L476.9,1084.205v-28.6Z",
    transform: "translate(-355.597 -773.769)",
    fill: "#d9e8f9"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M397.069,1008.879l-27.23-15.706,30.9-17.843,27.23,15.709Z",
    transform: "translate(-275.77 -727.254)",
    fill: "#fff"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M369.576,1045.482l27.23,15.707v.211l-27.32-15.762Z",
    transform: "translate(-275.507 -779.563)",
    fill: "#d9e8f9"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M507.8,1037.09l.093.158L476.9,1055.142v-.211Z",
    transform: "translate(-355.597 -773.306)",
    fill: "#eaffff"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M487.535,1185.039v-.145l.137-.078v.143a.968.968,0,0,1,1.289.123.218.218,0,0,0-.2.03.678.678,0,0,0-.292.423c-.034-.128-.152-.167-.289-.09a.682.682,0,0,0-.291.422c-.034-.127-.151-.166-.29-.085a.68.68,0,0,0-.292.419c-.035-.125-.151-.165-.285-.083a.656.656,0,0,0-.293.421c-.035-.127-.152-.166-.294-.089a.589.589,0,0,0-.191.2,3.509,3.509,0,0,1,1.287-1.608",
    transform: "translate(-362.57 -883.43)",
    fill: "#0540ac"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M491.444,1192.021l-.137.078v-2.83l.137-.079Z",
    transform: "translate(-366.342 -886.719)",
    fill: "#0540ac"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M491.765,1199.722a.717.717,0,0,0,.322-.56l.137-.077a1.022,1.022,0,0,1-.458.792c-.251.146-.458.025-.458-.264l.137-.08c0,.2.145.29.321.188",
    transform: "translate(-366.343 -894.098)",
    fill: "#0540ac"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M507.68,1172.506v1.562a2.137,2.137,0,0,1-.968,1.674c-.533.306-.965.059-.965-.558v-1.563Z",
    transform: "translate(-377.11 -874.279)",
    fill: "#0540ac"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M506.591,1187.3v-1.394l.225-.13v1.394l.215-.123.649-.2v.129l-1.933,1.115v-.128l.645-.552Z",
    transform: "translate(-377.11 -884.177)",
    fill: "#0540ac"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M524.3,1177.764v.414l-2.875,1.658v-.413Z",
    transform: "translate(-388.801 -878.199)",
    fill: "#0540ac"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M523.391,1170.007l-.374.217v-2.849l-.23.134.416-1.405.428.917-.24.137Z",
    transform: "translate(-389.815 -869.505)",
    fill: "#0540ac"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M528.523,1167.041l-.375.216,0-2.848-.229.134.42-1.4.425.917-.237.137Z",
    transform: "translate(-393.639 -867.293)",
    fill: "#0540ac"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M484.045,1180.661l3.831-2.213v5.518l-3.831,2.215Zm3.728-2.01-3.628,2.094v5.229l3.628-2.094Z",
    transform: "translate(-360.928 -878.709)",
    fill: "#0540ac"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M502.023,1170.284l3.831-2.212v5.515l-3.831,2.214Zm3.727-2.009-3.63,2.1v5.226l3.63-2.093Z",
    transform: "translate(-374.333 -870.973)",
    fill: "#0540ac"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M519.555,1160.158l3.832-2.213v5.516l-3.832,2.213Zm3.73-2.013-3.627,2.1v5.23l3.627-2.091Z",
    transform: "translate(-387.406 -863.421)",
    fill: "#0540ac"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M423.738,1024.505l30.99-17.892-2.75-1.584-30.99,17.891Z",
    transform: "translate(-313.909 -749.4)",
    fill: "#e6f5ff"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M423.738,1082.122v-5.155l-2.751-1.59v5.161Z",
    transform: "translate(-313.909 -801.855)",
    fill: "#d9e8f9"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M244.355,1116.25l27.321,15.761v28.6l-27.323-15.757Z",
    transform: "translate(-182.201 -832.331)",
    fill: "#c6dcf7"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M382.767,1107.868l.005,28.6-31,17.891v-28.6Z",
    transform: "translate(-262.301 -826.081)",
    fill: "#d9e8f9"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M271.956,1079.035l-27.228-15.709,30.9-17.841,27.231,15.71Z",
    transform: "translate(-182.482 -779.566)",
    fill: "#fff"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M244.455,1115.628l27.227,15.709v.21l-27.321-15.761Z",
    transform: "translate(-182.209 -831.868)",
    fill: "#d9e8f9"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M382.677,1107.252l.091.156L351.776,1125.3v-.21Z",
    transform: "translate(-262.301 -825.623)",
    fill: "#eaffff"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M362.414,1255.193v-.144l.135-.078v.144a.968.968,0,0,1,1.288.124.214.214,0,0,0-.194.03.656.656,0,0,0-.289.423c-.037-.127-.154-.17-.291-.089a.689.689,0,0,0-.293.422c-.037-.127-.15-.167-.292-.088a.692.692,0,0,0-.288.421c-.035-.127-.153-.167-.29-.085a.668.668,0,0,0-.291.422c-.036-.126-.154-.167-.292-.088a.577.577,0,0,0-.191.2,3.5,3.5,0,0,1,1.288-1.612",
    transform: "translate(-269.273 -935.742)",
    fill: "#0540ac"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M366.327,1262.181l-.135.079v-2.831l.135-.077Z",
    transform: "translate(-273.051 -939.036)",
    fill: "#0540ac"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M366.649,1269.871a.717.717,0,0,0,.325-.557l.132-.079a1.014,1.014,0,0,1-.457.791c-.256.148-.458.029-.458-.262l.136-.079c0,.207.145.291.323.187",
    transform: "translate(-273.05 -946.405)",
    fill: "#0540ac"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M382.552,1242.653v1.567a2.134,2.134,0,0,1-.965,1.673c-.532.306-.967.055-.967-.558v-1.563Z",
    transform: "translate(-283.809 -926.584)",
    fill: "#0540ac"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M381.464,1257.469v-1.4l.225-.126v1.391l.213-.125.65-.2v.134l-1.932,1.114v-.131l.648-.549Z",
    transform: "translate(-283.809 -936.497)",
    fill: "#0540ac"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M399.2,1247.91v.417l-2.873,1.656v-.411Z",
    transform: "translate(-295.52 -930.504)",
    fill: "#0540ac"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M398.277,1240.159l-.376.217v-2.847l-.229.134.417-1.407.425.917-.237.137Z",
    transform: "translate(-296.523 -921.814)",
    fill: "#0540ac"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M403.4,1237.193l-.383.218v-2.847l-.23.133.422-1.406.421.917-.23.137Z",
    transform: "translate(-300.341 -919.603)",
    fill: "#0540ac"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M358.924,1250.82l3.83-2.211v5.515l-3.83,2.211Zm3.728-2.011-3.627,2.1v5.229l3.627-2.094Z",
    transform: "translate(-267.631 -931.025)",
    fill: "#0540ac"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M376.888,1240.443l3.834-2.211v5.516l-3.834,2.212Zm3.731-2.009-3.629,2.094v5.23l3.629-2.1Z",
    transform: "translate(-281.026 -923.288)",
    fill: "#0540ac"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M394.431,1230.311l3.833-2.213v5.518l-3.833,2.211Zm3.732-2.01-3.626,2.094v5.23l3.626-2.093Z",
    transform: "translate(-294.107 -915.731)",
    fill: "#0540ac"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M298.618,1094.649l30.989-17.893-2.752-1.591-30.989,17.9Z",
    transform: "translate(-220.613 -801.697)",
    fill: "#e6f5ff"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M298.618,1152.277v-5.158l-2.752-1.588v5.16Z",
    transform: "translate(-220.613 -854.165)",
    fill: "#d9e8f9"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M145.212,799.5l27.327,15.757v28.6L145.212,828.1Z",
    transform: "translate(-108.277 -596.149)",
    fill: "#c6dcf7"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M283.641,791.113v28.6l-30.989,17.895V809Z",
    transform: "translate(-188.389 -589.894)",
    fill: "#d9e8f9"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M172.813,762.283l-27.234-15.7,30.905-17.843,27.228,15.706Z",
    transform: "translate(-108.551 -543.383)",
    fill: "#fff"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M145.3,798.89l27.234,15.7v.21l-27.327-15.757Z",
    transform: "translate(-108.277 -595.692)",
    fill: "#d9e8f9"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M283.55,790.485l.09.16-30.989,17.891v-.21Z",
    transform: "translate(-188.389 -589.425)",
    fill: "#eaffff"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M199.483,777.9l30.992-17.892-2.751-1.587-30.993,17.893Z",
    transform: "translate(-146.693 -565.517)",
    fill: "#e6f5ff"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M199.48,835.523l0-5.16-2.752-1.587v5.159Z",
    transform: "translate(-146.693 -617.977)",
    fill: "#d9e8f9"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M20.1,870.524l27.322,15.759v28.6L20.1,899.122Z",
    transform: "translate(-14.99 -649.106)",
    fill: "#c6dcf7"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M158.521,862.132l0,28.6-30.993,17.892v-28.6Z",
    transform: "translate(-95.093 -642.849)",
    fill: "#d9e8f9"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M47.7,833.3,20.464,817.6l30.9-17.84L78.6,815.463Z",
    transform: "translate(-15.259 -596.338)",
    fill: "#fff"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M20.2,869.9,47.433,885.6v.212L20.111,870.056Z",
    transform: "translate(-14.996 -648.638)",
    fill: "#d9e8f9"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M158.431,861.51l.091.158-30.99,17.893v-.212Z",
    transform: "translate(-95.094 -642.385)",
    fill: "#eaffff"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M74.359,848.918l30.989-17.889L102.6,829.44,71.607,847.334Z",
    transform: "translate(-53.393 -618.472)",
    fill: "#e6f5ff"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M74.356,906.546l0-5.156L71.606,899.8v5.158Z",
    transform: "translate(-53.393 -670.937)",
    fill: "#d9e8f9"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M256.534,863.981l27.32,15.76v28.6l-27.322-15.76Z",
    transform: "translate(-191.283 -644.228)",
    fill: "#c6dcf7"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M394.942,855.605v28.6L363.949,902.1V873.5Z",
    transform: "translate(-271.378 -637.982)",
    fill: "#d9e8f9"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M284.122,826.772l-27.23-15.7,30.9-17.841,27.231,15.7Z",
    transform: "translate(-191.552 -591.469)",
    fill: "#fff"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M256.63,863.369l27.23,15.7v.211l-27.32-15.76Z",
    transform: "translate(-191.289 -643.771)",
    fill: "#d9e8f9"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M394.85,854.967l.092.162L363.949,873.02v-.211Z",
    transform: "translate(-271.378 -637.506)",
    fill: "#eaffff"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M310.793,842.385l30.989-17.892L339.03,822.9l-30.989,17.9Z",
    transform: "translate(-229.69 -613.598)",
    fill: "#e6f5ff"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M310.789,900.008l0-5.159-2.752-1.588v5.159Z",
    transform: "translate(-229.69 -666.06)",
    fill: "#d9e8f9"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M131.409,935l27.32,15.762v28.6L131.4,963.6Z",
    transform: "translate(-97.982 -697.185)",
    fill: "#c6dcf7"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M269.824,926.621v28.6l-30.993,17.895v-28.6Z",
    transform: "translate(-178.084 -690.935)",
    fill: "#d9e8f9"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M159,897.792l-27.232-15.707,30.9-17.84L189.9,879.952Z",
    transform: "translate(-98.252 -644.424)",
    fill: "#fff"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M131.509,934.385l27.232,15.707v.212l-27.32-15.762Z",
    transform: "translate(-97.994 -696.724)",
    fill: "#d9e8f9"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M269.733,926l.091.158-30.993,17.894v-.212Z",
    transform: "translate(-178.084 -690.471)",
    fill: "#eaffff"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M185.672,913.407l30.989-17.892-2.748-1.587L182.92,911.82Z",
    transform: "translate(-136.394 -666.558)",
    fill: "#e6f5ff"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M185.672,971.031v-5.156l-2.752-1.589v5.157Z",
    transform: "translate(-136.394 -719.02)",
    fill: "#d9e8f9"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M369.476,929.638,396.8,945.4V974l-27.323-15.76Z",
    transform: "translate(-275.497 -693.185)",
    fill: "#c6dcf7"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M507.888,921.256l0,28.6L476.9,967.75v-28.6Z",
    transform: "translate(-355.597 -686.935)",
    fill: "#d9e8f9"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M397.069,892.431l-27.23-15.706,30.9-17.841,27.23,15.709Z",
    transform: "translate(-275.77 -640.427)",
    fill: "#fff"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M369.576,929.026l27.23,15.707v.212l-27.32-15.763Z",
    transform: "translate(-275.507 -692.729)",
    fill: "#d9e8f9"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M507.8,920.644l.093.156L476.9,938.695v-.212Z",
    transform: "translate(-355.597 -686.478)",
    fill: "#eaffff"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M487.535,1068.588v-.143l.137-.078v.144a.973.973,0,0,1,1.289.124.211.211,0,0,0-.2.028.676.676,0,0,0-.292.422c-.034-.126-.152-.166-.289-.086a.678.678,0,0,0-.291.423c-.034-.127-.151-.168-.29-.089a.679.679,0,0,0-.292.423c-.035-.127-.151-.167-.285-.084a.646.646,0,0,0-.293.421c-.035-.127-.152-.169-.294-.089a.63.63,0,0,0-.191.193,3.527,3.527,0,0,1,1.287-1.609",
    transform: "translate(-362.57 -796.602)",
    fill: "#0540ac"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M491.444,1075.58l-.137.08v-2.833l.137-.075Z",
    transform: "translate(-366.342 -799.896)",
    fill: "#0540ac"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M491.765,1083.263a.709.709,0,0,0,.322-.559l.137-.077a1.018,1.018,0,0,1-.458.792c-.251.147-.458.029-.458-.262l.137-.081c0,.209.145.29.321.187",
    transform: "translate(-366.343 -807.261)",
    fill: "#0540ac"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M507.68,1056.054v1.565a2.141,2.141,0,0,1-.968,1.672c-.533.307-.965.055-.965-.558v-1.563Z",
    transform: "translate(-377.11 -787.446)",
    fill: "#0540ac"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M506.591,1070.851v-1.394l.225-.131v1.4l.215-.129.649-.2v.134l-1.933,1.112v-.132l.645-.548Z",
    transform: "translate(-377.11 -797.343)",
    fill: "#0540ac"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M524.3,1061.308v.416l-2.875,1.657v-.414Z",
    transform: "translate(-388.801 -791.365)",
    fill: "#0540ac"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M523.391,1053.552l-.374.219v-2.85l-.23.132.416-1.405.428.919-.24.137Z",
    transform: "translate(-389.815 -782.67)",
    fill: "#0540ac"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M528.523,1050.59l-.375.217,0-2.846-.229.133.42-1.4.425.916-.237.139Z",
    transform: "translate(-393.639 -780.464)",
    fill: "#0540ac"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M484.045,1064.206l3.831-2.214v5.519l-3.831,2.21Zm3.728-2.012-3.628,2.1v5.23l3.628-2.1Z",
    transform: "translate(-360.928 -791.874)",
    fill: "#0540ac"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M502.023,1053.829l3.831-2.212v5.516l-3.831,2.214Zm3.727-2.009-3.63,2.1v5.23l3.63-2.1Z",
    transform: "translate(-374.333 -784.138)",
    fill: "#0540ac"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M519.555,1043.708l3.832-2.212v5.515l-3.832,2.214Zm3.73-2.012-3.627,2.1v5.229l3.627-2.1Z",
    transform: "translate(-387.406 -776.592)",
    fill: "#0540ac"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M423.738,908.049l30.99-17.894-2.75-1.587-30.99,17.893Z",
    transform: "translate(-313.909 -662.56)",
    fill: "#e6f5ff"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M423.738,965.673v-5.16l-2.751-1.587v5.158Z",
    transform: "translate(-313.909 -715.023)",
    fill: "#d9e8f9"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M244.355,999.8l27.321,15.759v28.6l-27.323-15.76Z",
    transform: "translate(-182.201 -745.502)",
    fill: "#c6dcf7"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M382.767,991.413l.005,28.6-31,17.895v-28.6Z",
    transform: "translate(-262.301 -739.247)",
    fill: "#d9e8f9"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M271.956,962.59l-27.228-15.706,30.9-17.841,27.231,15.706Z",
    transform: "translate(-182.482 -692.741)",
    fill: "#fff"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M244.455,999.186l27.227,15.706v.21l-27.321-15.759Z",
    transform: "translate(-182.209 -745.043)",
    fill: "#d9e8f9"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M382.677,990.791l.091.158-30.991,17.892v-.21Z",
    transform: "translate(-262.301 -738.783)",
    fill: "#eaffff"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M362.414,1138.736v-.145l.135-.077v.143a.969.969,0,0,1,1.288.122.231.231,0,0,0-.194.03.676.676,0,0,0-.289.425c-.037-.128-.154-.167-.291-.088a.684.684,0,0,0-.293.421c-.037-.125-.15-.166-.292-.086a.689.689,0,0,0-.288.423c-.035-.127-.153-.166-.29-.09a.68.68,0,0,0-.291.426c-.036-.127-.154-.166-.292-.086a.588.588,0,0,0-.191.191,3.509,3.509,0,0,1,1.288-1.609",
    transform: "translate(-269.273 -848.905)",
    fill: "#0540ac"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M366.327,1145.733l-.135.075v-2.828l.135-.076Z",
    transform: "translate(-273.051 -852.206)",
    fill: "#0540ac"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M366.649,1153.417a.72.72,0,0,0,.325-.558l.132-.079a1.015,1.015,0,0,1-.457.792c-.256.146-.458.027-.458-.262l.136-.08c0,.209.145.291.323.187",
    transform: "translate(-273.05 -859.57)",
    fill: "#0540ac"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M382.552,1126.2v1.563a2.126,2.126,0,0,1-.965,1.673c-.532.31-.967.059-.967-.557v-1.564Z",
    transform: "translate(-283.809 -839.752)",
    fill: "#0540ac"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M381.464,1141.012v-1.394l.225-.129v1.393l.213-.125.65-.2v.132l-1.932,1.115v-.131l.648-.551Z",
    transform: "translate(-283.809 -849.659)",
    fill: "#0540ac"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M399.2,1131.465v.413l-2.873,1.66v-.413Z",
    transform: "translate(-295.52 -843.677)",
    fill: "#0540ac"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M398.277,1123.7l-.376.22v-2.849l-.229.133.417-1.405.425.917-.237.14Z",
    transform: "translate(-296.523 -834.98)",
    fill: "#0540ac"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M403.4,1120.737l-.383.217v-2.848l-.23.132.422-1.406.421.918-.23.139Z",
    transform: "translate(-300.341 -832.766)",
    fill: "#0540ac"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M358.924,1134.364l3.83-2.213v5.517l-3.83,2.211Zm3.728-2.013-3.627,2.1v5.229l3.627-2.095Z",
    transform: "translate(-267.631 -844.188)",
    fill: "#0540ac"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M376.888,1123.987l3.834-2.213v5.518l-3.834,2.213Zm3.731-2.008-3.629,2.091v5.233l3.629-2.1Z",
    transform: "translate(-281.026 -836.451)",
    fill: "#0540ac"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M394.431,1113.858l3.833-2.211v5.517l-3.833,2.213Zm3.732-2.009-3.626,2.1v5.23l3.626-2.1Z",
    transform: "translate(-294.107 -828.899)",
    fill: "#0540ac"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M298.618,978.2,329.608,960.3l-2.752-1.59-30.989,17.9Z",
    transform: "translate(-220.613 -714.863)",
    fill: "#e6f5ff"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M298.618,1035.824v-5.156l-2.752-1.59v5.16Z",
    transform: "translate(-220.613 -767.333)",
    fill: "#d9e8f9"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M1006.007,85.061c0-7.866,5.574-11.083,12.386-7.151l109.239,63.067c6.813,3.933,12.384,13.588,12.384,21.452l0,278c0,7.863-5.569,11.081-12.382,7.144L1018.392,384.51c-6.815-3.932-12.387-13.586-12.387-21.453Z",
    transform: "translate(-750.127 -56.843)",
    fill: "#d0dae1"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M1151.378,419.688l.005-278c0-7.864-5.57-17.519-12.384-21.452L1029.76,57.169c-3.294-1.9-6.286-2.118-8.509-.961v-.015L1033.9,49c2.2-1.018,5.1-.737,8.275,1.092l109.242,63.066c6.808,3.935,12.38,13.589,12.38,21.453l0,278c0,3.992-1.436,6.786-3.74,8.059l-11.632,6.549c1.841-1.437,2.958-4.014,2.958-7.529",
    transform: "translate(-761.495 -36.102)",
    fill: "#fff"
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(255.878 26.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 210.625,
    height: 368.128,
    transform: "translate(-78.077 18.59) rotate(-13.393)",
    fill: "url(#linear-gradient-23)"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(255.954 26.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M864.074,283.276,864.078,0l280.481,161.932,0,283.272Z",
    transform: "translate(-900.25 -26.379)",
    fill: "#aaa192"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M1145.342,446.567,865.672,285.1l0-282.334,279.668,161.464Z",
    transform: "translate(-901.441 -28.442)",
    fill: "#3680d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M1901.512,854.881l16.2,9.356,0-87.385-16.2-9.355Z",
    transform: "translate(-1673.814 -598.659)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M1693.147,480.495l23.128,13.352v38.49l-23.128-13.352Z",
    transform: "translate(-1518.447 -384.657)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M1934.322,1586.427l-10.538-6.085v-48.89l10.538,6.083Z",
    transform: "translate(-1690.422 -1168.302)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M865.675,628.978l11.811,6.818v90.241l-11.811-6.817Z",
    transform: "translate(-901.444 -495.373)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M1104,471.638c-3.1-15.051-9.821-28.471-17.125-41.288l39.311-5.357,0,87.9-20.745-11.978c.652-10.422.364-20.512-1.439-29.281m26-114.419a17.186,17.186,0,0,1,7.765,13.449c0,4.942-3.483,6.953-7.765,4.483a17.19,17.19,0,0,1-7.765-13.448c0-4.945,3.484-6.956,7.765-4.483M1087.388,383l17.64,40.274-20.614,2.808q-1.623-2.788-3.256-5.552c-8.988-15.26-16.849-28.62-19.143-43.353l15.085,8.709Zm-21.71-23.446a138.286,138.286,0,0,0,7.312-26.188c.031-.176.053-.36.08-.539l20.215,6.192v.412l13.321,28.436-31.746,8.9-12.5-7.214c.859-3.26,2.021-6.457,3.314-10M1051.661,316.6a122.243,122.243,0,0,1-6.457,22.925,95.388,95.388,0,0,0-5.021,17.232l-14.123-8.154-12.071-47.509,36.808,3.655c1.032,4.779,1.386,8.831.864,11.851m-92.874,74.154c0-4.943,3.483-6.954,7.765-4.482a17.187,17.187,0,0,1,7.764,13.447c0,4.944-3.483,6.955-7.764,4.483a17.187,17.187,0,0,1-7.765-13.448M983.858,228.3,965.2,261.746,941.87,230.418ZM969.937,447.847V413.5c4.049,1.216,7.453.111,9.4-2.894L1023,459.544l-5.361,15.841Zm57.189,7.679V357.039l12.215,7.05c-.456,7.352.1,16.317,2.385,28.171,3.292,17.108,2.871,45.069-1.071,71.26l-13.2-7.621Zm73.033,81.958a279.04,279.04,0,0,0,4.662-29.1l22.691,13.1,14.29,40.045ZM1188,554.841l-20.215,3.78L1149.1,519.427l23.646-4.919Z",
    transform: "translate(-958.258 -196.609)",
    fill: "#1d66be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M1391.456,987.381c-2.852-13.865-10.657-27.121-18.921-41.151-3.978-6.756-8.139-13.821-11.868-21.242,2.374,19.557,1.643,45.646-2.119,70.6-1.87,12.4-5.57,31.284-12.307,47.739l36.586,21.121c5.922-22.026,13.046-55.589,8.628-77.065",
    transform: "translate(-1259.778 -716.092)",
    fill: "#1d66be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M956.218,71.813c6.66,10.942,13.557,23.5,19.456,35.409l-18.1,6.3-23.1-36.8.33-.016L932.8,71.284l-34.356,1.732L880.28,27.626l-4.9-2.828,19.368,48.4-14.91.753.676,1.828L877.083,73.8v51.53l-11.406-6.585v4.85l11.406,6.585,0,50.5-11.405-6.585v4.849l11.405,6.584v89.3l-11.4-6.585v4.85l11.4,6.585v28.437l4.2,2.425V282.1l77.874,44.96-8.05,23.79,4.418,2.55,15.2-44.9,0-107.282-13.036-51.307,36.031,3.577c.956,4.621,1.2,8.339.734,11.057a122.26,122.26,0,0,1-6.441,22.867c-4.609,12.637-8.958,24.576-3.491,52.994,3.284,17.064,2.858,45-1.088,71.162-3.037,20.138-7.806,37.359-13.792,49.8l-.071.146,4.562,2.633c5.825-12.61,10.474-29.692,13.449-49.416C991.6,288.013,992,259.3,988.59,241.579c-5.166-26.839-1.012-38.234,3.385-50.3a125.28,125.28,0,0,0,6.6-23.489c3.074-17.839-17.7-61.1-36.556-92.974l-6.128-3.539ZM881.28,77.849l.565,1.523,48.7-2.455,23.7,37.759-27.1,9.42-11.414-17.949-2.74,2.09,23.562,37.059v14.368l-39.087-22.568V114.307l-16.184-9.343Zm0,30.4,13.339,7.7v19.5l-13.339-7.7Zm0,59.536,29.195,16.855v-3.285L881.28,164.5V132.6l55.271,31.91v50.5L881.279,183.1ZM966.518,305.3,960.525,323l-79.247-45.752v-89.3l55.271,31.909v52.462l4.2,2.424V230.083l25.771,14.879Zm0-63.623L940.748,226.8V202.117L966.519,217Zm0-42.076v14.11l-25.771-14.879,0-50.6,13.044,1.3Zm-27.478-56.791-8.664-13.624,19.258-6.7,9.144,22.28Zm53.357,5.3-30.956-3.073-9.573-23.323,26.389-9.174c6.653,13.924,11.532,26.2,14.14,35.57",
    transform: "translate(-901.443 -44.867)",
    fill: "#044ca4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M961.439,75.284l-4.944-2.856c6.428,10.561,13.465,23.26,19.752,36l-18.689,6.5-23.789-37.9.485-.024-1.619-4.37-34.341,1.733L879.807,28.153l-3.951-2.281,19.461,48.637-14.928.752,1.619,4.369L932.155,77.1l-1.1.807,23.817,37.947L927.133,125.5,915.77,107.633l-2.21,1.685,23.4,36.8v15.053l-39.9-23.034V115.343L880.874,106V77.259L877.489,75.3l0,51.53-11.81-6.818v3.909l11.81,6.819V182.18l-11.811-6.818v3.911l11.811,6.818v90.241l-11.811-6.818v3.909l11.811,6.818v28.907l3.386,1.955V282.2l28.864,16.663,49.979,28.855L951.53,351.9l3.563,2.057,15.135-44.718.082-.248V201.859l-13.137-51.707,36.808,3.654c1.032,4.78,1.386,8.833.864,11.853a122.228,122.228,0,0,1-6.457,22.925c-4.585,12.583-8.917,24.468-3.477,52.735,3.295,17.126,2.871,45.135-1.083,71.351-3.082,20.448-7.846,37.485-13.821,49.9l3.679,2.124c5.82-12.549,10.461-29.41,13.487-49.47,4.02-26.66,4.421-55.293,1.023-72.953-5.194-26.993-1.023-38.436,3.4-50.558a124.853,124.853,0,0,0,6.589-23.429c3.1-17.993-18.9-62.92-36.741-93m-80.566,92.6,29.195,16.853V182.39l-29.194-16.855V132.7l56.082,32.378v51.437l-56.083-32.379Zm14.152-51.364v20.442l-14.151-8.17V108.347Zm65.8,207.926-51.085-29.492-28.864-16.665V188.047l56.083,32.378v52.462l3.386,1.955V230.182l26.584,15.346v60.883Zm-20.48-122.228,26.584,15.347v25.62l-26.584-15.348Zm26.584-1.658v14.658l-26.584-15.346V184.883l0-36.4,13.694,1.358Zm-27.96-56.447L929.741,129.6l20-6.951,9.639,23.484Zm53.952,5.359-31.636-3.142L951.4,122.255l-.866.12,27.8-9.663c6.367,13.276,11.746,26.325,14.587,36.757",
    transform: "translate(-901.443 -45.668)",
    fill: "#5da7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M1484.835,383.809v-3.284l-31.684-18.292V379.96l-10.6-6.12V335.82l-4.2-2.424v38.021l-26.516-15.308v4.851l26.516,15.306,0,86.447-26.7-15.417-20.944,2.852-19.671-44.906-3.477.71,19.572,44.685-19.982,2.722q-1.514-2.594-3.032-5.166c-9.712-16.493-18.1-30.738-19.494-46.856a82.591,82.591,0,0,1,4.117-13.575,138.759,138.759,0,0,0,7.325-26.245c.015-.084.027-.171.041-.26l19.461,5.961,14.6,31.167,3.372-.941-13.787-29.435V322.464l32.9,18.994v-4.849l-32.9-18.994V299.562l-4.2-2.424v31.311l-28.994-16.74c-3.328-8.6-7.521-18.075-12.464-28.156-2.322-4.737-4.844-9.672-7.494-14.678l-5.632-3.251.246.458c3.43,6.347,6.654,12.6,9.584,18.573,16.606,33.864,23.715,58.63,21.131,73.61a135.47,135.47,0,0,1-7.162,25.626,83.436,83.436,0,0,0-4.331,14.489l-.052.3.027.354c1.45,18.121,10.408,33.334,20.782,50.949,8.945,15.191,18.194,30.9,21.817,48.509,4.792,23.293-1.621,56.706-7.847,80.637l-.026.1,4.324,2.5c1.059-4.133,2.052-8.261,2.943-12.279l45.767,26.421,42.33-7.913v46.331l4.2,2.425V588.292l10.131,5.851v-4.849l-10.567-6.1-31.48-83.245,23.071.974,13.775,30.357,2.318-.564-14.2-31.286v-14.9l17.079,9.861v-4.848l-15.8-9.122V393.981l15.8,9.119v-4.849l-28.84-16.649V367.159Zm-136.7-67.9,27.416,15.827v30.5l-18.962-5.807c.455-10.323-2.389-23.947-8.454-40.518m122,266.3-19.581,3.663-20.8-43.642-3.345,1,20.64,43.3-20.135,3.766-43.573-25.154c5.763-27.518,7.017-49.575,3.728-65.566-3.15-15.316-9.941-28.721-16.874-40.93l42.65-5.811,25.511,14.729v28.5l-28.428-3.082,1.07,3.661,27.926,3.025Zm-5.226-84.945-22.358-.942V469.985l22.358,12.908Zm-.07-105.708V478l-22.287-12.865V378.689Z",
    transform: "translate(-1240.932 -224.439)",
    fill: "#044ca4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M1486.442,384.267V381.92l-31.277-18.058V381.59L1443.753,375V336.511l-3.387-1.955v38.49l-26.515-15.307v3.91l26.515,15.308,0,87.385-27-15.586-21.174,2.885-19.664-44.887-2.8.574,19.582,44.706-20.615,2.809q-1.623-2.789-3.255-5.552c-9.78-16.6-18.232-30.963-19.622-47.285a82.4,82.4,0,0,1,4.141-13.691,138.116,138.116,0,0,0,7.31-26.189c.032-.174.055-.358.082-.537l20.215,6.191v.412l14.29,30.51,2.721-.758-13.626-29.089v-46.17l32.9,18.994v-3.91l-32.9-18.994V300.255l-3.385-1.955v31.781l-29.637-17.112q-5.013-13.009-12.547-28.384c-2.586-5.274-5.2-10.358-7.716-15.094l-4.543-2.623c3.071,5.685,6.357,11.989,9.6,18.607,16.68,34.019,23.816,58.926,21.213,74.032a135.865,135.865,0,0,1-7.178,25.683,82.951,82.951,0,0,0-4.315,14.432l-.045.244.023.286c1.437,17.942,10.344,33.068,20.66,50.587,8.985,15.257,18.276,31.033,21.927,48.786,4.864,23.652-1.813,57.678-7.845,80.879l3.482,2.011c1.02-3.963,2.051-8.227,3.04-12.7l45.97,26.541,42.858-8.013v47.206l3.387,1.953v-48.89l10.537,6.083v-3.91l-10.8-6.236-31.81-84.117,23.773,1,13.736,30.268,1.656-.4-14.036-30.932V484.758l17.486,10.1v-3.911l-16.2-9.356,0-87.384,16.2,9.355v-3.91L1457.2,382.762v-15.38Zm-137.38-68.3,28.5,16.457v31.338l-19.807-6.065c.606-10.53-2.31-24.491-8.7-41.73m103.005,271.409-20.79-43.609-2.7.809,20.655,43.33-20.6,3.852-44.2-25.518c4.518-21.419,7.765-46.759,3.839-65.846-3.1-15.051-9.82-28.471-17.126-41.289l43.178-5.884,26.034,15.031v29.289l-28.306-3.069.765,2.616,27.882,3.022,31.574,83.487Zm14.855-88.655-23.171-.975v-27.54l23.171,13.376Zm-.073-19.091-23.1-13.335V378.913l23.1,13.335Z",
    transform: "translate(-1242.539 -225.366)",
    fill: "#5da7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M1278.92,313.135a124.883,124.883,0,0,1-6.589,23.429c-4.418,12.122-8.589,23.565-3.4,50.558,3.4,17.66,3,46.293-1.022,72.953-3.025,20.06-7.667,36.921-13.487,49.47l14.221,8.211c6.736-16.455,10.437-35.343,12.307-47.739,3.761-24.952,4.493-51.042,2.119-70.6,3.729,7.421,7.891,14.486,11.868,21.242,8.264,14.031,16.068,27.286,18.921,41.151,4.418,21.476-2.707,55.04-8.628,77.065l11.575,6.684c6.033-23.2,12.709-57.227,7.845-80.879-3.652-17.753-12.942-33.529-21.927-48.786-10.317-17.519-19.224-32.645-20.66-50.587l-.023-.286.046-.244a82.946,82.946,0,0,1,4.314-14.432,135.841,135.841,0,0,0,7.178-25.683c2.6-15.106-4.533-40.013-21.213-74.033-3.245-6.618-6.53-12.922-9.6-18.607l-20.588-11.886c17.842,30.075,39.84,75,36.741,93",
    transform: "translate(-1182.183 -190.523)",
    fill: "#044ca4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M1087.625,307.173l57.719,33.324v-8.761l-57.719-33.323a35,35,0,0,0-11.077-18.828V220.953l-7.585-4.379v58.91c-6.329-1.5-10.723,2.715-10.723,10.345a25.369,25.369,0,0,0,1.08,7.057L1017.91,304.5,913.529,244.238V199.724l30.753-55.132-8.438-4.872-27.621,49.517-42.547-57.131v10.509l40.266,54.071V304.645c-5.159-1.408-9.288.977-10.648,6.149l-29.62-17.1v8.758l29.62,17.1a35.277,35.277,0,0,0,10.648,18.441l0,66.8,7.586,4.38,0-66.8c3.859,1.056,7.165.051,9.157-2.786l46.353,51.949,101.41,58.547,22.335,62.58,8.546,4.935-23.658-66.288,67.671-14.081V426.635l-68.8,14.313,0-127.737c5.373,1.67,9.67-.675,11.077-6.038M909.736,332.006a16.294,16.294,0,0,1-7.359-12.745c0-4.685,3.3-6.591,7.359-4.248a16.285,16.285,0,0,1,7.357,12.744c0,4.685-3.3,6.591-7.357,4.249m159.225,108.459-98.227-56.71L924.68,332.14v0c0-7.877-4.57-17.319-11.151-23.112V253l106.891,61.711,43.431-12.179a32.754,32.754,0,0,0,5.113,6.024Zm4.224-137.512a16.285,16.285,0,0,1-7.358-12.744c0-4.685,3.3-6.591,7.358-4.249a16.293,16.293,0,0,1,7.359,12.746c0,4.684-3.3,6.59-7.359,4.247",
    transform: "translate(-901.443 -124.881)",
    fill: "#044ca4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M1077.145,452.5l68.2-14.19v-9.457l-69.2,14.4,0-129c5.5,1.858,9.861-.551,11.166-6.08l58.036,33.507v-7.82l-58.036-33.508a33.855,33.855,0,0,0-11.166-18.97V222.37l-6.774-3.91v59.265c-6.168-1.618-10.723,2.26-10.723,9.99a25.127,25.127,0,0,0,1.172,7.268L1018.045,306.7,913.124,246.123V201.032l30.708-55.049-7.534-4.352-27.911,50.038L865.677,134.32V143.7l40.673,54.616V306.9c-5.3-1.591-9.467.817-10.737,6.2l-29.939-17.284v7.821l29.938,17.284a33.926,33.926,0,0,0,10.736,18.594v67.166l6.774,3.91V343.423c4.051,1.215,7.453.111,9.4-2.894l46.61,52.24L1070.7,451.408l22.545,63.17,7.631,4.4ZM909.736,334.125a17.187,17.187,0,0,1-7.765-13.448c0-4.944,3.483-6.955,7.765-4.484a17.191,17.191,0,0,1,7.764,13.448c0,4.944-3.483,6.955-7.764,4.483m159.631,108.7-98.724-57L924.26,333.84c0-.1.013-.189.013-.287,0-7.908-4.764-17.291-11.15-22.745V253.944l107.164,61.87,43.578-12.222a32.073,32.073,0,0,0,5.505,6.495Zm-3.947-151.195c0-4.945,3.484-6.956,7.764-4.484a17.186,17.186,0,0,1,7.765,13.449c0,4.942-3.483,6.953-7.765,4.483a17.189,17.189,0,0,1-7.764-13.448",
    transform: "translate(-901.443 -126.532)",
    fill: "#5da7ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(255.915 26.375)",
    opacity: 0.1,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M1006.15,103.7l0,272.76,3.55,2.05c26.108-122.319,85.3-188.834,107.861-210.489Z",
    transform: "translate(-1006.148 -103.701)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    transform: "translate(285.496 104.583)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M1151.3,438.129c0,3.929-1.607,6.251-3.136,8.549-2.311,3.47-11.29,16.169-11.29,16.169s-9.26-23.58-11.345-29.313c-1.461-4.015-3.078-8.174-3.078-12.057,0-9.2,6.458-12.929,14.423-8.328s14.427,15.785,14.427,24.982",
    transform: "translate(-1122.451 -411.177)",
    fill: "#438be3"
  }))))), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M1126.078,450.349c0,3.929-1.607,6.251-3.136,8.549-2.311,3.47-11.29,16.169-11.29,16.169s-9.26-23.58-11.345-29.313c-1.46-4.015-3.078-8.174-3.078-12.057,0-9.2,6.458-12.929,14.423-8.328s14.427,15.785,14.427,24.982",
    transform: "translate(-818.148 -315.706)",
    fill: "#e21e66"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M1128.694,419c-3.5-2.02-6.706-2.433-9.2-1.483l-3.33,1.792c2.551-1.161,5.918-.821,9.608,1.311,7.964,4.6,14.427,15.785,14.427,24.982,0,3.929-1.607,6.251-3.136,8.549-2.311,3.47-11.29,16.168-11.29,16.168.253.642,2.925-1.618,2.925-1.618s8.977-12.7,11.288-16.172c1.53-2.3,3.136-4.619,3.136-8.548,0-9.2-6.46-20.384-14.425-24.982",
    transform: "translate(-832.265 -310.957)",
    fill: "#af0033"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M1133.334,461.518c0,6.8-4.775,9.56-10.668,6.156S1112,456.006,1112,449.2s4.776-9.559,10.666-6.156,10.668,11.671,10.668,18.475",
    transform: "translate(-829.162 -329.268)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(359.316 260.139)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M1441.533,1049.714c0,3.929-1.607,6.251-3.136,8.549-2.311,3.47-11.29,16.169-11.29,16.169s-9.26-23.58-11.345-29.313c-1.46-4.015-3.078-8.173-3.078-12.057,0-9.2,6.458-12.929,14.423-8.328s14.426,15.785,14.426,24.982",
    transform: "translate(-1412.683 -1022.762)",
    fill: "#438be3"
  }))))), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M1416.31,1061.934c0,3.929-1.607,6.251-3.136,8.549-2.311,3.47-11.29,16.168-11.29,16.168s-9.26-23.58-11.345-29.313c-1.461-4.015-3.078-8.174-3.078-12.058,0-9.2,6.458-12.929,14.423-8.328s14.427,15.785,14.427,24.982",
    transform: "translate(-1034.558 -771.734)",
    fill: "#e21e66"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M1418.925,1030.583c-3.5-2.019-6.706-2.433-9.2-1.483l-3.33,1.793c2.551-1.161,5.917-.822,9.608,1.311,7.964,4.6,14.427,15.785,14.427,24.982,0,3.929-1.607,6.251-3.136,8.549-2.311,3.47-11.29,16.168-11.29,16.168.252.642,2.925-1.618,2.925-1.618s8.977-12.7,11.289-16.172c1.529-2.3,3.136-4.619,3.136-8.548,0-9.2-6.46-20.384-14.425-24.982",
    transform: "translate(-1048.675 -766.985)",
    fill: "#af0033"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M1423.565,1073.1c0,6.8-4.775,9.56-10.668,6.156s-10.666-11.668-10.666-18.475,4.776-9.559,10.666-6.156,10.668,11.671,10.668,18.475",
    transform: "translate(-1045.572 -785.296)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(157.832 361.435)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M758.953,1455.069,730.835,1471.3c1.325-9.718-8.962-22.9-28.144-33.972-26.6-15.361-60.242-20.848-75.128-12.255s-5.381,28.015,21.223,43.375c19.183,11.078,42.014,17.015,58.843,16.248l-12.419,7.173,63.744,36.8,63.742-36.8Z",
    transform: "translate(-620.527 -1421.014)",
    fill: "#438be3"
  }))))), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M1040.73,1069.97l.851.6s2.74,3.293,4.154,4.761,5.387,5.875,5.332,7.371-1.716,2.829-3.43,4.242a33.744,33.744,0,0,1-4.487,2.912s-2.8.623-3.129.759-3.4,0-3.589-.3-1.47-4.41-1.47-4.518.57-1.2,1.06-1.2,1.089-.57.98-.733a12.068,12.068,0,0,1-1.06-4.488,15.408,15.408,0,0,0-.5-3.887l-.644-2.069Z",
    transform: "translate(-771.598 -797.823)",
    fill: "#ffcda8"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M1104.091,1248.109a1.222,1.222,0,0,0,.407-.069,1.237,1.237,0,0,0,.763-1.577l-40.389-116.8a4.337,4.337,0,0,0-2.1-2.309l-6.042-2.756a1.239,1.239,0,0,0-1.028,2.254l6.045,2.755a1.946,1.946,0,0,1,.791.873l40.39,116.8a1.235,1.235,0,0,0,1.168.832",
    transform: "translate(-786.64 -838.475)",
    fill: "#438be3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(268.747 286.428)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M1105.3,1248.911a.842.842,0,0,0,.27-.046.826.826,0,0,0,.512-1.048l-40.391-116.8a3.98,3.98,0,0,0-1.885-2.073l-6.044-2.75a.825.825,0,1,0-.684,1.5l6.043,2.754a2.325,2.325,0,0,1,1.011,1.108l40.387,116.8a.826.826,0,0,0,.781.557",
    transform: "translate(-1056.598 -1126.116)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    transform: "translate(269.159 286.84)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M1106.513,1249.708a.414.414,0,0,0,.391-.546l-40.39-116.8a3.55,3.55,0,0,0-1.665-1.831l-6.042-2.75a.412.412,0,0,0-.345.747l6.047,2.755a2.732,2.732,0,0,1,1.226,1.35l40.389,116.8a.414.414,0,0,0,.39.278",
    transform: "translate(-1058.221 -1127.738)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(269.469 287.149)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M1107.418,1250.3a.258.258,0,0,0,.034,0,.106.106,0,0,0,.063-.134l-40.388-116.8a3.233,3.233,0,0,0-1.5-1.653l-6.043-2.755a.108.108,0,0,0-.138.056.1.1,0,0,0,.053.133l6.043,2.754a3.063,3.063,0,0,1,1.392,1.532l40.39,116.8a.108.108,0,0,0,.1.069",
    transform: "translate(-1059.436 -1128.951)",
    fill: "#438be3"
  }))))), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M1054.831,1122.6a2.062,2.062,0,0,0-2.7.171c-.686.549-.415,2.635-.415,2.635l5.963,2.194a3.312,3.312,0,0,1,1.052-3.03v-.125Z",
    transform: "translate(-784.175 -836.76)",
    fill: "#3b4447"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M970.208,1273.618a1.252,1.252,0,0,0,.619-.164l38.312-22.121a1.239,1.239,0,1,0-1.241-2.145l-38.31,22.12a1.237,1.237,0,0,0,.621,2.309",
    transform: "translate(-722.511 -931.334)",
    fill: "#438be3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(246.87 318.101)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M971.416,1274.412a.816.816,0,0,0,.411-.111l38.315-22.118a.825.825,0,0,0-.825-1.429L971,1272.873a.824.824,0,0,0,.412,1.539",
    transform: "translate(-970.589 -1250.642)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(247.283 318.514)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M972.627,1275.21a.431.431,0,0,0,.2-.053l38.314-22.123a.412.412,0,0,0-.41-.715l-38.314,22.119a.412.412,0,0,0,.205.771",
    transform: "translate(-972.214 -1252.265)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(247.593 318.824)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M973.533,1275.808a.1.1,0,0,0,.053-.013l38.31-22.118a.1.1,0,0,0,.038-.142.1.1,0,0,0-.139-.037l-38.313,22.121a.1.1,0,0,0-.039.14.109.109,0,0,0,.09.05",
    transform: "translate(-973.429 -1253.484)",
    fill: "#438be3"
  }))))), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M1023.844,1436.47a1.234,1.234,0,0,0,.616-.164l38.316-22.118a1.24,1.24,0,0,0-1.239-2.148l-38.314,22.119a1.239,1.239,0,0,0,.622,2.311",
    transform: "translate(-762.504 -1052.765)",
    fill: "#438be3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(260.514 359.524)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M1025.054,1437.269a.781.781,0,0,0,.409-.114l38.316-22.119a.824.824,0,1,0-.826-1.426l-38.312,22.119a.826.826,0,0,0,.414,1.54",
    transform: "translate(-1024.228 -1413.498)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(260.926 359.937)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M1026.26,1438.064a.421.421,0,0,0,.207-.053l38.312-22.118a.413.413,0,1,0-.412-.715l-38.313,22.117a.412.412,0,0,0,.206.769",
    transform: "translate(-1025.848 -1415.122)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(261.236 360.246)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M1027.169,1438.663a.1.1,0,0,0,.054-.015l38.312-22.121a.1.1,0,1,0-.1-.175l-38.313,22.117a.1.1,0,0,0-.037.139.1.1,0,0,0,.088.055",
    transform: "translate(-1027.068 -1416.337)",
    fill: "#438be3"
  }))))), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M887.773,1562.184s-2.146,5.077-1.186,9.025c0,0,.171.792,2.933,2.2s4.516,2.48,6.265,4.849,3.609,6.1,10.6,7.055,11.167-1.522,11.732-3.048c0,0-.17-2.988-4.964-7.051s-9.364-8.294-9.364-8.294a3.1,3.1,0,0,0-3.552,0c-1.808,1.3-1.354,3.616-4.035,3.53s-5.332-2.509-6.4-4.258a36.665,36.665,0,0,1-2.03-4.007",
    transform: "translate(-660.898 -1164.842)",
    fill: "#412999"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M906.7,1610.937c-6.994-.96-8.858-4.683-10.6-7.055s-3.5-3.44-6.265-4.848-2.933-2.2-2.933-2.2c-.021-.094-.041-.188-.06-.284v.009a9.087,9.087,0,0,0,.06,2.832s.17.791,2.933,2.2c1,.509,1.873.98,2.66,1.482l1.262-.582a12.97,12.97,0,0,1,2.343,2.466c1.745,2.367,3.609,6.094,10.6,7.052s11.168-1.525,11.732-3.046a3.644,3.644,0,0,0-.166-.749c-.976,1.517-5.041,3.619-11.567,2.725",
    transform: "translate(-661.209 -1190.466)",
    fill: "#0f0067"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M737.642,1409.8s-3.679,3.8-3.968,7.887a9.437,9.437,0,0,0,3.164,3.942c2.091,1.314,6.423,4.041,7.689,6.962s2,7.836,6.962,9.589,9.638,2.629,11.732-1.168c0,0-.636-4.239-2.386-6.623s-7.789-7.88-8.664-9.782a3.526,3.526,0,0,0-2.288.391,5.217,5.217,0,0,1-4.522.193c-1.8-.679-8.029-8.759-7.717-11.39",
    transform: "translate(-547.063 -1051.22)",
    fill: "#412999"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M761.674,1459.54c-.022-.1-.044-.219-.073-.345.048.263.073.416.073.416-2.095,3.8-6.768,2.922-11.732,1.168s-5.695-6.67-6.963-9.589-5.6-5.648-7.688-6.962a9.439,9.439,0,0,1-3.164-3.942c0-.062.013-.118.02-.18a9.068,9.068,0,0,0-.547,2.443,9.428,9.428,0,0,0,3.165,3.944,46.671,46.671,0,0,1,3.938,2.7c.44-.176.952-.383,1.475-.589a10.593,10.593,0,0,1,2.8,3.46c1.268,2.921,2,7.834,6.963,9.589s9.637,2.628,11.732-1.171a6.23,6.23,0,0,0,0-.948",
    transform: "translate(-545.517 -1073.815)",
    fill: "#0f0067"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M793.908,1140.258c-1.038,16.153-7.471,22.859-15.574,35.839s-19.162,27.615-21.241,44.164c0,0-15.351,1.8-18.693-8.761,0,0,7.759-17.539,10.837-25.632s12.848-17.469,12.848-17.469l7.732-23.418s24.457-10.405,24.091-4.723",
    transform: "translate(-550.587 -848.967)",
    fill: "#367fd7"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M823.5,1211.934c-.243-7.369-4.6-47.189-4.6-47.189l-30.892-.943c1.852,12.159,15.256,48.136,15.726,52.625s-1.277,18.2,2.061,26.95,7.224,28.212,7.224,28.212a17.556,17.556,0,0,0,18.757-.525c-7.656-15.733-8.034-51.762-8.278-59.131",
    transform: "translate(-587.58 -867.789)",
    fill: "#5098f0"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M1034.8,1079.317l2.474-1.443a3.2,3.2,0,0,1,1.279,2.095c.325,2.176-.625,3.129.516,4.488s1.6,1.55,1.387,3.239a29.122,29.122,0,0,0-.272,4.1c0,1.227-.527,3.578.8,4.447-.468.114-.855.215-.967.259-.325.137-3.4,0-3.589-.3s-1.47-4.41-1.47-4.518.57-1.2,1.06-1.2,1.089-.57.98-.733a12.065,12.065,0,0,1-1.06-4.488,15.408,15.408,0,0,0-.5-3.887Z",
    transform: "translate(-771.598 -803.717)",
    fill: "#d9a782"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M858.756,1186.279a6.658,6.658,0,0,0,2.584,1.749c1.384.412,6.664,2.18,7.915,3.157a37.438,37.438,0,0,1,3.755,4.109s.652,5.112,0,5.415-2.067-.628-2.067-.628l-.816-1.089s-1.172,4.108-2.014,4.325a12.553,12.553,0,0,0-2.555,1.333,15.726,15.726,0,0,1-5.441.408,10.57,10.57,0,0,1-2.393-2.693c0-.081-1.915-8.6-3.9-9.846Z",
    transform: "translate(-636.657 -884.549)",
    fill: "#ffcda8"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M874.308,1231.806a5.522,5.522,0,0,1-1.448-1.4,53.479,53.479,0,0,1,6.695-.725c1.88-.166,2.615-1.5,2.4-2.257s-1.877-1.551-2.15-1.8.19-1.331.219-2.366.49-1.113,1.716-1.113a3.768,3.768,0,0,1,2.34,1.358l.243,2.23s-1.171,4.108-2.013,4.325a12.579,12.579,0,0,0-2.555,1.333,15.734,15.734,0,0,1-5.44.408",
    transform: "translate(-650.847 -911.297)",
    fill: "#d9a782"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M952.36,895a9.908,9.908,0,0,0-6.506,5.323s-19.949-13.946-24.43-20.114-6.51-45.647-6.51-45.647,7.862,2.451,9.891,8.961.509,8.536,2.874,16.142,4.311,10.82,4.311,10.82S951.349,893.217,952.36,895",
    transform: "translate(-682.205 -622.287)",
    fill: "#d51159"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M922.781,885.307s4.227-1.639,4.141,1.571a25.449,25.449,0,0,0,.424,7.609c.761,5.157.676,11.994,3.213,12.464s4.056-.205,3.124,1.905-2.7,7.524,4.482,14.793a112.863,112.863,0,0,0,13.424,10.973,11.158,11.158,0,0,0-2.518,3.227s-19.949-13.945-24.43-20.114c-2.608-3.6-4.386-18.481-5.413-30.294Z",
    transform: "translate(-685.421 -659.817)",
    fill: "#af0034"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M783.163,834.512c2.115-.844,7.225-1.394,7.859-.76a29.871,29.871,0,0,1,6.764,14.033c1.436,7.944,2.365,15.636,1.605,19.605S798.378,880.5,797.955,887s3.971,25.187,4.227,25.359-1.015,5.916-16.481,9.721-28.657-3.212-28.657-3.212,5.665-15.637,4.4-22.822-6.173-18.089-6.173-18.089l-6.506-22.785s9.171-11.887,12.659-15.384,21.743-5.279,21.743-5.279",
    transform: "translate(-558.313 -621.482)",
    fill: "#d51159"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M768.021,980.965l-2.156-7.565,3.848-1.311s7.945-2.115,8.959,2.619,1.438,6.6,2.788,7.61,5.327-1.691,4.141,6-4.55,14.793.22,17.835,4.686,5.411,4.516,7.692c-.121,1.618,4.759,7.85,7.619,11.353-15.254,3.535-28.16-3.321-28.16-3.321s5.665-15.637,4.4-22.822-6.173-18.089-6.173-18.089",
    transform: "translate(-571.067 -724.488)",
    fill: "#af0034"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M766.6,985.716l-5.579,7.69s-24.851-20.371-28.318-24.428-3.379-26.627-3.3-32.288,1.947-17.255,4.9-19.065,13.328,2.755,13.681,10.951-4.384,26.966-3.453,34.148Z",
    transform: "translate(-543.861 -683.932)",
    fill: "#d51159"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M810.419,817.184s.65,4.966-.647,7.641,3.406,5.466,9.142,7.909,7,1.155,7.867.086c1.836-2.251,1.434-8.839,1.434-8.839Z",
    transform: "translate(-603.645 -609.333)",
    fill: "#d9a782"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(205.903 207.85)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M829.317,829.935c-.527-2.943-1.125-5.955-1.125-5.955l-17.8-6.8s.65,4.966-.648,7.641c-.484,1.006-.16,2.734.739,4.641l2.851,2.369s-.143-6.434,3.275-5.146c2.968,1.12,7.965,3.457,12.705,3.246",
    transform: "translate(-809.524 -817.183)",
    fill: "#d88f69"
  }))))), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M877.28,847.586l5.84,5.779s-.6-10.34-1.1-14.956l-3.006-1.421s-.844,8.339-1.733,10.6",
    transform: "translate(-654.143 -624.1)",
    fill: "#fc367f"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M804.09,726.616c4.019-2.7,10.38-2.406,14.862.628a13.811,13.811,0,0,1,6.063,8.337c.395,1.649.893,3.066,1.286,4.318s-.9,2.82-.9,2.82c1.406,1.769.31,5.966.018,6.985a2.3,2.3,0,0,1,.238.955,1.1,1.1,0,0,1-.792,1.043,22.225,22.225,0,0,0-.574,3.657c0,1.013.138,4.38-3.819,4.446s-9.661-2.274-13.251-5.142a26.277,26.277,0,0,1-8.436-14.466,13.106,13.106,0,0,1,5.307-13.581",
    transform: "translate(-595.415 -540.422)",
    fill: "#ffcda8"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M850.646,771.208c-.393-1.252-.891-2.668-1.286-4.318-.011-.042-.022-.094-.034-.136a53.664,53.664,0,0,0-17.85,5.673c-.1.054-.206.108-.309.165a19.052,19.052,0,0,0,9.1,4.924c3.276.577,4.25-1.741,9.577-3.622a3.449,3.449,0,0,0,.8-2.685",
    transform: "translate(-619.759 -571.73)",
    fill: "#d9a782"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M897.457,798.627v0c-.553-1.337-1.908-3.405-2.279-4.758-.484-1.746,3-3.494,3-3.494a5.48,5.48,0,0,1-.743,1.265c1.406,1.769.31,5.966.017,6.985",
    transform: "translate(-667.455 -589.345)",
    fill: "#d9a782"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M804.09,726.616c4.019-2.7,10.38-2.406,14.862.628a14.2,14.2,0,0,1,5.7,7.092,4.1,4.1,0,0,1-2.586,2.675c-3.935.848-7.631-.381-9.619.213-1.509.449-2.272,3.3-2.442,5.883s-1.775,3.467-1.27,6.345c.441,2.5,3.968,6.226,4.951,8.874a26,26,0,0,1-6.468-3.662,26.277,26.277,0,0,1-8.436-14.466,13.106,13.106,0,0,1,5.307-13.581",
    transform: "translate(-595.415 -540.422)",
    fill: "#ffcda8"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M808.557,781.317c-.443,1.169-.925,2.668-1.667,3.093-.452.258-1.31-.485-1.532-.74-.534-.614-4.266-4.94-4.5.4a24.289,24.289,0,0,1-2.06-6.082,15.288,15.288,0,0,1-.261-2.54,29.888,29.888,0,0,0,10.183,2.689c-.17,1.34.068,2.573-.16,3.179",
    transform: "translate(-595.426 -578.214)",
    fill: "#281080"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M893.089,838.25a19.511,19.511,0,0,1,.57-7.377c.055-.212.967.026,1.665-.205h0a22.2,22.2,0,0,0-.574,3.657c0,.775.076,2.927-1.66,3.925",
    transform: "translate(-665.874 -619.387)",
    fill: "#d9a782"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M810.029,805.738c-.48.31-1.6.753-3.784-1.585s-2.143-4.534-1.061-5.269a1.821,1.821,0,0,1,2.683.56,57.123,57.123,0,0,1,2.162,6.294",
    transform: "translate(-599.845 -595.412)",
    fill: "#f2a983"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M810.029,805.738c-.48.31-1.6.753-3.784-1.585s-2.143-4.534-1.061-5.269a1.821,1.821,0,0,1,2.683.56,57.123,57.123,0,0,1,2.162,6.294",
    transform: "translate(-599.845 -595.412)",
    fill: "#ffcda8"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M797.078,734.188s4.4-3.037,7.328-4.6a52.675,52.675,0,0,1,19.308-5.827s-3.374-7.507-5.788-10.337c-2.235-2.62-8.9-3.912-15.157-.3-8.03,4.635-7.912,9.149-7.9,12.969,0,2.387.74,4.467,2.213,8.1",
    transform: "translate(-592.69 -530.08)",
    fill: "#d51159"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M850.784,761.461a52.676,52.676,0,0,0-19.308,5.827l-.309.161a18.977,18.977,0,0,0,9.1,4.926c3.426.606,4.323-1.961,10.336-3.88a16.2,16.2,0,0,1,8.219-.664,28.8,28.8,0,0,0-3.968-3.743,31.5,31.5,0,0,0-4.071-2.627",
    transform: "translate(-619.759 -567.784)",
    fill: "#fc367f"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M803.053,836.989a28.811,28.811,0,0,0,16.561,10.6l-1.58,9.144s-15.3-10.676-18.091-14.7Z",
    transform: "translate(-596.477 -624.101)",
    fill: "#fc367f"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M1012.263,1634.743v0l5.258-3.068a5.01,5.01,0,0,1,2.635-.431c4.7.416,10.136,6.09,12.131,12.678,1.566,5.169.547,9.364-2.239,10.727l-4.725,2.776a4.854,4.854,0,0,1-3.086.678c-4.7-.413-10.137-6.089-12.134-12.673-1.547-5.119-.564-9.279,2.159-10.686",
    transform: "translate(-752.636 -1216.317)",
    fill: "#00267e"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M1010.1,1654.249c2,6.584,7.43,12.26,12.134,12.673s6.906-4.588,4.912-11.173-7.427-12.262-12.133-12.678-6.905,4.591-4.913,11.178",
    transform: "translate(-752.633 -1225.138)",
    fill: "#003f97"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M1020.061,1664.239c1.438,4.749,5.353,8.836,8.747,9.137s4.977-3.307,3.538-8.057-5.355-8.839-8.747-9.137-4.976,3.308-3.539,8.056",
    transform: "translate(-760.212 -1234.919)",
    fill: "#c6dcf7"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M1035.486,1679.71c.575,1.9,2.141,3.534,3.5,3.656s1.992-1.323,1.417-3.222-2.14-3.535-3.5-3.656-1.99,1.325-1.415,3.223",
    transform: "translate(-771.951 -1250.067)",
    fill: "#fff"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M1032.949,1681.06c.577,1.9,2.143,3.535,3.5,3.66s1.992-1.328,1.417-3.226-2.139-3.536-3.5-3.654-1.989,1.321-1.417,3.219",
    transform: "translate(-770.06 -1251.076)",
    fill: "#c6dcf7"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M1037.6,1685.73a2.767,2.767,0,0,0,1.915,2c.744.065,1.087-.725.775-1.764a2.755,2.755,0,0,0-1.913-2c-.744-.067-1.091.725-.776,1.761",
    transform: "translate(-773.602 -1255.648)",
    fill: "#003f97"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M1021.569,1657.76c-1.334,1.344-1.709,3.973-.762,7.105,1.439,4.75,5.355,8.839,8.747,9.138a3.542,3.542,0,0,0,2.038-.39,3.347,3.347,0,0,1-2.78.952c-3.394-.3-7.309-4.388-8.747-9.137-1.108-3.655-.418-6.627,1.506-7.668",
    transform: "translate(-760.214 -1236.108)",
    fill: "#fff"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M952.032,1347.7a1.176,1.176,0,0,0,.4-.069,1.234,1.234,0,0,0,.766-1.574l-40.389-116.8a4.324,4.324,0,0,0-2.1-2.309l-6.045-2.757a1.238,1.238,0,1,0-1.026,2.254l6.042,2.756a1.928,1.928,0,0,1,.791.867l40.389,116.8a1.24,1.24,0,0,0,1.17.833",
    transform: "translate(-673.257 -912.731)",
    fill: "#438be3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(230.07 311.758)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M953.242,1348.5a.828.828,0,0,0,.781-1.1l-40.387-116.8a3.944,3.944,0,0,0-1.886-2.071l-6.043-2.755a.826.826,0,0,0-.686,1.5l6.045,2.755a2.3,2.3,0,0,1,1.007,1.109l40.389,116.8a.827.827,0,0,0,.78.555",
    transform: "translate(-904.538 -1225.704)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(230.482 312.171)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    clipPath: "url(#clip-path-87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M954.451,1349.3a.411.411,0,0,0,.391-.546l-40.388-116.8a3.534,3.534,0,0,0-1.666-1.831l-6.043-2.755a.413.413,0,1,0-.343.751l6.042,2.754a2.75,2.75,0,0,1,1.229,1.35l40.39,116.8a.41.41,0,0,0,.388.275",
    transform: "translate(-906.159 -1227.328)",
    fill: "#438be3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(230.792 312.481)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M955.359,1349.9a.074.074,0,0,0,.036-.006.1.1,0,0,0,.061-.131l-40.387-116.8a3.255,3.255,0,0,0-1.5-1.651l-6.044-2.753a.1.1,0,0,0-.135.053.1.1,0,0,0,.051.136l6.043,2.752a3.061,3.061,0,0,1,1.393,1.532l40.387,116.8a.1.1,0,0,0,.1.071",
    transform: "translate(-907.376 -1228.545)",
    fill: "#438be3"
  }))))), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M902.778,1222.185a2.062,2.062,0,0,0-2.7.173c-.686.552-.413,2.636-.413,2.636l5.961,2.195a3.315,3.315,0,0,1,1.05-3.031v-.127Z",
    transform: "translate(-670.798 -911.013)",
    fill: "#412999"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M1092.711,1685.112l56.129-7.935-.327-.97-56.129,7.933Z",
    transform: "translate(-814.536 -1249.863)",
    fill: "#1058b0"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M1313.058,1608.563l.327.97,39.445-23.072-.326-.972Z",
    transform: "translate(-979.081 -1182.219)",
    fill: "#1058b0"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M1092.384,1616.5l56.129-7.933,39.446-23.075-56.131,7.938Z",
    transform: "translate(-814.536 -1182.218)",
    fill: "#438be3"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M1109.807,1568.8l-44.385,6.278-12.516-36.2,44.663-6.274Z",
    transform: "translate(-785.098 -1142.788)",
    fill: "#d9e8f9"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M1098.381,1467.836,1054,1474.111l37.765-22.088,44.386-6.28Z",
    transform: "translate(-785.911 -1078.017)",
    fill: "#fff"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M1228.5,1467.836l12.238,36.2,37.767-22.09-12.24-36.2Z",
    transform: "translate(-916.031 -1078.017)",
    fill: "#c6dcf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(287.752 370.523)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M1169.08,1457.444l4.945-.7-37.769,22.092-4.939.7Z",
    transform: "translate(-1131.318 -1456.745)",
    fill: "#438be3"
  }))))), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M1136.127,1556.219l-4.061-12.009,4.733-.665,4.148,11.995Z",
    transform: "translate(-844.124 -1150.944)",
    fill: "#c6dcf7"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M1194.72,1644.727l-.088-.222.152-.023.089.22a2.582,2.582,0,0,1,1.975,1.088.392.392,0,0,0-.269-.09c-.156.026-.224.208-.177.437a.566.566,0,0,0-.481-.334c-.156.022-.225.208-.176.436-.129-.216-.325-.359-.482-.337s-.224.208-.177.437c-.128-.218-.326-.36-.48-.335s-.224.21-.176.436c-.128-.217-.324-.358-.481-.333a.209.209,0,0,0-.172.155c.01-.807.344-1.4.943-1.536",
    transform: "translate(-890.139 -1226.207)",
    fill: "#0540ac"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M1201.542,1655.278l-.154.021-1.686-4.293.149-.022Z",
    transform: "translate(-894.557 -1231.055)",
    fill: "#0540ac"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M1207.384,1668.772c.2-.03.266-.307.144-.621l.152-.023c.175.441.082.836-.2.88s-.659-.278-.836-.72l.157-.024c.12.312.385.542.585.509",
    transform: "translate(-899.732 -1243.839)",
    fill: "#0540ac"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M1215.662,1640.735l.934,2.372c.368.937.177,1.773-.427,1.863s-1.392-.59-1.76-1.527l-.934-2.371Z",
    transform: "translate(-904.827 -1223.414)",
    fill: "#0540ac"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M1224.771,1660.661l-.834-2.116.254-.039.832,2.115.247-.037.839.157.08.2-2.19.335-.078-.2.627-.383Z",
    transform: "translate(-912.616 -1236.665)",
    fill: "#0540ac"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M1244.31,1662.327l.249.63-3.252.5-.247-.626Z",
    transform: "translate(-925.395 -1239.514)",
    fill: "#0540ac"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M1237.228,1644.862l-.425.065-1.7-4.324-.261.042-.221-1.84,1.178,1.691-.268.043Z",
    transform: "translate(-920.594 -1221.974)",
    fill: "#0540ac"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M1243.047,1643.964l-.426.065-1.7-4.32-.26.038-.22-1.837,1.175,1.691-.267.042Z",
    transform: "translate(-924.932 -1221.307)",
    fill: "#0540ac"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M1187.564,1640.432l4.335-.667,3.294,8.372-4.338.667Zm4.306-.431-4.109.629,3.124,7.939,4.107-.631Z",
    transform: "translate(-885.506 -1222.69)",
    fill: "#0540ac"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M1207.882,1637.3l4.338-.665,3.3,8.372-4.335.667Zm4.311-.43-4.106.635,3.122,7.937,4.107-.633Z",
    transform: "translate(-900.656 -1220.356)",
    fill: "#0540ac"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M1227.743,1634.248l4.338-.668,3.294,8.372-4.335.667Zm4.309-.432-4.108.632,3.125,7.935,4.106-.631Z",
    transform: "translate(-915.466 -1218.078)",
    fill: "#0540ac"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M1058.8,1424.353l-44.385,6.276-12.518-36.2,44.665-6.276Z",
    transform: "translate(-747.063 -1035.077)",
    fill: "#d9e8f9"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M1047.379,1323.391l-44.386,6.276,37.765-22.092,44.385-6.276Z",
    transform: "translate(-747.881 -970.313)",
    fill: "#fff"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M1177.5,1323.391l12.239,36.2,37.767-22.089-12.242-36.2Z",
    transform: "translate(-878.001 -970.313)",
    fill: "#c6dcf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(274.775 333.783)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    clipPath: "url(#clip-path-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M1118.074,1312.994l4.939-.7-37.767,22.091-4.942.7Z",
    transform: "translate(-1080.303 -1312.298)",
    fill: "#438be3"
  }))))), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M1085.121,1411.757l-4.061-12.011,4.734-.664,4.147,12Z",
    transform: "translate(-806.091 -1043.225)",
    fill: "#c6dcf7"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M1143.723,1500.272l-.087-.218.152-.025.087.222a2.561,2.561,0,0,1,1.973,1.087.378.378,0,0,0-.267-.09c-.158.026-.224.206-.178.434-.129-.214-.323-.359-.48-.334s-.225.208-.178.437c-.126-.215-.324-.359-.479-.334s-.225.207-.176.436c-.127-.215-.326-.359-.481-.333s-.222.205-.175.435c-.13-.215-.326-.359-.483-.335a.211.211,0,0,0-.169.159c.007-.808.341-1.406.941-1.54",
    transform: "translate(-852.114 -1118.496)",
    fill: "#0540ac"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M1150.529,1510.81l-.153.023-1.689-4.3.152-.026Z",
    transform: "translate(-856.517 -1123.329)",
    fill: "#0540ac"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M1156.391,1524.314c.2-.029.264-.31.141-.623l.154-.023c.173.444.084.84-.2.883s-.658-.282-.833-.722l.153-.022c.119.31.386.539.588.507",
    transform: "translate(-861.709 -1136.123)",
    fill: "#0540ac"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M1164.656,1496.289l.932,2.371c.368.935.177,1.769-.427,1.861s-1.394-.587-1.76-1.526l-.935-2.372Z",
    transform: "translate(-866.792 -1115.707)",
    fill: "#0540ac"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M1173.771,1516.2l-.832-2.115.253-.04.832,2.117.243-.036.841.153.077.2-2.186.337-.078-.2.624-.382Z",
    transform: "translate(-874.588 -1128.948)",
    fill: "#0540ac"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M1193.317,1517.877l.246.629-3.252.5-.244-.628Z",
    transform: "translate(-887.372 -1131.805)",
    fill: "#0540ac"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M1186.223,1500.41l-.428.065-1.7-4.324-.261.042-.224-1.838,1.18,1.69-.269.044Z",
    transform: "translate(-882.559 -1114.266)",
    fill: "#0540ac"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M1192.04,1499.516l-.425.067-1.7-4.32-.263.04-.22-1.836,1.176,1.687-.266.045Z",
    transform: "translate(-886.899 -1113.603)",
    fill: "#0540ac"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M1136.551,1495.973l4.337-.668,3.294,8.372-4.335.669Zm4.309-.43-4.108.628,3.123,7.939,4.108-.632Z",
    transform: "translate(-847.468 -1114.974)",
    fill: "#0540ac"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M1156.886,1492.849l4.338-.665,3.295,8.369-4.338.67Zm4.309-.431-4.107.633,3.121,7.938,4.108-.634Z",
    transform: "translate(-862.631 -1112.647)",
    fill: "#0540ac"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M1176.747,1489.793l4.336-.669,3.294,8.371-4.337.67Zm4.307-.432-4.107.633,3.123,7.935,4.108-.633Z",
    transform: "translate(-877.44 -1110.365)",
    fill: "#0540ac"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M1022.8,1113.479l-11.272-3.756s-2.481,1.3-1.211,3.34l13.783,4.658Z",
    transform: "translate(-753.069 -827.465)",
    fill: "#412999"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M1062.921,1112.561s-3.79,3.363-3.968,4.905-1.882,3.653-3.146,3.653-1.457-5.195-.646-8.338,7.76-.6,7.76-.219",
    transform: "translate(-786.417 -828.589)",
    fill: "#ffcda8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupply);
export default __webpack_public_path__ + "static/media/supply.dabb2f06b54275de7db6d46eb1d213e5.svg";
export { ForwardRef as ReactComponent };